/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('BaseAPIUrlTeamA');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signup(body: SignupDto | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignup(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSignup(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }
}

@Injectable()
export class AssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    isAssetExist(assetId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Asset/IsAssetExist?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAssetExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAssetExist(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsAssetExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAsset(body: CreateAssetDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/CreateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAsset(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAsset(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssetStatus(body: UpdateAssetStatusDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/UpdateAssetStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetStatus(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssetStatus(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssetTitle(body: UpdateAssetTitleDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/UpdateAssetTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetTitle(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssetTitle(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssetPublishStatus(body: UpdateAssetPublishStatusDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/UpdateAssetPublishStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetPublishStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetPublishStatus(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssetPublishStatus(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssetBusinessType(body: UpdateAssetBusinessTypeDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/UpdateAssetBusinessType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetBusinessType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetBusinessType(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssetBusinessType(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssetType(body: UpdateAssetTypeDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/UpdateAssetType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetType(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssetType(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertAssetFile(body: InsertAssetFileDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/InsertAssetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertAssetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertAssetFile(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processInsertAssetFile(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssetFileDescription(body: UpdateAssetFileDescriptionDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Asset/UpdateAssetFileDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetFileDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetFileDescription(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssetFileDescription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    deleteAssetFile(fileId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Asset/DeleteAssetFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssetFile(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAssetFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param uniqueName (optional) 
     * @param assetId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getAssetFilePathByUniqueName(uniqueName: string | undefined, assetId: number | undefined, type: FileType | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetFilePathByUniqueName?";
        if (uniqueName === null)
            throw new Error("The parameter 'uniqueName' cannot be null.");
        else if (uniqueName !== undefined)
            url_ += "uniqueName=" + encodeURIComponent("" + uniqueName) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetFilePathByUniqueName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetFilePathByUniqueName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetFilePathByUniqueName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getAssetFilesByAssetId(assetId: number | undefined, type: FileType | undefined): any{
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetFilesByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetFilesByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetFilesByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<InsertAssetFileResponseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsertAssetFileResponseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetFilesByAssetId(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InsertAssetFileResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsertAssetFileResponseDto[]>(<any>null);
    }

    /**
     * @param status (optional) 
     * @param isStatusDescOrder (optional) 
     * @param isTitleDescOrder (optional) 
     * @param isListedOnDescOrder (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllListing(status: AssetStatus | undefined, isStatusDescOrder: boolean | undefined, isTitleDescOrder: boolean | undefined, isListedOnDescOrder: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetAssetPagedResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAllListing?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isStatusDescOrder === null)
            throw new Error("The parameter 'isStatusDescOrder' cannot be null.");
        else if (isStatusDescOrder !== undefined)
            url_ += "IsStatusDescOrder=" + encodeURIComponent("" + isStatusDescOrder) + "&";
        if (isTitleDescOrder === null)
            throw new Error("The parameter 'isTitleDescOrder' cannot be null.");
        else if (isTitleDescOrder !== undefined)
            url_ += "IsTitleDescOrder=" + encodeURIComponent("" + isTitleDescOrder) + "&";
        if (isListedOnDescOrder === null)
            throw new Error("The parameter 'isListedOnDescOrder' cannot be null.");
        else if (isListedOnDescOrder !== undefined)
            url_ += "IsListedOnDescOrder=" + encodeURIComponent("" + isListedOnDescOrder) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllListing(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetPagedResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetPagedResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllListing(response: HttpResponseBase): Observable<GetAssetPagedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetPagedResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetPagedResponseDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetDetail(id: number | undefined): Observable<GetAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetDetail(response: HttpResponseBase): Observable<GetAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AssetDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto>(<any>null);
    }
}

@Injectable()
export class AssetAdditionalInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetAdditionalInfo(body: UpsertAssetAdditionalInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAdditionalInfo/UpsertAssetAdditionalInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetAdditionalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetAdditionalInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetAdditionalInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAdditionalInfoByAssetId(assetId: number | undefined): Observable<GetAssetAdditionalInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAdditionalInfo/GetAdditionalInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetAdditionalInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetAdditionalInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdditionalInfoByAssetId(response: HttpResponseBase): Observable<GetAssetAdditionalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetAdditionalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetAdditionalInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdditionalInfo(id: number | undefined): Observable<GetAssetAdditionalInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAdditionalInfo/GetAdditionalInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetAdditionalInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetAdditionalInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdditionalInfo(response: HttpResponseBase): Observable<GetAssetAdditionalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetAdditionalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetAdditionalInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetAddressInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAddressInfo(body: UpsertAddressInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAddressInfo/UpsertAddressInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAddressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAddressInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAddressInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAddressInfoByAssetId(assetId: number | undefined): Observable<GetAssetAddressInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAddressInfo/GetAddressInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetAddressInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetAddressInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressInfoByAssetId(response: HttpResponseBase): Observable<GetAssetAddressInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetAddressInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetAddressInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetAssociationInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetAssociationInfo(body: UpsertAssetAssociationInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssociationInfo/UpsertAssetAssociationInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetAssociationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetAssociationInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetAssociationInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetAssociationInfoByAssetId(assetId: number | undefined): Observable<GetAssetAssociationInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssociationInfo/GetAssetAssociationInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetAssociationInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetAssociationInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetAssociationInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetAssociationInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetAssociationInfoByAssetId(response: HttpResponseBase): Observable<GetAssetAssociationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetAssociationInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetAssociationInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetAssociationInfo(id: number | undefined): Observable<GetAssetAssociationInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetAssociationInfo/GetAssetAssociationInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetAssociationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetAssociationInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetAssociationInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetAssociationInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetAssociationInfo(response: HttpResponseBase): Observable<GetAssetAssociationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetAssociationInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetAssociationInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetCommercialInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetCommercialInfo(body: UpsertAssetCommercialInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetCommercialInfo/UpsertAssetCommercialInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetCommercialInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetCommercialInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetCommercialInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetCommercialInfoByAssetId(assetId: number | undefined): Observable<GetAssetCommercialInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetCommercialInfo/GetAssetCommercialInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetCommercialInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetCommercialInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetCommercialInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetCommercialInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetCommercialInfoByAssetId(response: HttpResponseBase): Observable<GetAssetCommercialInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetCommercialInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetCommercialInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetCommercialInfo(id: number | undefined): Observable<GetAssetCommercialInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetCommercialInfo/GetAssetCommercialInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetCommercialInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetCommercialInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetCommercialInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetCommercialInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetCommercialInfo(response: HttpResponseBase): Observable<GetAssetCommercialInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetCommercialInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetCommercialInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetCompensationInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCompensationInfo(body: UpsertCompensationInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetCompensationInfo/UpsertCompensationInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCompensationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCompensationInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertCompensationInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getCompensationInfoByAssetId(assetId: number | undefined): Observable<GetCompensationInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetCompensationInfo/GetCompensationInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompensationInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompensationInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetCompensationInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCompensationInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompensationInfoByAssetId(response: HttpResponseBase): Observable<GetCompensationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompensationInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompensationInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompensationInfo(id: number | undefined): Observable<GetCompensationInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetCompensationInfo/GetCompensationInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompensationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompensationInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetCompensationInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCompensationInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompensationInfo(response: HttpResponseBase): Observable<GetCompensationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompensationInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompensationInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetContractInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertContractInfo(body: UpsertContractInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetContractInfo/UpsertContractInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertContractInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertContractInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertContractInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getContractInfoByAssetId(assetId: number | undefined): Observable<GetContractInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetContractInfo/GetContractInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetContractInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContractInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractInfoByAssetId(response: HttpResponseBase): Observable<GetContractInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContractInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContractInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContractInfo(id: number | undefined): Observable<GetContractInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetContractInfo/GetContractInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetContractInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContractInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractInfo(response: HttpResponseBase): Observable<GetContractInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContractInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContractInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetInteriorExteriorFeatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetInteriorExteriorFeature(body: UpsertAssetInteriorExteriorFeatureDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetInteriorExteriorFeature/UpsertAssetInteriorExteriorFeature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetInteriorExteriorFeature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetInteriorExteriorFeature(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetInteriorExteriorFeature(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetInteriorExteriorFeatureByAssetId(assetId: number | undefined): Observable<GetAssetInteriorExteriorFeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetInteriorExteriorFeature/GetAssetInteriorExteriorFeatureByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetInteriorExteriorFeatureByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetInteriorExteriorFeatureByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetInteriorExteriorFeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetInteriorExteriorFeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetInteriorExteriorFeatureByAssetId(response: HttpResponseBase): Observable<GetAssetInteriorExteriorFeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetInteriorExteriorFeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetInteriorExteriorFeatureDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetInteriorExteriorFeature(id: number | undefined): Observable<GetAssetInteriorExteriorFeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetInteriorExteriorFeature/GetAssetInteriorExteriorFeature?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetInteriorExteriorFeature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetInteriorExteriorFeature(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetInteriorExteriorFeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetInteriorExteriorFeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetInteriorExteriorFeature(response: HttpResponseBase): Observable<GetAssetInteriorExteriorFeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetInteriorExteriorFeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetInteriorExteriorFeatureDto>(<any>null);
    }
}

@Injectable()
export class AssetLandRecordInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertLandRecordInfo(body: UpsertLandRecordInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetLandRecordInfo/UpsertLandRecordInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertLandRecordInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertLandRecordInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertLandRecordInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getLandRecordInfoByAssetId(assetId: number | undefined): Observable<GetLandRecordInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetLandRecordInfo/GetLandRecordInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLandRecordInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLandRecordInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetLandRecordInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLandRecordInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLandRecordInfoByAssetId(response: HttpResponseBase): Observable<GetLandRecordInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLandRecordInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLandRecordInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetLeaseInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetLeaseInfo(body: UpsertAssetLeaseInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetLeaseInfo/UpsertAssetLeaseInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetLeaseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetLeaseInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetLeaseInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetLeaseInfo(id: number | undefined): Observable<GetAssetLeaseInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetLeaseInfo/GetAssetLeaseInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetLeaseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetLeaseInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetLeaseInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetLeaseInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetLeaseInfo(response: HttpResponseBase): Observable<GetAssetLeaseInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetLeaseInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetLeaseInfoDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetLeaseInfoByAssetId(assetId: number | undefined): Observable<GetAssetLeaseInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetLeaseInfo/GetAssetLeaseInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetLeaseInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetLeaseInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetLeaseInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetLeaseInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetLeaseInfoByAssetId(response: HttpResponseBase): Observable<GetAssetLeaseInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetLeaseInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetLeaseInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetOpenHouseInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertOpenHouseInfo(body: UpsertAssetOpenHouseSummaryDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetOpenHouseInfo/UpsertOpenHouseInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertOpenHouseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOpenHouseInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertOpenHouseInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetOpenHouseSummaryByAssetId(assetId: number | undefined): Observable<GetAssetOpenHouseSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetOpenHouseInfo/GetAssetOpenHouseSummaryByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetOpenHouseSummaryByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetOpenHouseSummaryByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetOpenHouseSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetOpenHouseSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetOpenHouseSummaryByAssetId(response: HttpResponseBase): Observable<GetAssetOpenHouseSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetOpenHouseSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetOpenHouseSummaryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetOpenHouseSummary(id: number | undefined): Observable<GetAssetOpenHouseSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetOpenHouseInfo/GetAssetOpenHouseSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetOpenHouseSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetOpenHouseSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetOpenHouseSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetOpenHouseSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetOpenHouseSummary(response: HttpResponseBase): Observable<GetAssetOpenHouseSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetOpenHouseSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetOpenHouseSummaryDto>(<any>null);
    }
}

@Injectable()
export class AssetPhotoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetPhotoInfo(body: UpsertAssetPhotoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetPhoto/UpsertAssetPhotoInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetPhotoInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetPhotoInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetPhotoInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetPhotoByAssetId(assetId: number | undefined): Observable<GetAssetPhotoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetPhoto/GetAssetPhotoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetPhotoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetPhotoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetPhotoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetPhotoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetPhotoByAssetId(response: HttpResponseBase): Observable<GetAssetPhotoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetPhotoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetPhotoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetPhoto(id: number | undefined): Observable<GetAssetPhotoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetPhoto/GetAssetPhoto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetPhoto(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetPhotoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetPhotoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetPhoto(response: HttpResponseBase): Observable<GetAssetPhotoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetPhotoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetPhotoDto>(<any>null);
    }
}

@Injectable()
export class AssetRemarksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetRemarks(body: UpsertAssetRemarksDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetRemarks/UpsertAssetRemarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetRemarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetRemarks(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetRemarks(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetRemarksByAssetId(assetId: number | undefined): Observable<GetAssetRemarksDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetRemarks/GetAssetRemarksByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRemarksByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRemarksByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetRemarksDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetRemarksDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetRemarksByAssetId(response: HttpResponseBase): Observable<GetAssetRemarksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetRemarksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetRemarksDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetRemarks(id: number | undefined): Observable<GetAssetRemarksDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetRemarks/GetAssetRemarks?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRemarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRemarks(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetRemarksDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetRemarksDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetRemarks(response: HttpResponseBase): Observable<GetAssetRemarksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetRemarksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetRemarksDto>(<any>null);
    }
}

@Injectable()
export class AssetRoomInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertRoomInfo(body: UpsertAssetRoomInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetRoomInfo/UpsertRoomInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRoomInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRoomInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertRoomInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetRoomInfoByAssetId(assetId: number | undefined): Observable<GetAssetRoomInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetRoomInfo/GetAssetRoomInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRoomInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRoomInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetRoomInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetRoomInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetRoomInfoByAssetId(response: HttpResponseBase): Observable<GetAssetRoomInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetRoomInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetRoomInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetRoomInfo(id: number | undefined): Observable<GetAssetRoomInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetRoomInfo/GetAssetRoomInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRoomInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRoomInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetRoomInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetRoomInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetRoomInfo(response: HttpResponseBase): Observable<GetAssetRoomInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetRoomInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetRoomInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetSchoolInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetSchoolInfo(body: UpsertAssetSchoolInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetSchoolInfo/UpsertAssetSchoolInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetSchoolInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetSchoolInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetSchoolInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetSchoolInfoByAssetId(assetId: number | undefined): Observable<GetAssetSchoolInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetSchoolInfo/GetAssetSchoolInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetSchoolInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetSchoolInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetSchoolInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetSchoolInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetSchoolInfoByAssetId(response: HttpResponseBase): Observable<GetAssetSchoolInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetSchoolInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetSchoolInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetSchoolInfo(id: number | undefined): Observable<GetAssetSchoolInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetSchoolInfo/GetAssetSchoolInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetSchoolInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetSchoolInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetSchoolInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetSchoolInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetSchoolInfo(response: HttpResponseBase): Observable<GetAssetSchoolInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetSchoolInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetSchoolInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetShowingAvailabilityScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetShowingAvailabilitySchedule(body: UpsertAssetShowingAvailabilityScheduleDto[] | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingAvailabilitySchedule/UpsertAssetShowingAvailabilitySchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetShowingAvailabilitySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetShowingAvailabilitySchedule(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetShowingAvailabilitySchedule(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetShowingAvailabilityScheduleByAssetId(assetId: number | undefined):any {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingAvailabilitySchedule/GetAssetShowingAvailabilityScheduleByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetShowingAvailabilityScheduleByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetShowingAvailabilityScheduleByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetShowingAvailabilityScheduleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetShowingAvailabilityScheduleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetShowingAvailabilityScheduleByAssetId(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAssetShowingAvailabilityScheduleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetShowingAvailabilityScheduleDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetShowingAvailabilitySchedule(id: number | undefined): Observable<GetAssetShowingAvailabilityScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingAvailabilitySchedule/GetAssetShowingAvailabilitySchedule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetShowingAvailabilitySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetShowingAvailabilitySchedule(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetShowingAvailabilityScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetShowingAvailabilityScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetShowingAvailabilitySchedule(response: HttpResponseBase): Observable<GetAssetShowingAvailabilityScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetShowingAvailabilityScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetShowingAvailabilityScheduleDto>(<any>null);
    }
}

@Injectable()
export class AssetShowingContactInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetShowingContactInfo(body: UpsertAssetShowingContactDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingContactInfo/UpsertAssetShowingContactInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetShowingContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetShowingContactInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetShowingContactInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetShowingContactSummaryByAssetId(assetId: number | undefined): Observable<GetAssetShowingContactSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingContactInfo/GetAssetShowingContactSummaryByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetShowingContactSummaryByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetShowingContactSummaryByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetShowingContactSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetShowingContactSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetShowingContactSummaryByAssetId(response: HttpResponseBase): Observable<GetAssetShowingContactSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetShowingContactSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetShowingContactSummaryDto>(<any>null);
    }
}

@Injectable()
export class AssetShowingSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetShowingSetting(body: UpsertAssetShowingSettingDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingSetting/UpsertAssetShowingSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetShowingSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetShowingSetting(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetShowingSetting(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetShowingSettingsByAssetId(assetId: number | undefined): Observable<GetAssetShowingSettingSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetShowingSetting/GetAssetShowingSettingsByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetShowingSettingsByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetShowingSettingsByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetShowingSettingSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetShowingSettingSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetShowingSettingsByAssetId(response: HttpResponseBase): Observable<GetAssetShowingSettingSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetShowingSettingSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetShowingSettingSummaryDto>(<any>null);
    }
}

@Injectable()
export class AssetSoldInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetSoldInfo(body: UpsertAssetSoldInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetSoldInfo/UpsertAssetSoldInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetSoldInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetSoldInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetSoldInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetSoldInfo(id: number | undefined): Observable<GetAssetSoldInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetSoldInfo/GetAssetSoldInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetSoldInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetSoldInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetSoldInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetSoldInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetSoldInfo(response: HttpResponseBase): Observable<GetAssetSoldInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetSoldInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetSoldInfoDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetSoldInfoByAssetId(assetId: number | undefined): Observable<GetAssetSoldInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetSoldInfo/GetAssetSoldInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetSoldInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetSoldInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetSoldInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetSoldInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetSoldInfoByAssetId(response: HttpResponseBase): Observable<GetAssetSoldInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetSoldInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetSoldInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetStructuralInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertStructuralInfo(body: UpsertStructuralInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetStructuralInfo/UpsertStructuralInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertStructuralInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertStructuralInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertStructuralInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStructuralInfo(id: number | undefined): Observable<GetStructuralInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetStructuralInfo/GetStructuralInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructuralInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructuralInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetStructuralInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStructuralInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStructuralInfo(response: HttpResponseBase): Observable<GetStructuralInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStructuralInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStructuralInfoDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getStructuralInfoByAssetId(assetId: number | undefined): Observable<GetStructuralInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetStructuralInfo/GetStructuralInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructuralInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructuralInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetStructuralInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStructuralInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStructuralInfoByAssetId(response: HttpResponseBase): Observable<GetStructuralInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStructuralInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStructuralInfoDto>(<any>null);
    }
}

@Injectable()
export class AssetUnitInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetUnitInfo(body: UpsertAssetUnitInfoDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetUnitInfo/UpsertAssetUnitInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetUnitInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetUnitInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetUnitInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetUnitInfoForDropDown(assetId: number | undefined): any{
        let url_ = this.baseUrl + "/api/services/app/AssetUnitInfo/GetAssetUnitInfoForDropDown?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetUnitInfoForDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetUnitInfoForDropDown(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetUnitInfoForDropDownDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetUnitInfoForDropDownDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetUnitInfoForDropDown(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAssetUnitInfoForDropDownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetUnitInfoForDropDownDto[]>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetUnitInfoSummaryByAssetId(assetId: number | undefined): Observable<GetAssetUnitInfoSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetUnitInfo/GetAssetUnitInfoSummaryByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetUnitInfoSummaryByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetUnitInfoSummaryByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetUnitInfoSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetUnitInfoSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetUnitInfoSummaryByAssetId(response: HttpResponseBase): Observable<GetAssetUnitInfoSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetUnitInfoSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetUnitInfoSummaryDto>(<any>null);
    }
}

@Injectable()
export class AssetUtilityInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetUtilityInfo(body: UpsertAssetUtilityDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetUtilityInfo/UpsertAssetUtilityInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetUtilityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetUtilityInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetUtilityInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetUtilityInfo(id: number | undefined): Observable<GetAssetUtilityDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetUtilityInfo/GetAssetUtilityInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetUtilityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetUtilityInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetUtilityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetUtilityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetUtilityInfo(response: HttpResponseBase): Observable<GetAssetUtilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetUtilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetUtilityDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetUtilityInfoByAssetId(assetId: number | undefined): Observable<GetAssetUtilityDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetUtilityInfo/GetAssetUtilityInfoByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetUtilityInfoByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetUtilityInfoByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetUtilityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetUtilityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetUtilityInfoByAssetId(response: HttpResponseBase): Observable<GetAssetUtilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetUtilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetUtilityDto>(<any>null);
    }
}

@Injectable()
export class AssetVirtualTourServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAssetVirtualTourInfo(body: UpsertAssetVirtualTourDto | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetVirtualTour/UpsertAssetVirtualTourInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAssetVirtualTourInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAssetVirtualTourInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertAssetVirtualTourInfo(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetVirtualTourByAssetId(assetId: number | undefined): Observable<GetAssetVirtualTourDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetVirtualTour/GetAssetVirtualTourByAssetId?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetVirtualTourByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetVirtualTourByAssetId(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetVirtualTourDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetVirtualTourDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetVirtualTourByAssetId(response: HttpResponseBase): Observable<GetAssetVirtualTourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetVirtualTourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetVirtualTourDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetVirtualTour(id: number | undefined): Observable<GetAssetVirtualTourDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetVirtualTour/GetAssetVirtualTour?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetVirtualTour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetVirtualTour(<any>response_);
                } catch (e) {
                    return <Observable<GetAssetVirtualTourDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAssetVirtualTourDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetVirtualTour(response: HttpResponseBase): Observable<GetAssetVirtualTourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetVirtualTourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetVirtualTourDto>(<any>null);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMyBusiness(): Observable<GetMyBusinessResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetMyBusiness";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyBusiness(<any>response_);
                } catch (e) {
                    return <Observable<GetMyBusinessResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyBusinessResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyBusiness(response: HttpResponseBase): Observable<GetMyBusinessResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyBusinessResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyBusinessResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    marketPulseSearch(body: MarketPulseDto | undefined): Observable<MarketPulseResponceDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/MarketPulseSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarketPulseSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketPulseSearch(<any>response_);
                } catch (e) {
                    return <Observable<MarketPulseResponceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MarketPulseResponceDto>><any>_observableThrow(response_);
        }));
    }

    protected processMarketPulseSearch(response: HttpResponseBase): Observable<MarketPulseResponceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketPulseResponceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarketPulseResponceDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMarketPulseHistory():  any{
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetMarketPulseHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarketPulseHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarketPulseHistory(<any>response_);
                } catch (e) {
                    return <Observable<GetMarketPulseHistoryResponseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMarketPulseHistoryResponseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMarketPulseHistory(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetMarketPulseHistoryResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMarketPulseHistoryResponseDto[]>(<any>null);
    }
}

@Injectable()
export class FeedbackServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FeedbackTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FeedbackTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackTemplateDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: FeedbackTemplateRequestDto | undefined): Observable<FeedbackTemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetAll?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackTemplateDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackTemplateDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FeedbackTemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackTemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackTemplateDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFeedbackTemplateDto | undefined): Observable<FeedbackTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FeedbackTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackTemplateDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FeedbackTemplateDto | undefined): Observable<FeedbackTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FeedbackTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackTemplateDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param uniqueName (optional) 
     * @param assetId (optional) 
     * @param type (optional) 
     * @return Success
     */
    downloadAssetFileByUniqueName(uniqueName: string | undefined, assetId: number | undefined, type: FileType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Files/DownloadAssetFileByUniqueName?";
        if (uniqueName === null)
            throw new Error("The parameter 'uniqueName' cannot be null.");
        else if (uniqueName !== undefined)
            url_ += "uniqueName=" + encodeURIComponent("" + uniqueName) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAssetFileByUniqueName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAssetFileByUniqueName(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadAssetFileByUniqueName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fileName (optional) 
     * @param description (optional) 
     * @param assetId (optional) 
     * @param type (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadSingleAssetFile(fileName: string | undefined, description: string | undefined, assetId: number | undefined, type: FileType | undefined, file: FileParameter | undefined): Observable<UpsertAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Files/UploadSingleAssetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (assetId === null || assetId === undefined)
            throw new Error("The parameter 'assetId' cannot be null.");
        else
            content_.append("AssetId", assetId.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSingleAssetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSingleAssetFile(<any>response_);
                } catch (e) {
                    return <Observable<UpsertAssetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertAssetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadSingleAssetFile(response: HttpResponseBase): Observable<UpsertAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertAssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertAssetDto>(<any>null);
    }
}

@Injectable()
export class MasterDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAssetTypes(): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetAssetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetTypes(<any>response_);
                } catch (e) {
                    return <Observable<AssetTypeLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetTypeLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetTypes(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetTypeLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetTypeLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCountries():any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<CountryLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CountryLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRegions():  any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(<any>response_);
                } catch (e) {
                    return <Observable<RegionLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegions(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RegionLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionLookupDto[]>(<any>null);
    }

    /**
     * @param country (optional) 
     * @return Success
     */
    getRegionsByCountry(country: string | undefined):any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetRegionsByCountry?";
        if (country === null)
            throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionsByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionsByCountry(<any>response_);
                } catch (e) {
                    return <Observable<RegionLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionsByCountry(response: HttpResponseBase):any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RegionLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionLookupDto[]>(<any>null);
    }

    /**
     * @param region (optional) 
     * @return Success
     */
    getDistrictsByRegion(region: string | undefined): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetDistrictsByRegion?";
        if (region === null)
            throw new Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistrictsByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistrictsByRegion(<any>response_);
                } catch (e) {
                    return <Observable<DistrictLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistrictLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDistrictsByRegion(response: HttpResponseBase):  any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DistrictLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DistrictLookupDto[]>(<any>null);
    }

    /**
     * @param district (optional) 
     * @return Success
     */
    getMunicipalitiesByDistrict(district: string | undefined):  any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetMunicipalitiesByDistrict?";
        if (district === null)
            throw new Error("The parameter 'district' cannot be null.");
        else if (district !== undefined)
            url_ += "district=" + encodeURIComponent("" + district) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMunicipalitiesByDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMunicipalitiesByDistrict(<any>response_);
                } catch (e) {
                    return <Observable<MunicipalityLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MunicipalityLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMunicipalitiesByDistrict(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MunicipalityLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMunicipalities():  any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetMunicipalities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMunicipalities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMunicipalities(<any>response_);
                } catch (e) {
                    return <Observable<MunicipalityLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MunicipalityLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMunicipalities(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MunicipalityLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityLookupDto[]>(<any>null);
    }

    /**
     * @param municipality (optional) 
     * @return Success
     */
    getParishesByMunicipality(municipality: string | undefined): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetParishesByMunicipality?";
        if (municipality === null)
            throw new Error("The parameter 'municipality' cannot be null.");
        else if (municipality !== undefined)
            url_ += "municipality=" + encodeURIComponent("" + municipality) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParishesByMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParishesByMunicipality(<any>response_);
                } catch (e) {
                    return <Observable<ParishLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ParishLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetParishesByMunicipality(response: HttpResponseBase):any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParishLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParishLookupDto[]>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getStructuralFeaturesByType(type: StructureLookupType | undefined): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetStructuralFeaturesByType?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructuralFeaturesByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructuralFeaturesByType(<any>response_);
                } catch (e) {
                    return <Observable<StructuralLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StructuralLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStructuralFeaturesByType(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StructuralLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StructuralLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRoomFeatures(): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetRoomFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomFeatures(<any>response_);
                } catch (e) {
                    return <Observable<RoomFeatureLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoomFeatureLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoomFeatures(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RoomFeatureLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomFeatureLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRoomTypes(): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetRoomTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomTypes(<any>response_);
                } catch (e) {
                    return <Observable<RoomTypeLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoomTypeLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoomTypes(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RoomTypeLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoomTypeLookupDto[]>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getInteriorExteriorFeaturesByType(type: InteriorExteriorFeatureLookupType | undefined): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetInteriorExteriorFeaturesByType?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInteriorExteriorFeaturesByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInteriorExteriorFeaturesByType(<any>response_);
                } catch (e) {
                    return <Observable<InteriorExteriorFeatureLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InteriorExteriorFeatureLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInteriorExteriorFeaturesByType(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InteriorExteriorFeatureLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InteriorExteriorFeatureLookupDto[]>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getLaundryRoomTypeByType(type: InteriorExteriorFeatureLookupType | undefined): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetLaundryRoomTypeByType?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaundryRoomTypeByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaundryRoomTypeByType(<any>response_);
                } catch (e) {
                    return <Observable<InteriorExteriorFeatureLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InteriorExteriorFeatureLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLaundryRoomTypeByType(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InteriorExteriorFeatureLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InteriorExteriorFeatureLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getApartmentAccessTypes():any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetApartmentAccessTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApartmentAccessTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApartmentAccessTypes(<any>response_);
                } catch (e) {
                    return <Observable<ApartmentAccessTypesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApartmentAccessTypesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApartmentAccessTypes(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApartmentAccessTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApartmentAccessTypesDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLaundryRoomTypes(): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetLaundryRoomTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaundryRoomTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaundryRoomTypes(<any>response_);
                } catch (e) {
                    return <Observable<LaundryRoomTypesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LaundryRoomTypesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLaundryRoomTypes(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LaundryRoomTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LaundryRoomTypesDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getHOAAmenitiesTypes():any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetHOAAmenitiesTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHOAAmenitiesTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHOAAmenitiesTypes(<any>response_);
                } catch (e) {
                    return <Observable<HOAAmenitiesTypesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HOAAmenitiesTypesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHOAAmenitiesTypes(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HOAAmenitiesTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HOAAmenitiesTypesDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getHOARestrictionTypes(): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetHOARestrictionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHOARestrictionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHOARestrictionTypes(<any>response_);
                } catch (e) {
                    return <Observable<HOARestrictionTypesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HOARestrictionTypesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHOARestrictionTypes(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HOARestrictionTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HOARestrictionTypesDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAssociationFeeProvideTypes():any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetAssociationFeeProvideTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssociationFeeProvideTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssociationFeeProvideTypes(<any>response_);
                } catch (e) {
                    return <Observable<AssociationFeeProvideTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssociationFeeProvideTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssociationFeeProvideTypes(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssociationFeeProvideTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssociationFeeProvideTypeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitFeatures():any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetUnitFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnitFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnitFeatures(<any>response_);
                } catch (e) {
                    return <Observable<UnitFeatureLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UnitFeatureLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnitFeatures(response: HttpResponseBase):any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UnitFeatureLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnitFeatureLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRoadFrontageTypes(): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetRoadFrontageTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoadFrontageTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoadFrontageTypes(<any>response_);
                } catch (e) {
                    return <Observable<RoadFrontageLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoadFrontageLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoadFrontageTypes(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RoadFrontageLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoadFrontageLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDocumentTypes(): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetDocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentTypeLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypeLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCommercialFeatures(): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetCommercialFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommercialFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommercialFeatures(<any>response_);
                } catch (e) {
                    return <Observable<CommercialFeatureLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommercialFeatureLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommercialFeatures(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CommercialFeatureLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommercialFeatureLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getResponsibilityLookups(): any{
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetResponsibilityLookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsibilityLookups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsibilityLookups(<any>response_);
                } catch (e) {
                    return <Observable<ResponsibilityLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponsibilityLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetResponsibilityLookups(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ResponsibilityLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponsibilityLookupDto[]>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getUtilityTypes(type: UtilityLookupType | undefined): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetUtilityTypes?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityTypes(<any>response_);
                } catch (e) {
                    return <Observable<UtilitiesFeatureLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UtilitiesFeatureLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUtilityTypes(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UtilitiesFeatureLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilitiesFeatureLookupDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLandlordRequirementsTypes(): any {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetLandlordRequirementsTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLandlordRequirementsTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLandlordRequirementsTypes(<any>response_);
                } catch (e) {
                    return <Observable<LandlordRequirementsTypeLookupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LandlordRequirementsTypeLookupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLandlordRequirementsTypes(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LandlordRequirementsTypeLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LandlordRequirementsTypeLookupDto[]>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleListDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleListDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class SearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchProperty(body: SearchDto | undefined): any {
        let url_ = this.baseUrl + "/api/services/app/Search/SearchProperty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProperty(<any>response_);
                } catch (e) {
                    return <Observable<SearchResponseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchResponseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearchProperty(response: HttpResponseBase): any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SearchResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchResponseDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSearchHistory():  any{
        let url_ = this.baseUrl + "/api/services/app/Search/GetSearchHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchHistory(<any>response_);
                } catch (e) {
                    return <Observable<GetSearchHistoryResponseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSearchHistoryResponseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchHistory(response: HttpResponseBase):any {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetSearchHistoryResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSearchHistoryResponseDto[]>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): any {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContact(body: CreateContactDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContact(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateContact(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class UsersContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserContactDto> {
        let url_ = this.baseUrl + "/api/services/app/UsersContact/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserContactDto | undefined): Observable<UserContactDto> {
        let url_ = this.baseUrl + "/api/services/app/UsersContact/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    search(keyword: string | undefined):any {
        let url_ = this.baseUrl + "/api/services/app/UsersContact/Search?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<UserContactDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): any{
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserContactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: UserContactRequestDto | undefined): Observable<UserContactDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UsersContact/GetAll?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserContactDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserContactDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserContactDto | undefined): Observable<UserContactDto> {
        let url_ = this.baseUrl + "/api/services/app/UsersContact/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UsersContact/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export enum AcceptableFinancingType {
    None = <any>"None",
    Any = <any>"Any",
    BankLoan = <any>"BankLoan",
    Cash = <any>"Cash",
    DeveloperFinancing = <any>"DeveloperFinancing",
    Other = <any>"Other",
}

export class ApartmentAccessTypesDto implements IApartmentAccessTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IApartmentAccessTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ApartmentAccessTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApartmentAccessTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): ApartmentAccessTypesDto {
        const json = this.toJSON();
        let result = new ApartmentAccessTypesDto();
        result.init(json);
        return result;
    }
}

export interface IApartmentAccessTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export enum AreaType {
    None = <any>"None",
    District = <any>"District",
    Municipality = <any>"Municipality",
    Parish = <any>"Parish",
}

export class AssetAreaDto implements IAssetAreaDto {
    integralLandArea: number | undefined;
    privateGrossArea: number | undefined;
    dependentGrossArea: number | undefined;
    buildingDeploymentArea: number | undefined;
    buildingGrossArea: number | undefined;
    totalLandArea: number | undefined;

    constructor(data?: IAssetAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integralLandArea = _data["integralLandArea"];
            this.privateGrossArea = _data["privateGrossArea"];
            this.dependentGrossArea = _data["dependentGrossArea"];
            this.buildingDeploymentArea = _data["buildingDeploymentArea"];
            this.buildingGrossArea = _data["buildingGrossArea"];
            this.totalLandArea = _data["totalLandArea"];
        }
    }

    static fromJS(data: any): AssetAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integralLandArea"] = this.integralLandArea;
        data["privateGrossArea"] = this.privateGrossArea;
        data["dependentGrossArea"] = this.dependentGrossArea;
        data["buildingDeploymentArea"] = this.buildingDeploymentArea;
        data["buildingGrossArea"] = this.buildingGrossArea;
        data["totalLandArea"] = this.totalLandArea;
        return data; 
    }

    clone(): AssetAreaDto {
        const json = this.toJSON();
        let result = new AssetAreaDto();
        result.init(json);
        return result;
    }
}

export interface IAssetAreaDto {
    integralLandArea: number | undefined;
    privateGrossArea: number | undefined;
    dependentGrossArea: number | undefined;
    buildingDeploymentArea: number | undefined;
    buildingGrossArea: number | undefined;
    totalLandArea: number | undefined;
}

export class AssetConfrontationDto implements IAssetConfrontationDto {
    north: string | undefined;
    south: string | undefined;
    east: string | undefined;
    west: string | undefined;

    constructor(data?: IAssetConfrontationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.north = _data["north"];
            this.south = _data["south"];
            this.east = _data["east"];
            this.west = _data["west"];
        }
    }

    static fromJS(data: any): AssetConfrontationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetConfrontationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["north"] = this.north;
        data["south"] = this.south;
        data["east"] = this.east;
        data["west"] = this.west;
        return data; 
    }

    clone(): AssetConfrontationDto {
        const json = this.toJSON();
        let result = new AssetConfrontationDto();
        result.init(json);
        return result;
    }
}

export interface IAssetConfrontationDto {
    north: string | undefined;
    south: string | undefined;
    east: string | undefined;
    west: string | undefined;
}

export class AssetDescriptionDto implements IAssetDescriptionDto {
    allocation: string | undefined;
    description: string | undefined;
    typology: number | undefined;
    permilage: number | undefined;

    constructor(data?: IAssetDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocation = _data["allocation"];
            this.description = _data["description"];
            this.typology = _data["typology"];
            this.permilage = _data["permilage"];
        }
    }

    static fromJS(data: any): AssetDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocation"] = this.allocation;
        data["description"] = this.description;
        data["typology"] = this.typology;
        data["permilage"] = this.permilage;
        return data; 
    }

    clone(): AssetDescriptionDto {
        const json = this.toJSON();
        let result = new AssetDescriptionDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDescriptionDto {
    allocation: string | undefined;
    description: string | undefined;
    typology: number | undefined;
    permilage: number | undefined;
}

export class AssetDto implements IAssetDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    assetStatus: AssetStatus;
    correlationId: string | undefined;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    unpublishDate: moment.Moment | undefined;
    tenantId: number | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.systemId = _data["systemId"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.assetStatus = _data["assetStatus"];
            this.correlationId = _data["correlationId"];
            this.businessType = _data["businessType"];
            this.activationStartDate = _data["activationStartDate"] ? moment(_data["activationStartDate"].toString()) : <any>undefined;
            this.activationEndDate = _data["activationEndDate"] ? moment(_data["activationEndDate"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.unpublishDate = _data["unpublishDate"] ? moment(_data["unpublishDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["systemId"] = this.systemId;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["assetStatus"] = this.assetStatus;
        data["correlationId"] = this.correlationId;
        data["businessType"] = this.businessType;
        data["activationStartDate"] = this.activationStartDate ? this.activationStartDate.toISOString() : <any>undefined;
        data["activationEndDate"] = this.activationEndDate ? this.activationEndDate.toISOString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["unpublishDate"] = this.unpublishDate ? this.unpublishDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    assetStatus: AssetStatus;
    correlationId: string | undefined;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    unpublishDate: moment.Moment | undefined;
    tenantId: number | undefined;
}

export class AssetDtoPagedResultDto implements IAssetDtoPagedResultDto {
    items: AssetDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): AssetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDtoPagedResultDto {
    items: AssetDto[] | undefined;
    totalCount: number;
}

export class AssetEvaluationDto implements IAssetEvaluationDto {
    matrixEnrollmentYear: number | undefined;
    yearDetermined: number | undefined;
    currentIMIYear: number | undefined;
    modOfIMI: number | undefined;
    locationCoefficientType: string | undefined;
    currentEquityValue: number | undefined;
    xCoordinate: number | undefined;
    yCoordinate: number | undefined;
    otherTaxes: number | undefined;
    deliveryDate: moment.Moment | undefined;
    evaluationForm: string | undefined;
    evaluationDate: moment.Moment | undefined;

    constructor(data?: IAssetEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matrixEnrollmentYear = _data["matrixEnrollmentYear"];
            this.yearDetermined = _data["yearDetermined"];
            this.currentIMIYear = _data["currentIMIYear"];
            this.modOfIMI = _data["modOfIMI"];
            this.locationCoefficientType = _data["locationCoefficientType"];
            this.currentEquityValue = _data["currentEquityValue"];
            this.xCoordinate = _data["xCoordinate"];
            this.yCoordinate = _data["yCoordinate"];
            this.otherTaxes = _data["otherTaxes"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.evaluationForm = _data["evaluationForm"];
            this.evaluationDate = _data["evaluationDate"] ? moment(_data["evaluationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matrixEnrollmentYear"] = this.matrixEnrollmentYear;
        data["yearDetermined"] = this.yearDetermined;
        data["currentIMIYear"] = this.currentIMIYear;
        data["modOfIMI"] = this.modOfIMI;
        data["locationCoefficientType"] = this.locationCoefficientType;
        data["currentEquityValue"] = this.currentEquityValue;
        data["xCoordinate"] = this.xCoordinate;
        data["yCoordinate"] = this.yCoordinate;
        data["otherTaxes"] = this.otherTaxes;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["evaluationForm"] = this.evaluationForm;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): AssetEvaluationDto {
        const json = this.toJSON();
        let result = new AssetEvaluationDto();
        result.init(json);
        return result;
    }
}

export interface IAssetEvaluationDto {
    matrixEnrollmentYear: number | undefined;
    yearDetermined: number | undefined;
    currentIMIYear: number | undefined;
    modOfIMI: number | undefined;
    locationCoefficientType: string | undefined;
    currentEquityValue: number | undefined;
    xCoordinate: number | undefined;
    yCoordinate: number | undefined;
    otherTaxes: number | undefined;
    deliveryDate: moment.Moment | undefined;
    evaluationForm: string | undefined;
    evaluationDate: moment.Moment | undefined;
}

export enum AssetFormSteps {
    None = <any>"None",
    BasicAsset = <any>"BasicAsset",
    Parties = <any>"Parties",
    ContractInfo = <any>"ContractInfo",
    CompensationInfo = <any>"CompensationInfo",
    SoldInfo = <any>"SoldInfo",
    AddressInfo = <any>"AddressInfo",
    ContractInfoFile = <any>"ContractInfoFile",
    LandRecordInfo = <any>"LandRecordInfo",
    SchoolInfo = <any>"SchoolInfo",
    StructuralInfo = <any>"StructuralInfo",
    RoomsInfo = <any>"RoomsInfo",
    InteriorExteriorFeature = <any>"InteriorExteriorFeature",
    AssetAssociationInfo = <any>"AssetAssociationInfo",
    UnitInfo = <any>"UnitInfo",
    CommercialInfo = <any>"CommercialInfo",
    AssetUtility = <any>"AssetUtility",
    OpenHouse = <any>"OpenHouse",
    AssetShowing = <any>"AssetShowing",
    AssetRemarks = <any>"AssetRemarks",
    AssetAdditionalInfo = <any>"AssetAdditionalInfo",
    AssetLeaseInfo = <any>"AssetLeaseInfo",
    AssetShowingContact = <any>"AssetShowingContact",
    AssetShowingAvailability = <any>"AssetShowingAvailability",
    AssetPhoto = <any>"AssetPhoto",
    AssetVirtualTour = <any>"AssetVirtualTour",
}

export class AssetIdentificationDto implements IAssetIdentificationDto {
    matrixArticle: number | undefined;
    nip: number | undefined;
    underRegistrationNo: number | undefined;
    describedCRP: string | undefined;

    constructor(data?: IAssetIdentificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matrixArticle = _data["matrixArticle"];
            this.nip = _data["nip"];
            this.underRegistrationNo = _data["underRegistrationNo"];
            this.describedCRP = _data["describedCRP"];
        }
    }

    static fromJS(data: any): AssetIdentificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetIdentificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matrixArticle"] = this.matrixArticle;
        data["nip"] = this.nip;
        data["underRegistrationNo"] = this.underRegistrationNo;
        data["describedCRP"] = this.describedCRP;
        return data; 
    }

    clone(): AssetIdentificationDto {
        const json = this.toJSON();
        let result = new AssetIdentificationDto();
        result.init(json);
        return result;
    }
}

export interface IAssetIdentificationDto {
    matrixArticle: number | undefined;
    nip: number | undefined;
    underRegistrationNo: number | undefined;
    describedCRP: string | undefined;
}

export class AssetOpenHouseInfoDto implements IAssetOpenHouseInfoDto {
    link: string | undefined;
    description: string | undefined;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    date: moment.Moment | undefined;
    refreshmentType: RefreshmentType;
    openHouseType: OpenHouseType;

    constructor(data?: IAssetOpenHouseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            this.description = _data["description"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.refreshmentType = _data["refreshmentType"];
            this.openHouseType = _data["openHouseType"];
        }
    }

    static fromJS(data: any): AssetOpenHouseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetOpenHouseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["description"] = this.description;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["refreshmentType"] = this.refreshmentType;
        data["openHouseType"] = this.openHouseType;
        return data; 
    }

    clone(): AssetOpenHouseInfoDto {
        const json = this.toJSON();
        let result = new AssetOpenHouseInfoDto();
        result.init(json);
        return result;
    }
}

export interface IAssetOpenHouseInfoDto {
    link: string | undefined;
    description: string | undefined;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    date: moment.Moment | undefined;
    refreshmentType: RefreshmentType;
    openHouseType: OpenHouseType;
}

export class AssetRoomDto implements IAssetRoomDto {
    type: string | undefined;
    roomLevel: string | undefined;
    roomLength: number | undefined;
    roomWidth: number | undefined;
    features: string[] | undefined;

    constructor(data?: IAssetRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.roomLevel = _data["roomLevel"];
            this.roomLength = _data["roomLength"];
            this.roomWidth = _data["roomWidth"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(item);
            }
        }
    }

    static fromJS(data: any): AssetRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["roomLevel"] = this.roomLevel;
        data["roomLength"] = this.roomLength;
        data["roomWidth"] = this.roomWidth;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        return data; 
    }

    clone(): AssetRoomDto {
        const json = this.toJSON();
        let result = new AssetRoomDto();
        result.init(json);
        return result;
    }
}

export interface IAssetRoomDto {
    type: string | undefined;
    roomLevel: string | undefined;
    roomLength: number | undefined;
    roomWidth: number | undefined;
    features: string[] | undefined;
}

export class AssetShowingAccessInfoDto implements IAssetShowingAccessInfoDto {
    isSecureAccessEnabled: boolean | undefined;
    isListingAgentIsRequiedInShowing: boolean | undefined;
    hasAlarm: boolean | undefined;
    accessType: PropertyAccessType;
    accessCode: string | undefined;
    keyLocation: string | undefined;
    showingInstructions: string | undefined;
    alarmCode: string | undefined;
    alarmInstructions: string | undefined;

    constructor(data?: IAssetShowingAccessInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSecureAccessEnabled = _data["isSecureAccessEnabled"];
            this.isListingAgentIsRequiedInShowing = _data["isListingAgentIsRequiedInShowing"];
            this.hasAlarm = _data["hasAlarm"];
            this.accessType = _data["accessType"];
            this.accessCode = _data["accessCode"];
            this.keyLocation = _data["keyLocation"];
            this.showingInstructions = _data["showingInstructions"];
            this.alarmCode = _data["alarmCode"];
            this.alarmInstructions = _data["alarmInstructions"];
        }
    }

    static fromJS(data: any): AssetShowingAccessInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingAccessInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSecureAccessEnabled"] = this.isSecureAccessEnabled;
        data["isListingAgentIsRequiedInShowing"] = this.isListingAgentIsRequiedInShowing;
        data["hasAlarm"] = this.hasAlarm;
        data["accessType"] = this.accessType;
        data["accessCode"] = this.accessCode;
        data["keyLocation"] = this.keyLocation;
        data["showingInstructions"] = this.showingInstructions;
        data["alarmCode"] = this.alarmCode;
        data["alarmInstructions"] = this.alarmInstructions;
        return data; 
    }

    clone(): AssetShowingAccessInfoDto {
        const json = this.toJSON();
        let result = new AssetShowingAccessInfoDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingAccessInfoDto {
    isSecureAccessEnabled: boolean | undefined;
    isListingAgentIsRequiedInShowing: boolean | undefined;
    hasAlarm: boolean | undefined;
    accessType: PropertyAccessType;
    accessCode: string | undefined;
    keyLocation: string | undefined;
    showingInstructions: string | undefined;
    alarmCode: string | undefined;
    alarmInstructions: string | undefined;
}

export class AssetShowingAccessInfoResponseDto implements IAssetShowingAccessInfoResponseDto {
    id: number;
    isSecureAccessEnabled: boolean | undefined;
    isListingAgentIsRequiedInShowing: boolean | undefined;
    hasAlarm: boolean | undefined;
    accessType: string | undefined;
    accessCode: string | undefined;
    keyLocation: string | undefined;
    showingInstructions: string | undefined;
    alarmCode: string | undefined;
    alarmInstructions: string | undefined;

    constructor(data?: IAssetShowingAccessInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSecureAccessEnabled = _data["isSecureAccessEnabled"];
            this.isListingAgentIsRequiedInShowing = _data["isListingAgentIsRequiedInShowing"];
            this.hasAlarm = _data["hasAlarm"];
            this.accessType = _data["accessType"];
            this.accessCode = _data["accessCode"];
            this.keyLocation = _data["keyLocation"];
            this.showingInstructions = _data["showingInstructions"];
            this.alarmCode = _data["alarmCode"];
            this.alarmInstructions = _data["alarmInstructions"];
        }
    }

    static fromJS(data: any): AssetShowingAccessInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingAccessInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSecureAccessEnabled"] = this.isSecureAccessEnabled;
        data["isListingAgentIsRequiedInShowing"] = this.isListingAgentIsRequiedInShowing;
        data["hasAlarm"] = this.hasAlarm;
        data["accessType"] = this.accessType;
        data["accessCode"] = this.accessCode;
        data["keyLocation"] = this.keyLocation;
        data["showingInstructions"] = this.showingInstructions;
        data["alarmCode"] = this.alarmCode;
        data["alarmInstructions"] = this.alarmInstructions;
        return data; 
    }

    clone(): AssetShowingAccessInfoResponseDto {
        const json = this.toJSON();
        let result = new AssetShowingAccessInfoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingAccessInfoResponseDto {
    id: number;
    isSecureAccessEnabled: boolean | undefined;
    isListingAgentIsRequiedInShowing: boolean | undefined;
    hasAlarm: boolean | undefined;
    accessType: string | undefined;
    accessCode: string | undefined;
    keyLocation: string | undefined;
    showingInstructions: string | undefined;
    alarmCode: string | undefined;
    alarmInstructions: string | undefined;
}

export class AssetShowingAgentInstructionDto implements IAssetShowingAgentInstructionDto {
    shouldTurnOffLights: boolean | undefined;
    shouldBringAgentLicense: boolean | undefined;
    shouldLeaveBusinessCards: boolean | undefined;
    shouldRemoveShoes: boolean | undefined;
    shouldLockAllDoors: boolean | undefined;
    shouldKnockFirst: boolean | undefined;
    otherInstructions: string | undefined;
    noteForAgent: string | undefined;
    noteForStaff: string | undefined;

    constructor(data?: IAssetShowingAgentInstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldTurnOffLights = _data["shouldTurnOffLights"];
            this.shouldBringAgentLicense = _data["shouldBringAgentLicense"];
            this.shouldLeaveBusinessCards = _data["shouldLeaveBusinessCards"];
            this.shouldRemoveShoes = _data["shouldRemoveShoes"];
            this.shouldLockAllDoors = _data["shouldLockAllDoors"];
            this.shouldKnockFirst = _data["shouldKnockFirst"];
            this.otherInstructions = _data["otherInstructions"];
            this.noteForAgent = _data["noteForAgent"];
            this.noteForStaff = _data["noteForStaff"];
        }
    }

    static fromJS(data: any): AssetShowingAgentInstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingAgentInstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldTurnOffLights"] = this.shouldTurnOffLights;
        data["shouldBringAgentLicense"] = this.shouldBringAgentLicense;
        data["shouldLeaveBusinessCards"] = this.shouldLeaveBusinessCards;
        data["shouldRemoveShoes"] = this.shouldRemoveShoes;
        data["shouldLockAllDoors"] = this.shouldLockAllDoors;
        data["shouldKnockFirst"] = this.shouldKnockFirst;
        data["otherInstructions"] = this.otherInstructions;
        data["noteForAgent"] = this.noteForAgent;
        data["noteForStaff"] = this.noteForStaff;
        return data; 
    }

    clone(): AssetShowingAgentInstructionDto {
        const json = this.toJSON();
        let result = new AssetShowingAgentInstructionDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingAgentInstructionDto {
    shouldTurnOffLights: boolean | undefined;
    shouldBringAgentLicense: boolean | undefined;
    shouldLeaveBusinessCards: boolean | undefined;
    shouldRemoveShoes: boolean | undefined;
    shouldLockAllDoors: boolean | undefined;
    shouldKnockFirst: boolean | undefined;
    otherInstructions: string | undefined;
    noteForAgent: string | undefined;
    noteForStaff: string | undefined;
}

export class AssetShowingAgentInstructionResponseDto implements IAssetShowingAgentInstructionResponseDto {
    id: number;
    shouldTurnOffLights: boolean | undefined;
    shouldBringAgentLicense: boolean | undefined;
    shouldLeaveBusinessCards: boolean | undefined;
    shouldRemoveShoes: boolean | undefined;
    shouldLockAllDoors: boolean | undefined;
    shouldKnockFirst: boolean | undefined;
    otherInstructions: string | undefined;
    noteForAgent: string | undefined;
    noteForStaff: string | undefined;

    constructor(data?: IAssetShowingAgentInstructionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shouldTurnOffLights = _data["shouldTurnOffLights"];
            this.shouldBringAgentLicense = _data["shouldBringAgentLicense"];
            this.shouldLeaveBusinessCards = _data["shouldLeaveBusinessCards"];
            this.shouldRemoveShoes = _data["shouldRemoveShoes"];
            this.shouldLockAllDoors = _data["shouldLockAllDoors"];
            this.shouldKnockFirst = _data["shouldKnockFirst"];
            this.otherInstructions = _data["otherInstructions"];
            this.noteForAgent = _data["noteForAgent"];
            this.noteForStaff = _data["noteForStaff"];
        }
    }

    static fromJS(data: any): AssetShowingAgentInstructionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingAgentInstructionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shouldTurnOffLights"] = this.shouldTurnOffLights;
        data["shouldBringAgentLicense"] = this.shouldBringAgentLicense;
        data["shouldLeaveBusinessCards"] = this.shouldLeaveBusinessCards;
        data["shouldRemoveShoes"] = this.shouldRemoveShoes;
        data["shouldLockAllDoors"] = this.shouldLockAllDoors;
        data["shouldKnockFirst"] = this.shouldKnockFirst;
        data["otherInstructions"] = this.otherInstructions;
        data["noteForAgent"] = this.noteForAgent;
        data["noteForStaff"] = this.noteForStaff;
        return data; 
    }

    clone(): AssetShowingAgentInstructionResponseDto {
        const json = this.toJSON();
        let result = new AssetShowingAgentInstructionResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingAgentInstructionResponseDto {
    id: number;
    shouldTurnOffLights: boolean | undefined;
    shouldBringAgentLicense: boolean | undefined;
    shouldLeaveBusinessCards: boolean | undefined;
    shouldRemoveShoes: boolean | undefined;
    shouldLockAllDoors: boolean | undefined;
    shouldKnockFirst: boolean | undefined;
    otherInstructions: string | undefined;
    noteForAgent: string | undefined;
    noteForStaff: string | undefined;
}

export enum AssetShowingAvailabilityModeType {
    None = <any>"None",
    Availability = <any>"Availability",
    Restriction = <any>"Restriction",
}

export class AssetShowingContactDto implements IAssetShowingContactDto {
    occupantType: OccupantType[] | undefined;
    notificationType: NotificationType[] | undefined;
    requirementType: ContactRequirementType[] | undefined;
    isReceivedFeedbackToBeSent: boolean | undefined;
    isShowingAgentInfoToBeSent: boolean | undefined;
    userContactId: number | undefined;

    constructor(data?: IAssetShowingContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["occupantType"])) {
                this.occupantType = [] as any;
                for (let item of _data["occupantType"])
                    this.occupantType.push(item);
            }
            if (Array.isArray(_data["notificationType"])) {
                this.notificationType = [] as any;
                for (let item of _data["notificationType"])
                    this.notificationType.push(item);
            }
            if (Array.isArray(_data["requirementType"])) {
                this.requirementType = [] as any;
                for (let item of _data["requirementType"])
                    this.requirementType.push(item);
            }
            this.isReceivedFeedbackToBeSent = _data["isReceivedFeedbackToBeSent"];
            this.isShowingAgentInfoToBeSent = _data["isShowingAgentInfoToBeSent"];
            this.userContactId = _data["userContactId"];
        }
    }

    static fromJS(data: any): AssetShowingContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.occupantType)) {
            data["occupantType"] = [];
            for (let item of this.occupantType)
                data["occupantType"].push(item);
        }
        if (Array.isArray(this.notificationType)) {
            data["notificationType"] = [];
            for (let item of this.notificationType)
                data["notificationType"].push(item);
        }
        if (Array.isArray(this.requirementType)) {
            data["requirementType"] = [];
            for (let item of this.requirementType)
                data["requirementType"].push(item);
        }
        data["isReceivedFeedbackToBeSent"] = this.isReceivedFeedbackToBeSent;
        data["isShowingAgentInfoToBeSent"] = this.isShowingAgentInfoToBeSent;
        data["userContactId"] = this.userContactId;
        return data; 
    }

    clone(): AssetShowingContactDto {
        const json = this.toJSON();
        let result = new AssetShowingContactDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingContactDto {
    occupantType: OccupantType[] | undefined;
    notificationType: NotificationType[] | undefined;
    requirementType: ContactRequirementType[] | undefined;
    isReceivedFeedbackToBeSent: boolean | undefined;
    isShowingAgentInfoToBeSent: boolean | undefined;
    userContactId: number | undefined;
}

export class AssetShowingFeedbackDto implements IAssetShowingFeedbackDto {
    isShowingFeedbackAllowed: boolean | undefined;
    feedbackTemplate: string | undefined;

    constructor(data?: IAssetShowingFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isShowingFeedbackAllowed = _data["isShowingFeedbackAllowed"];
            this.feedbackTemplate = _data["feedbackTemplate"];
        }
    }

    static fromJS(data: any): AssetShowingFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isShowingFeedbackAllowed"] = this.isShowingFeedbackAllowed;
        data["feedbackTemplate"] = this.feedbackTemplate;
        return data; 
    }

    clone(): AssetShowingFeedbackDto {
        const json = this.toJSON();
        let result = new AssetShowingFeedbackDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingFeedbackDto {
    isShowingFeedbackAllowed: boolean | undefined;
    feedbackTemplate: string | undefined;
}

export class AssetShowingFeedbackResponseDto implements IAssetShowingFeedbackResponseDto {
    id: number;
    isShowingFeedbackAllowed: boolean | undefined;
    feedbackTemplate: string | undefined;

    constructor(data?: IAssetShowingFeedbackResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isShowingFeedbackAllowed = _data["isShowingFeedbackAllowed"];
            this.feedbackTemplate = _data["feedbackTemplate"];
        }
    }

    static fromJS(data: any): AssetShowingFeedbackResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingFeedbackResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isShowingFeedbackAllowed"] = this.isShowingFeedbackAllowed;
        data["feedbackTemplate"] = this.feedbackTemplate;
        return data; 
    }

    clone(): AssetShowingFeedbackResponseDto {
        const json = this.toJSON();
        let result = new AssetShowingFeedbackResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingFeedbackResponseDto {
    id: number;
    isShowingFeedbackAllowed: boolean | undefined;
    feedbackTemplate: string | undefined;
}

export class AssetShowingSettingDto implements IAssetShowingSettingDto {
    isShowingOff: boolean | undefined;
    isRealTimeAvaliabilityAllowed: boolean | undefined;
    isSmartShowingConciergeActivated: boolean | undefined;
    isOverlappingShowingAllowed: boolean | undefined;
    isAgentAllowToScheduleShowingOnline: boolean | undefined;
    isOverlappingShowingNotificationToAgentOn: boolean | undefined;
    maxShowingDuration: number | undefined;
    maxOverlapShowing: MaxOverlapShowing;
    minShowingNotice: number | undefined;

    constructor(data?: IAssetShowingSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isShowingOff = _data["isShowingOff"];
            this.isRealTimeAvaliabilityAllowed = _data["isRealTimeAvaliabilityAllowed"];
            this.isSmartShowingConciergeActivated = _data["isSmartShowingConciergeActivated"];
            this.isOverlappingShowingAllowed = _data["isOverlappingShowingAllowed"];
            this.isAgentAllowToScheduleShowingOnline = _data["isAgentAllowToScheduleShowingOnline"];
            this.isOverlappingShowingNotificationToAgentOn = _data["isOverlappingShowingNotificationToAgentOn"];
            this.maxShowingDuration = _data["maxShowingDuration"];
            this.maxOverlapShowing = _data["maxOverlapShowing"];
            this.minShowingNotice = _data["minShowingNotice"];
        }
    }

    static fromJS(data: any): AssetShowingSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isShowingOff"] = this.isShowingOff;
        data["isRealTimeAvaliabilityAllowed"] = this.isRealTimeAvaliabilityAllowed;
        data["isSmartShowingConciergeActivated"] = this.isSmartShowingConciergeActivated;
        data["isOverlappingShowingAllowed"] = this.isOverlappingShowingAllowed;
        data["isAgentAllowToScheduleShowingOnline"] = this.isAgentAllowToScheduleShowingOnline;
        data["isOverlappingShowingNotificationToAgentOn"] = this.isOverlappingShowingNotificationToAgentOn;
        data["maxShowingDuration"] = this.maxShowingDuration;
        data["maxOverlapShowing"] = this.maxOverlapShowing;
        data["minShowingNotice"] = this.minShowingNotice;
        return data; 
    }

    clone(): AssetShowingSettingDto {
        const json = this.toJSON();
        let result = new AssetShowingSettingDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingSettingDto {
    isShowingOff: boolean | undefined;
    isRealTimeAvaliabilityAllowed: boolean | undefined;
    isSmartShowingConciergeActivated: boolean | undefined;
    isOverlappingShowingAllowed: boolean | undefined;
    isAgentAllowToScheduleShowingOnline: boolean | undefined;
    isOverlappingShowingNotificationToAgentOn: boolean | undefined;
    maxShowingDuration: number | undefined;
    maxOverlapShowing: MaxOverlapShowing;
    minShowingNotice: number | undefined;
}

export class AssetShowingSettingResponseDto implements IAssetShowingSettingResponseDto {
    id: number;
    isShowingOff: boolean | undefined;
    isRealTimeAvaliabilityAllowed: boolean | undefined;
    isSmartShowingConciergeActivated: boolean | undefined;
    isOverlappingShowingAllowed: boolean | undefined;
    isAgentAllowToScheduleShowingOnline: boolean | undefined;
    isOverlappingShowingNotificationToAgentOn: boolean | undefined;
    maxShowingDuration: number | undefined;
    maxOverlapShowing: MaxOverlapShowing;
    minShowingNotice: number | undefined;

    constructor(data?: IAssetShowingSettingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isShowingOff = _data["isShowingOff"];
            this.isRealTimeAvaliabilityAllowed = _data["isRealTimeAvaliabilityAllowed"];
            this.isSmartShowingConciergeActivated = _data["isSmartShowingConciergeActivated"];
            this.isOverlappingShowingAllowed = _data["isOverlappingShowingAllowed"];
            this.isAgentAllowToScheduleShowingOnline = _data["isAgentAllowToScheduleShowingOnline"];
            this.isOverlappingShowingNotificationToAgentOn = _data["isOverlappingShowingNotificationToAgentOn"];
            this.maxShowingDuration = _data["maxShowingDuration"];
            this.maxOverlapShowing = _data["maxOverlapShowing"];
            this.minShowingNotice = _data["minShowingNotice"];
        }
    }

    static fromJS(data: any): AssetShowingSettingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetShowingSettingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isShowingOff"] = this.isShowingOff;
        data["isRealTimeAvaliabilityAllowed"] = this.isRealTimeAvaliabilityAllowed;
        data["isSmartShowingConciergeActivated"] = this.isSmartShowingConciergeActivated;
        data["isOverlappingShowingAllowed"] = this.isOverlappingShowingAllowed;
        data["isAgentAllowToScheduleShowingOnline"] = this.isAgentAllowToScheduleShowingOnline;
        data["isOverlappingShowingNotificationToAgentOn"] = this.isOverlappingShowingNotificationToAgentOn;
        data["maxShowingDuration"] = this.maxShowingDuration;
        data["maxOverlapShowing"] = this.maxOverlapShowing;
        data["minShowingNotice"] = this.minShowingNotice;
        return data; 
    }

    clone(): AssetShowingSettingResponseDto {
        const json = this.toJSON();
        let result = new AssetShowingSettingResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAssetShowingSettingResponseDto {
    id: number;
    isShowingOff: boolean | undefined;
    isRealTimeAvaliabilityAllowed: boolean | undefined;
    isSmartShowingConciergeActivated: boolean | undefined;
    isOverlappingShowingAllowed: boolean | undefined;
    isAgentAllowToScheduleShowingOnline: boolean | undefined;
    isOverlappingShowingNotificationToAgentOn: boolean | undefined;
    maxShowingDuration: number | undefined;
    maxOverlapShowing: MaxOverlapShowing;
    minShowingNotice: number | undefined;
}

export class AssetSoldIntoAddressDto implements IAssetSoldIntoAddressDto {
    country: string | undefined;
    region: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    type: SoldInfoAddressType;

    constructor(data?: IAssetSoldIntoAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.region = _data["region"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AssetSoldIntoAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSoldIntoAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["region"] = this.region;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["type"] = this.type;
        return data; 
    }

    clone(): AssetSoldIntoAddressDto {
        const json = this.toJSON();
        let result = new AssetSoldIntoAddressDto();
        result.init(json);
        return result;
    }
}

export interface IAssetSoldIntoAddressDto {
    country: string | undefined;
    region: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    type: SoldInfoAddressType;
}

export enum AssetStatus {
    None = <any>"None",
    Active = <any>"Active",
    ComingSoon = <any>"ComingSoon",
    Temporary = <any>"Temporary",
    UnderContract = <any>"UnderContract",
    UnderContractNoVisit = <any>"UnderContractNoVisit",
    Closed = <any>"Closed",
    Withdrawn = <any>"Withdrawn",
    Cancelled = <any>"Cancelled",
    Expired = <any>"Expired",
}

export class AssetTitleHolderDto implements IAssetTitleHolderDto {
    ownershipType: OwnershipType;
    documentType: string | undefined;
    part: string | undefined;
    taxIdentification: number | undefined;
    entity: string | undefined;
    ownerName: string | undefined;
    ownerAddress: string | undefined;

    constructor(data?: IAssetTitleHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownershipType = _data["ownershipType"];
            this.documentType = _data["documentType"];
            this.part = _data["part"];
            this.taxIdentification = _data["taxIdentification"];
            this.entity = _data["entity"];
            this.ownerName = _data["ownerName"];
            this.ownerAddress = _data["ownerAddress"];
        }
    }

    static fromJS(data: any): AssetTitleHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTitleHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownershipType"] = this.ownershipType;
        data["documentType"] = this.documentType;
        data["part"] = this.part;
        data["taxIdentification"] = this.taxIdentification;
        data["entity"] = this.entity;
        data["ownerName"] = this.ownerName;
        data["ownerAddress"] = this.ownerAddress;
        return data; 
    }

    clone(): AssetTitleHolderDto {
        const json = this.toJSON();
        let result = new AssetTitleHolderDto();
        result.init(json);
        return result;
    }
}

export interface IAssetTitleHolderDto {
    ownershipType: OwnershipType;
    documentType: string | undefined;
    part: string | undefined;
    taxIdentification: number | undefined;
    entity: string | undefined;
    ownerName: string | undefined;
    ownerAddress: string | undefined;
}

export class AssetTypeLookupDto implements IAssetTypeLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    childern: AssetTypeLookupDto[] | undefined;

    constructor(data?: IAssetTypeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["childern"])) {
                this.childern = [] as any;
                for (let item of _data["childern"])
                    this.childern.push(AssetTypeLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetTypeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.childern)) {
            data["childern"] = [];
            for (let item of this.childern)
                data["childern"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AssetTypeLookupDto {
        const json = this.toJSON();
        let result = new AssetTypeLookupDto();
        result.init(json);
        return result;
    }
}

export interface IAssetTypeLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    childern: AssetTypeLookupDto[] | undefined;
}

export class AssetUnitDto implements IAssetUnitDto {
    id: number;
    unitLevel: number | undefined;
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBathRooms: number | undefined;
    numberOfHalfBathRooms: number | undefined;
    monthlyRent: number | undefined;
    lease: LeaseType;
    occupant: OccupantType;
    leaseExpiryDate: moment.Moment | undefined;
    includedWithRent: string[] | undefined;
    unitFeatures: string[] | undefined;
    applianceIncluded: string[] | undefined;

    constructor(data?: IAssetUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitLevel = _data["unitLevel"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBedRooms = _data["numberOfBedRooms"];
            this.numberOfFullBathRooms = _data["numberOfFullBathRooms"];
            this.numberOfHalfBathRooms = _data["numberOfHalfBathRooms"];
            this.monthlyRent = _data["monthlyRent"];
            this.lease = _data["lease"];
            this.occupant = _data["occupant"];
            this.leaseExpiryDate = _data["leaseExpiryDate"] ? moment(_data["leaseExpiryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["includedWithRent"])) {
                this.includedWithRent = [] as any;
                for (let item of _data["includedWithRent"])
                    this.includedWithRent.push(item);
            }
            if (Array.isArray(_data["unitFeatures"])) {
                this.unitFeatures = [] as any;
                for (let item of _data["unitFeatures"])
                    this.unitFeatures.push(item);
            }
            if (Array.isArray(_data["applianceIncluded"])) {
                this.applianceIncluded = [] as any;
                for (let item of _data["applianceIncluded"])
                    this.applianceIncluded.push(item);
            }
        }
    }

    static fromJS(data: any): AssetUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitLevel"] = this.unitLevel;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBedRooms"] = this.numberOfBedRooms;
        data["numberOfFullBathRooms"] = this.numberOfFullBathRooms;
        data["numberOfHalfBathRooms"] = this.numberOfHalfBathRooms;
        data["monthlyRent"] = this.monthlyRent;
        data["lease"] = this.lease;
        data["occupant"] = this.occupant;
        data["leaseExpiryDate"] = this.leaseExpiryDate ? this.leaseExpiryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.includedWithRent)) {
            data["includedWithRent"] = [];
            for (let item of this.includedWithRent)
                data["includedWithRent"].push(item);
        }
        if (Array.isArray(this.unitFeatures)) {
            data["unitFeatures"] = [];
            for (let item of this.unitFeatures)
                data["unitFeatures"].push(item);
        }
        if (Array.isArray(this.applianceIncluded)) {
            data["applianceIncluded"] = [];
            for (let item of this.applianceIncluded)
                data["applianceIncluded"].push(item);
        }
        return data; 
    }

    clone(): AssetUnitDto {
        const json = this.toJSON();
        let result = new AssetUnitDto();
        result.init(json);
        return result;
    }
}

export interface IAssetUnitDto {
    id: number;
    unitLevel: number | undefined;
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBathRooms: number | undefined;
    numberOfHalfBathRooms: number | undefined;
    monthlyRent: number | undefined;
    lease: LeaseType;
    occupant: OccupantType;
    leaseExpiryDate: moment.Moment | undefined;
    includedWithRent: string[] | undefined;
    unitFeatures: string[] | undefined;
    applianceIncluded: string[] | undefined;
}

export class AssetUnitResponseDto implements IAssetUnitResponseDto {
    id: number;
    unitLevel: number | undefined;
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBathRooms: number | undefined;
    numberOfHalfBathRooms: number | undefined;
    monthlyRent: number | undefined;
    lease: LeaseType;
    occupant: OccupantType;
    leaseExpiryDate: moment.Moment | undefined;
    includedWithRent: string[] | undefined;
    unitFeatures: string[] | undefined;
    applianceIncluded: string[] | undefined;

    constructor(data?: IAssetUnitResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitLevel = _data["unitLevel"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBedRooms = _data["numberOfBedRooms"];
            this.numberOfFullBathRooms = _data["numberOfFullBathRooms"];
            this.numberOfHalfBathRooms = _data["numberOfHalfBathRooms"];
            this.monthlyRent = _data["monthlyRent"];
            this.lease = _data["lease"];
            this.occupant = _data["occupant"];
            this.leaseExpiryDate = _data["leaseExpiryDate"] ? moment(_data["leaseExpiryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["includedWithRent"])) {
                this.includedWithRent = [] as any;
                for (let item of _data["includedWithRent"])
                    this.includedWithRent.push(item);
            }
            if (Array.isArray(_data["unitFeatures"])) {
                this.unitFeatures = [] as any;
                for (let item of _data["unitFeatures"])
                    this.unitFeatures.push(item);
            }
            if (Array.isArray(_data["applianceIncluded"])) {
                this.applianceIncluded = [] as any;
                for (let item of _data["applianceIncluded"])
                    this.applianceIncluded.push(item);
            }
        }
    }

    static fromJS(data: any): AssetUnitResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUnitResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitLevel"] = this.unitLevel;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBedRooms"] = this.numberOfBedRooms;
        data["numberOfFullBathRooms"] = this.numberOfFullBathRooms;
        data["numberOfHalfBathRooms"] = this.numberOfHalfBathRooms;
        data["monthlyRent"] = this.monthlyRent;
        data["lease"] = this.lease;
        data["occupant"] = this.occupant;
        data["leaseExpiryDate"] = this.leaseExpiryDate ? this.leaseExpiryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.includedWithRent)) {
            data["includedWithRent"] = [];
            for (let item of this.includedWithRent)
                data["includedWithRent"].push(item);
        }
        if (Array.isArray(this.unitFeatures)) {
            data["unitFeatures"] = [];
            for (let item of this.unitFeatures)
                data["unitFeatures"].push(item);
        }
        if (Array.isArray(this.applianceIncluded)) {
            data["applianceIncluded"] = [];
            for (let item of this.applianceIncluded)
                data["applianceIncluded"].push(item);
        }
        return data; 
    }

    clone(): AssetUnitResponseDto {
        const json = this.toJSON();
        let result = new AssetUnitResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAssetUnitResponseDto {
    id: number;
    unitLevel: number | undefined;
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBathRooms: number | undefined;
    numberOfHalfBathRooms: number | undefined;
    monthlyRent: number | undefined;
    lease: LeaseType;
    occupant: OccupantType;
    leaseExpiryDate: moment.Moment | undefined;
    includedWithRent: string[] | undefined;
    unitFeatures: string[] | undefined;
    applianceIncluded: string[] | undefined;
}

export class AssociationFeeProvideTypeDto implements IAssociationFeeProvideTypeDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IAssociationFeeProvideTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AssociationFeeProvideTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociationFeeProvideTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): AssociationFeeProvideTypeDto {
        const json = this.toJSON();
        let result = new AssociationFeeProvideTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAssociationFeeProvideTypeDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class AvailabilitySlotDto implements IAvailabilitySlotDto {
    date: moment.Moment;
    from: moment.Moment;
    to: moment.Moment;
    priority: number;

    constructor(data?: IAvailabilitySlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): AvailabilitySlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilitySlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["priority"] = this.priority;
        return data; 
    }

    clone(): AvailabilitySlotDto {
        const json = this.toJSON();
        let result = new AvailabilitySlotDto();
        result.init(json);
        return result;
    }
}

export interface IAvailabilitySlotDto {
    date: moment.Moment;
    from: moment.Moment;
    to: moment.Moment;
    priority: number;
}

export enum BuildoutAllowanceAvailbleType {
    None = <any>"None",
    Yes = <any>"Yes",
    No = <any>"No",
    Negotiable = <any>"Negotiable",
}

export enum BusinessIncludedState {
    None = <any>"None",
    Unknown = <any>"Unknown",
    Yes = <any>"Yes",
    No = <any>"No",
}

export enum BusinessSubPropertyType {
    None = <any>"None",
    Hotel = <any>"Hotel",
    Hostel = <any>"Hostel",
    Motel = <any>"Motel",
    Investment = <any>"Investment",
    Resort = <any>"Resort",
    Guethouse_Bed_Breakfast = <any>"Guethouse_Bed_Breakfast",
    CampingSite = <any>"CampingSite",
}

export enum BusinessType {
    None = <any>"None",
    Sale = <any>"Sale",
    Lease = <any>"Lease",
    Exchange = <any>"Exchange",
    Trespassing = <any>"Trespassing",
    QuotaTransfer = <any>"QuotaTransfer",
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data; 
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChoiceDto implements IChoiceDto {
    id: number;
    choiceText: string | undefined;

    constructor(data?: IChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.choiceText = _data["choiceText"];
        }
    }

    static fromJS(data: any): ChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["choiceText"] = this.choiceText;
        return data; 
    }

    clone(): ChoiceDto {
        const json = this.toJSON();
        let result = new ChoiceDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceDto {
    id: number;
    choiceText: string | undefined;
}

export class CommercialFeatureLookupDto implements ICommercialFeatureLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: ICommercialFeatureLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CommercialFeatureLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialFeatureLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): CommercialFeatureLookupDto {
        const json = this.toJSON();
        let result = new CommercialFeatureLookupDto();
        result.init(json);
        return result;
    }
}

export interface ICommercialFeatureLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export enum CommissionType {
    None = <any>"None",
    Amount = <any>"Amount",
    PercentageOfTheSalePrice = <any>"PercentageOfTheSalePrice",
    PercentageOfTheMonthlyRent = <any>"PercentageOfTheMonthlyRent",
    PercentageOfTheMonthRentForEachYear = <any>"PercentageOfTheMonthRentForEachYear",
    PercentageOfTheGrossLeaseOfTheLeaseFirstYear = <any>"PercentageOfTheGrossLeaseOfTheLeaseFirstYear",
    PercentageOfTheTotalGrossLeaseOfTheLeaseFirstYear = <any>"PercentageOfTheTotalGrossLeaseOfTheLeaseFirstYear",
}

export class CompanyDto implements ICompanyDto {
    name: string | undefined;
    phone: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        return data; 
    }

    clone(): CompanyDto {
        const json = this.toJSON();
        let result = new CompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDto {
    name: string | undefined;
    phone: string | undefined;
}

export enum ContactRequirementType {
    None = <any>"None",
    SendTextNotifications = <any>"SendTextNotifications",
    RequireAnAutoCall = <any>"RequireAnAutoCall",
    SendEmailNotification = <any>"SendEmailNotification",
    SendShowingAgentInformation = <any>"SendShowingAgentInformation",
    SendWhatsAppNotifications = <any>"SendWhatsAppNotifications",
    SendFeedbackReceived = <any>"SendFeedbackReceived",
}

export enum ContactStatus {
    None = <any>"None",
    Sphere = <any>"Sphere",
    Prospect = <any>"Prospect",
    NewLead = <any>"NewLead",
    ActiveLead = <any>"ActiveLead",
    Client = <any>"Client",
    Contract = <any>"Contract",
    Closed = <any>"Closed",
}

export enum ContactType {
    None = <any>"None",
    ListingAgent = <any>"ListingAgent",
    AddManually = <any>"AddManually",
}

export enum ContractType {
    None = <any>"None",
    FullService = <any>"FullService",
    LimitedService = <any>"LimitedService",
    EntryOnly = <any>"EntryOnly",
}

export class CountryLookupDto implements ICountryLookupDto {
    id: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: ICountryLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CountryLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }

    clone(): CountryLookupDto {
        const json = this.toJSON();
        let result = new CountryLookupDto();
        result.init(json);
        return result;
    }
}

export interface ICountryLookupDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class CreateAssetDto implements ICreateAssetDto {
    title: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    type: string | undefined;
    subType: string | undefined;

    constructor(data?: ICreateAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.assetStatus = _data["assetStatus"];
            this.businessType = _data["businessType"];
            this.type = _data["type"];
            this.subType = _data["subType"];
        }
    }

    static fromJS(data: any): CreateAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["assetStatus"] = this.assetStatus;
        data["businessType"] = this.businessType;
        data["type"] = this.type;
        data["subType"] = this.subType;
        return data; 
    }

    clone(): CreateAssetDto {
        const json = this.toJSON();
        let result = new CreateAssetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetDto {
    title: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    type: string | undefined;
    subType: string | undefined;
}

export class CreateChoiceDto implements ICreateChoiceDto {
    choiceText: string | undefined;

    constructor(data?: ICreateChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.choiceText = _data["choiceText"];
        }
    }

    static fromJS(data: any): CreateChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceText"] = this.choiceText;
        return data; 
    }

    clone(): CreateChoiceDto {
        const json = this.toJSON();
        let result = new CreateChoiceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateChoiceDto {
    choiceText: string | undefined;
}

export class CreateContactAddressDto implements ICreateContactAddressDto {
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;

    constructor(data?: ICreateContactAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.intermunicipalCommunities = _data["intermunicipalCommunities"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.zone = _data["zone"];
            this.streetType = _data["streetType"];
            this.streetName = _data["streetName"];
            this.doorNumber = _data["doorNumber"];
            this.floorNumber = _data["floorNumber"];
            this.doorIdentifier = _data["doorIdentifier"];
            this.unitNumber = _data["unitNumber"];
            this.floorLevel = _data["floorLevel"];
            this.zipcode = _data["zipcode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CreateContactAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["intermunicipalCommunities"] = this.intermunicipalCommunities;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["zone"] = this.zone;
        data["streetType"] = this.streetType;
        data["streetName"] = this.streetName;
        data["doorNumber"] = this.doorNumber;
        data["floorNumber"] = this.floorNumber;
        data["doorIdentifier"] = this.doorIdentifier;
        data["unitNumber"] = this.unitNumber;
        data["floorLevel"] = this.floorLevel;
        data["zipcode"] = this.zipcode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }

    clone(): CreateContactAddressDto {
        const json = this.toJSON();
        let result = new CreateContactAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContactAddressDto {
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
}

export class CreateContactDto implements ICreateContactDto {
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    address: CreateContactAddressDto;
    roleNames: string[] | undefined;

    constructor(data?: ICreateContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"] ? CreateContactAddressDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data; 
    }

    clone(): CreateContactDto {
        const json = this.toJSON();
        let result = new CreateContactDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContactDto {
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    address: CreateContactAddressDto;
    roleNames: string[] | undefined;
}

export class CreateFeedbackTemplateDto implements ICreateFeedbackTemplateDto {
    title: string | undefined;
    description: string | undefined;
    feedbackRequestByEmail: string | undefined;
    feedbackInstruction: string | undefined;
    isDefault: boolean;
    questions: CreateQuestionDto[] | undefined;

    constructor(data?: ICreateFeedbackTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.feedbackRequestByEmail = _data["feedbackRequestByEmail"];
            this.feedbackInstruction = _data["feedbackInstruction"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions.push(CreateQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateFeedbackTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["feedbackRequestByEmail"] = this.feedbackRequestByEmail;
        data["feedbackInstruction"] = this.feedbackInstruction;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateFeedbackTemplateDto {
        const json = this.toJSON();
        let result = new CreateFeedbackTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFeedbackTemplateDto {
    title: string | undefined;
    description: string | undefined;
    feedbackRequestByEmail: string | undefined;
    feedbackInstruction: string | undefined;
    isDefault: boolean;
    questions: CreateQuestionDto[] | undefined;
}

export class CreateQuestionDto implements ICreateQuestionDto {
    questionText: string | undefined;
    type: QuestionType;
    threshold: number | undefined;
    choices: CreateChoiceDto[] | undefined;

    constructor(data?: ICreateQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionText = _data["questionText"];
            this.type = _data["type"];
            this.threshold = _data["threshold"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices.push(CreateChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["type"] = this.type;
        data["threshold"] = this.threshold;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateQuestionDto {
        const json = this.toJSON();
        let result = new CreateQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateQuestionDto {
    questionText: string | undefined;
    type: QuestionType;
    threshold: number | undefined;
    choices: CreateChoiceDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUserContactAddressDto implements ICreateUserContactAddressDto {
    region: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;

    constructor(data?: ICreateUserContactAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.zone = _data["zone"];
            this.streetType = _data["streetType"];
            this.streetName = _data["streetName"];
            this.doorNumber = _data["doorNumber"];
            this.floorNumber = _data["floorNumber"];
            this.doorIdentifier = _data["doorIdentifier"];
            this.unitNumber = _data["unitNumber"];
            this.floorLevel = _data["floorLevel"];
            this.zipcode = _data["zipcode"];
        }
    }

    static fromJS(data: any): CreateUserContactAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserContactAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["zone"] = this.zone;
        data["streetType"] = this.streetType;
        data["streetName"] = this.streetName;
        data["doorNumber"] = this.doorNumber;
        data["floorNumber"] = this.floorNumber;
        data["doorIdentifier"] = this.doorIdentifier;
        data["unitNumber"] = this.unitNumber;
        data["floorLevel"] = this.floorLevel;
        data["zipcode"] = this.zipcode;
        return data; 
    }

    clone(): CreateUserContactAddressDto {
        const json = this.toJSON();
        let result = new CreateUserContactAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserContactAddressDto {
    region: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
}

export class CreateUserContactDto implements ICreateUserContactDto {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    spouseName: string | undefined;
    spouseCellNumber: string | undefined;
    note: string | undefined;
    isEmailNotificationRequired: boolean | undefined;
    isCallNotificationRequired: boolean | undefined;
    isTextNotificationRequired: boolean | undefined;
    isWhatsappNotificationRequired: boolean | undefined;
    contactType: ContactType;
    contactStatus: ContactStatus;
    leadSource: LeadSource;
    userId: number;
    userContactAddresses: CreateUserContactAddressDto[] | undefined;

    constructor(data?: ICreateUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.spouseName = _data["spouseName"];
            this.spouseCellNumber = _data["spouseCellNumber"];
            this.note = _data["note"];
            this.isEmailNotificationRequired = _data["isEmailNotificationRequired"];
            this.isCallNotificationRequired = _data["isCallNotificationRequired"];
            this.isTextNotificationRequired = _data["isTextNotificationRequired"];
            this.isWhatsappNotificationRequired = _data["isWhatsappNotificationRequired"];
            this.contactType = _data["contactType"];
            this.contactStatus = _data["contactStatus"];
            this.leadSource = _data["leadSource"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["userContactAddresses"])) {
                this.userContactAddresses = [] as any;
                for (let item of _data["userContactAddresses"])
                    this.userContactAddresses.push(CreateUserContactAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["spouseName"] = this.spouseName;
        data["spouseCellNumber"] = this.spouseCellNumber;
        data["note"] = this.note;
        data["isEmailNotificationRequired"] = this.isEmailNotificationRequired;
        data["isCallNotificationRequired"] = this.isCallNotificationRequired;
        data["isTextNotificationRequired"] = this.isTextNotificationRequired;
        data["isWhatsappNotificationRequired"] = this.isWhatsappNotificationRequired;
        data["contactType"] = this.contactType;
        data["contactStatus"] = this.contactStatus;
        data["leadSource"] = this.leadSource;
        data["userId"] = this.userId;
        if (Array.isArray(this.userContactAddresses)) {
            data["userContactAddresses"] = [];
            for (let item of this.userContactAddresses)
                data["userContactAddresses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateUserContactDto {
        const json = this.toJSON();
        let result = new CreateUserContactDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserContactDto {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    spouseName: string | undefined;
    spouseCellNumber: string | undefined;
    note: string | undefined;
    isEmailNotificationRequired: boolean | undefined;
    isCallNotificationRequired: boolean | undefined;
    isTextNotificationRequired: boolean | undefined;
    isWhatsappNotificationRequired: boolean | undefined;
    contactType: ContactType;
    contactStatus: ContactStatus;
    leadSource: LeadSource;
    userId: number;
    userContactAddresses: CreateUserContactAddressDto[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export enum DayOfWeek {
    Sunday = <any>"Sunday",
    Monday = <any>"Monday",
    Tuesday = <any>"Tuesday",
    Wednesday = <any>"Wednesday",
    Thursday = <any>"Thursday",
    Friday = <any>"Friday",
    Saturday = <any>"Saturday",
}

export enum DisabilityCompliantState {
    None = <any>"None",
    Unknown = <any>"Unknown",
    Yes = <any>"Yes",
    No = <any>"No",
}

export class DistrictLookupDto implements IDistrictLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IDistrictLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DistrictLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): DistrictLookupDto {
        const json = this.toJSON();
        let result = new DistrictLookupDto();
        result.init(json);
        return result;
    }
}

export interface IDistrictLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class DocumentTypeLookupDto implements IDocumentTypeLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IDocumentTypeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DocumentTypeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): DocumentTypeLookupDto {
        const json = this.toJSON();
        let result = new DocumentTypeLookupDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data; 
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data; 
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FeedbackTemplateDto implements IFeedbackTemplateDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    feedbackRequestByEmail: string | undefined;
    feedbackInstruction: string | undefined;
    isDefault: boolean;
    questions: QuestionDto[] | undefined;

    constructor(data?: IFeedbackTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.feedbackRequestByEmail = _data["feedbackRequestByEmail"];
            this.feedbackInstruction = _data["feedbackInstruction"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["feedbackRequestByEmail"] = this.feedbackRequestByEmail;
        data["feedbackInstruction"] = this.feedbackInstruction;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FeedbackTemplateDto {
        const json = this.toJSON();
        let result = new FeedbackTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IFeedbackTemplateDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    feedbackRequestByEmail: string | undefined;
    feedbackInstruction: string | undefined;
    isDefault: boolean;
    questions: QuestionDto[] | undefined;
}

export class FeedbackTemplateDtoPagedResultDto implements IFeedbackTemplateDtoPagedResultDto {
    items: FeedbackTemplateDto[] | undefined;
    totalCount: number;

    constructor(data?: IFeedbackTemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FeedbackTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FeedbackTemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): FeedbackTemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FeedbackTemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFeedbackTemplateDtoPagedResultDto {
    items: FeedbackTemplateDto[] | undefined;
    totalCount: number;
}

export class FeedbackTemplateRequestDto implements IFeedbackTemplateRequestDto {

    constructor(data?: IFeedbackTemplateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FeedbackTemplateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTemplateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): FeedbackTemplateRequestDto {
        const json = this.toJSON();
        let result = new FeedbackTemplateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IFeedbackTemplateRequestDto {
}

export enum FileType {
    None = <any>"None",
    Contract = <any>"Contract",
    ProfileImage = <any>"ProfileImage",
    EnergyCertificate = <any>"EnergyCertificate",
    AssetImages = <any>"AssetImages",
    LockBoxImage = <any>"LockBoxImage",
    PropertyCertificate = <any>"PropertyCertificate",
    VirtualTour = <any>"VirtualTour",
}

export enum FinanceType {
    None = <any>"None",
    Cash = <any>"Cash",
    BankFinanced = <any>"BankFinanced",
    PrivateFinanced = <any>"PrivateFinanced",
    Exchange = <any>"Exchange",
    LineOfCredit = <any>"LineOfCredit",
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetAddressInfoProjection implements IGetAddressInfoProjection {
    id: number;
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    departmentName: string | undefined;
    sunExposure: SunExposeSides;
    assetId: number;

    constructor(data?: IGetAddressInfoProjection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.region = _data["region"];
            this.intermunicipalCommunities = _data["intermunicipalCommunities"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.zone = _data["zone"];
            this.streetType = _data["streetType"];
            this.streetName = _data["streetName"];
            this.doorNumber = _data["doorNumber"];
            this.floorNumber = _data["floorNumber"];
            this.doorIdentifier = _data["doorIdentifier"];
            this.unitNumber = _data["unitNumber"];
            this.floorLevel = _data["floorLevel"];
            this.zipcode = _data["zipcode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.departmentName = _data["departmentName"];
            this.sunExposure = _data["sunExposure"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAddressInfoProjection {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressInfoProjection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["region"] = this.region;
        data["intermunicipalCommunities"] = this.intermunicipalCommunities;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["zone"] = this.zone;
        data["streetType"] = this.streetType;
        data["streetName"] = this.streetName;
        data["doorNumber"] = this.doorNumber;
        data["floorNumber"] = this.floorNumber;
        data["doorIdentifier"] = this.doorIdentifier;
        data["unitNumber"] = this.unitNumber;
        data["floorLevel"] = this.floorLevel;
        data["zipcode"] = this.zipcode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["departmentName"] = this.departmentName;
        data["sunExposure"] = this.sunExposure;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAddressInfoProjection {
        const json = this.toJSON();
        let result = new GetAddressInfoProjection();
        result.init(json);
        return result;
    }
}

export interface IGetAddressInfoProjection {
    id: number;
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    departmentName: string | undefined;
    sunExposure: SunExposeSides;
    assetId: number;
}

export class GetAssetAdditionalInfoDto implements IGetAssetAdditionalInfoDto {
    id: number;
    displayAddressOnInternet: boolean | undefined;
    acceptableFinancing: AcceptableFinancingType;
    displayListingOnIdxWebsite: boolean | undefined;
    occupiedBy: OccupiedByType;
    propertyHasForSaleSign: boolean | undefined;
    anyPropertyOwnerIsARealEstateLicensee: boolean | undefined;
    possession: moment.Moment | undefined;
    relatedMlsNumbers: string[] | undefined;
    bankOwnedOrControlledProperty: boolean | undefined;
    propertyTitle: string | undefined;
    directions: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetAdditionalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayAddressOnInternet = _data["displayAddressOnInternet"];
            this.acceptableFinancing = _data["acceptableFinancing"];
            this.displayListingOnIdxWebsite = _data["displayListingOnIdxWebsite"];
            this.occupiedBy = _data["occupiedBy"];
            this.propertyHasForSaleSign = _data["propertyHasForSaleSign"];
            this.anyPropertyOwnerIsARealEstateLicensee = _data["anyPropertyOwnerIsARealEstateLicensee"];
            this.possession = _data["possession"] ? moment(_data["possession"].toString()) : <any>undefined;
            if (Array.isArray(_data["relatedMlsNumbers"])) {
                this.relatedMlsNumbers = [] as any;
                for (let item of _data["relatedMlsNumbers"])
                    this.relatedMlsNumbers.push(item);
            }
            this.bankOwnedOrControlledProperty = _data["bankOwnedOrControlledProperty"];
            this.propertyTitle = _data["propertyTitle"];
            this.directions = _data["directions"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetAdditionalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetAdditionalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayAddressOnInternet"] = this.displayAddressOnInternet;
        data["acceptableFinancing"] = this.acceptableFinancing;
        data["displayListingOnIdxWebsite"] = this.displayListingOnIdxWebsite;
        data["occupiedBy"] = this.occupiedBy;
        data["propertyHasForSaleSign"] = this.propertyHasForSaleSign;
        data["anyPropertyOwnerIsARealEstateLicensee"] = this.anyPropertyOwnerIsARealEstateLicensee;
        data["possession"] = this.possession ? this.possession.toISOString() : <any>undefined;
        if (Array.isArray(this.relatedMlsNumbers)) {
            data["relatedMlsNumbers"] = [];
            for (let item of this.relatedMlsNumbers)
                data["relatedMlsNumbers"].push(item);
        }
        data["bankOwnedOrControlledProperty"] = this.bankOwnedOrControlledProperty;
        data["propertyTitle"] = this.propertyTitle;
        data["directions"] = this.directions;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetAdditionalInfoDto {
        const json = this.toJSON();
        let result = new GetAssetAdditionalInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetAdditionalInfoDto {
    id: number;
    displayAddressOnInternet: boolean | undefined;
    acceptableFinancing: AcceptableFinancingType;
    displayListingOnIdxWebsite: boolean | undefined;
    occupiedBy: OccupiedByType;
    propertyHasForSaleSign: boolean | undefined;
    anyPropertyOwnerIsARealEstateLicensee: boolean | undefined;
    possession: moment.Moment | undefined;
    relatedMlsNumbers: string[] | undefined;
    bankOwnedOrControlledProperty: boolean | undefined;
    propertyTitle: string | undefined;
    directions: string | undefined;
    assetId: number;
}

export class GetAssetAddressInfoDto implements IGetAssetAddressInfoDto {
    id: number;
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    departmentName: string | undefined;
    sunExposure: SunExposeSides;
    assetId: number;

    constructor(data?: IGetAssetAddressInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.region = _data["region"];
            this.intermunicipalCommunities = _data["intermunicipalCommunities"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.zone = _data["zone"];
            this.streetType = _data["streetType"];
            this.streetName = _data["streetName"];
            this.doorNumber = _data["doorNumber"];
            this.floorNumber = _data["floorNumber"];
            this.doorIdentifier = _data["doorIdentifier"];
            this.unitNumber = _data["unitNumber"];
            this.floorLevel = _data["floorLevel"];
            this.zipcode = _data["zipcode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.departmentName = _data["departmentName"];
            this.sunExposure = _data["sunExposure"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetAddressInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetAddressInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["region"] = this.region;
        data["intermunicipalCommunities"] = this.intermunicipalCommunities;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["zone"] = this.zone;
        data["streetType"] = this.streetType;
        data["streetName"] = this.streetName;
        data["doorNumber"] = this.doorNumber;
        data["floorNumber"] = this.floorNumber;
        data["doorIdentifier"] = this.doorIdentifier;
        data["unitNumber"] = this.unitNumber;
        data["floorLevel"] = this.floorLevel;
        data["zipcode"] = this.zipcode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["departmentName"] = this.departmentName;
        data["sunExposure"] = this.sunExposure;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetAddressInfoDto {
        const json = this.toJSON();
        let result = new GetAssetAddressInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetAddressInfoDto {
    id: number;
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    departmentName: string | undefined;
    sunExposure: SunExposeSides;
    assetId: number;
}

export class GetAssetAreaDto implements IGetAssetAreaDto {
    id: number;
    integralLandArea: number | undefined;
    privateGrossArea: number | undefined;
    dependentGrossArea: number | undefined;
    buildingDeploymentArea: number | undefined;
    buildingGrossArea: number | undefined;
    totalLandArea: number | undefined;

    constructor(data?: IGetAssetAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.integralLandArea = _data["integralLandArea"];
            this.privateGrossArea = _data["privateGrossArea"];
            this.dependentGrossArea = _data["dependentGrossArea"];
            this.buildingDeploymentArea = _data["buildingDeploymentArea"];
            this.buildingGrossArea = _data["buildingGrossArea"];
            this.totalLandArea = _data["totalLandArea"];
        }
    }

    static fromJS(data: any): GetAssetAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["integralLandArea"] = this.integralLandArea;
        data["privateGrossArea"] = this.privateGrossArea;
        data["dependentGrossArea"] = this.dependentGrossArea;
        data["buildingDeploymentArea"] = this.buildingDeploymentArea;
        data["buildingGrossArea"] = this.buildingGrossArea;
        data["totalLandArea"] = this.totalLandArea;
        return data; 
    }

    clone(): GetAssetAreaDto {
        const json = this.toJSON();
        let result = new GetAssetAreaDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetAreaDto {
    id: number;
    integralLandArea: number | undefined;
    privateGrossArea: number | undefined;
    dependentGrossArea: number | undefined;
    buildingDeploymentArea: number | undefined;
    buildingGrossArea: number | undefined;
    totalLandArea: number | undefined;
}

export class GetAssetAssociationInfoDto implements IGetAssetAssociationInfoDto {
    id: number;
    fees: number | undefined;
    paymentFrequency: PaymentFrequency;
    restrictions: string[] | undefined;
    amenities: string[] | undefined;
    feeProvides: string[] | undefined;
    propertyManagementType: PropertyManagementType;
    managementCompanyName: string | undefined;
    propertyManagerName: string | undefined;
    managerPhone: string | undefined;
    managementCompanyPhone: string | undefined;
    managementEmail: string | undefined;
    specialAssociationDetails: string | undefined;
    isHOA: boolean | undefined;
    isSpecialAssociationAssessments: boolean | undefined;
    assetId: number;

    constructor(data?: IGetAssetAssociationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fees = _data["fees"];
            this.paymentFrequency = _data["paymentFrequency"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions.push(item);
            }
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities.push(item);
            }
            if (Array.isArray(_data["feeProvides"])) {
                this.feeProvides = [] as any;
                for (let item of _data["feeProvides"])
                    this.feeProvides.push(item);
            }
            this.propertyManagementType = _data["propertyManagementType"];
            this.managementCompanyName = _data["managementCompanyName"];
            this.propertyManagerName = _data["propertyManagerName"];
            this.managerPhone = _data["managerPhone"];
            this.managementCompanyPhone = _data["managementCompanyPhone"];
            this.managementEmail = _data["managementEmail"];
            this.specialAssociationDetails = _data["specialAssociationDetails"];
            this.isHOA = _data["isHOA"];
            this.isSpecialAssociationAssessments = _data["isSpecialAssociationAssessments"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetAssociationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetAssociationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fees"] = this.fees;
        data["paymentFrequency"] = this.paymentFrequency;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item);
        }
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item);
        }
        if (Array.isArray(this.feeProvides)) {
            data["feeProvides"] = [];
            for (let item of this.feeProvides)
                data["feeProvides"].push(item);
        }
        data["propertyManagementType"] = this.propertyManagementType;
        data["managementCompanyName"] = this.managementCompanyName;
        data["propertyManagerName"] = this.propertyManagerName;
        data["managerPhone"] = this.managerPhone;
        data["managementCompanyPhone"] = this.managementCompanyPhone;
        data["managementEmail"] = this.managementEmail;
        data["specialAssociationDetails"] = this.specialAssociationDetails;
        data["isHOA"] = this.isHOA;
        data["isSpecialAssociationAssessments"] = this.isSpecialAssociationAssessments;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetAssociationInfoDto {
        const json = this.toJSON();
        let result = new GetAssetAssociationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetAssociationInfoDto {
    id: number;
    fees: number | undefined;
    paymentFrequency: PaymentFrequency;
    restrictions: string[] | undefined;
    amenities: string[] | undefined;
    feeProvides: string[] | undefined;
    propertyManagementType: PropertyManagementType;
    managementCompanyName: string | undefined;
    propertyManagerName: string | undefined;
    managerPhone: string | undefined;
    managementCompanyPhone: string | undefined;
    managementEmail: string | undefined;
    specialAssociationDetails: string | undefined;
    isHOA: boolean | undefined;
    isSpecialAssociationAssessments: boolean | undefined;
    assetId: number;
}

export class GetAssetCommercialInfoDto implements IGetAssetCommercialInfoDto {
    id: number;
    potentialUse: string | undefined;
    presentUser: string | undefined;
    location: string | undefined;
    availableDocuments: string | undefined;
    disabilityCompliant: DisabilityCompliantState;
    trafficCount: number | undefined;
    industrialArea: number | undefined;
    rentalArea: number | undefined;
    officeArea: number | undefined;
    warehouseArea: number | undefined;
    ceilingArea: number | undefined;
    roadFrontageArea: number | undefined;
    roadFrontageDescription: string | undefined;
    garageParkingType: string | undefined;
    numberOfRestRooms: number | undefined;
    numberOfStories: number | undefined;
    numberOfLoadingDocks: number | undefined;
    numberOfOverheadDoors: number | undefined;
    coveredParkingSpaces: number | undefined;
    uncoveredParkingSpaces: number | undefined;
    additionalSpaceAvailable: boolean | undefined;
    spaceIsDividlable: boolean | undefined;
    businessIncluded: BusinessIncludedState;
    numberOfTenants: number | undefined;
    businessIncludedItems: string | undefined;
    commercialFeatures: string[] | undefined;
    grossAnnaulIncome: number | undefined;
    grossAnnaulExpenses: number | undefined;
    netOperationIncome: number | undefined;
    assetId: number;

    constructor(data?: IGetAssetCommercialInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.potentialUse = _data["potentialUse"];
            this.presentUser = _data["presentUser"];
            this.location = _data["location"];
            this.availableDocuments = _data["availableDocuments"];
            this.disabilityCompliant = _data["disabilityCompliant"];
            this.trafficCount = _data["trafficCount"];
            this.industrialArea = _data["industrialArea"];
            this.rentalArea = _data["rentalArea"];
            this.officeArea = _data["officeArea"];
            this.warehouseArea = _data["warehouseArea"];
            this.ceilingArea = _data["ceilingArea"];
            this.roadFrontageArea = _data["roadFrontageArea"];
            this.roadFrontageDescription = _data["roadFrontageDescription"];
            this.garageParkingType = _data["garageParkingType"];
            this.numberOfRestRooms = _data["numberOfRestRooms"];
            this.numberOfStories = _data["numberOfStories"];
            this.numberOfLoadingDocks = _data["numberOfLoadingDocks"];
            this.numberOfOverheadDoors = _data["numberOfOverheadDoors"];
            this.coveredParkingSpaces = _data["coveredParkingSpaces"];
            this.uncoveredParkingSpaces = _data["uncoveredParkingSpaces"];
            this.additionalSpaceAvailable = _data["additionalSpaceAvailable"];
            this.spaceIsDividlable = _data["spaceIsDividlable"];
            this.businessIncluded = _data["businessIncluded"];
            this.numberOfTenants = _data["numberOfTenants"];
            this.businessIncludedItems = _data["businessIncludedItems"];
            if (Array.isArray(_data["commercialFeatures"])) {
                this.commercialFeatures = [] as any;
                for (let item of _data["commercialFeatures"])
                    this.commercialFeatures.push(item);
            }
            this.grossAnnaulIncome = _data["grossAnnaulIncome"];
            this.grossAnnaulExpenses = _data["grossAnnaulExpenses"];
            this.netOperationIncome = _data["netOperationIncome"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetCommercialInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetCommercialInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["potentialUse"] = this.potentialUse;
        data["presentUser"] = this.presentUser;
        data["location"] = this.location;
        data["availableDocuments"] = this.availableDocuments;
        data["disabilityCompliant"] = this.disabilityCompliant;
        data["trafficCount"] = this.trafficCount;
        data["industrialArea"] = this.industrialArea;
        data["rentalArea"] = this.rentalArea;
        data["officeArea"] = this.officeArea;
        data["warehouseArea"] = this.warehouseArea;
        data["ceilingArea"] = this.ceilingArea;
        data["roadFrontageArea"] = this.roadFrontageArea;
        data["roadFrontageDescription"] = this.roadFrontageDescription;
        data["garageParkingType"] = this.garageParkingType;
        data["numberOfRestRooms"] = this.numberOfRestRooms;
        data["numberOfStories"] = this.numberOfStories;
        data["numberOfLoadingDocks"] = this.numberOfLoadingDocks;
        data["numberOfOverheadDoors"] = this.numberOfOverheadDoors;
        data["coveredParkingSpaces"] = this.coveredParkingSpaces;
        data["uncoveredParkingSpaces"] = this.uncoveredParkingSpaces;
        data["additionalSpaceAvailable"] = this.additionalSpaceAvailable;
        data["spaceIsDividlable"] = this.spaceIsDividlable;
        data["businessIncluded"] = this.businessIncluded;
        data["numberOfTenants"] = this.numberOfTenants;
        data["businessIncludedItems"] = this.businessIncludedItems;
        if (Array.isArray(this.commercialFeatures)) {
            data["commercialFeatures"] = [];
            for (let item of this.commercialFeatures)
                data["commercialFeatures"].push(item);
        }
        data["grossAnnaulIncome"] = this.grossAnnaulIncome;
        data["grossAnnaulExpenses"] = this.grossAnnaulExpenses;
        data["netOperationIncome"] = this.netOperationIncome;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetCommercialInfoDto {
        const json = this.toJSON();
        let result = new GetAssetCommercialInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetCommercialInfoDto {
    id: number;
    potentialUse: string | undefined;
    presentUser: string | undefined;
    location: string | undefined;
    availableDocuments: string | undefined;
    disabilityCompliant: DisabilityCompliantState;
    trafficCount: number | undefined;
    industrialArea: number | undefined;
    rentalArea: number | undefined;
    officeArea: number | undefined;
    warehouseArea: number | undefined;
    ceilingArea: number | undefined;
    roadFrontageArea: number | undefined;
    roadFrontageDescription: string | undefined;
    garageParkingType: string | undefined;
    numberOfRestRooms: number | undefined;
    numberOfStories: number | undefined;
    numberOfLoadingDocks: number | undefined;
    numberOfOverheadDoors: number | undefined;
    coveredParkingSpaces: number | undefined;
    uncoveredParkingSpaces: number | undefined;
    additionalSpaceAvailable: boolean | undefined;
    spaceIsDividlable: boolean | undefined;
    businessIncluded: BusinessIncludedState;
    numberOfTenants: number | undefined;
    businessIncludedItems: string | undefined;
    commercialFeatures: string[] | undefined;
    grossAnnaulIncome: number | undefined;
    grossAnnaulExpenses: number | undefined;
    netOperationIncome: number | undefined;
    assetId: number;
}

export class GetAssetConfrontationDto implements IGetAssetConfrontationDto {
    id: number;
    north: string | undefined;
    south: string | undefined;
    east: string | undefined;
    west: string | undefined;

    constructor(data?: IGetAssetConfrontationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.north = _data["north"];
            this.south = _data["south"];
            this.east = _data["east"];
            this.west = _data["west"];
        }
    }

    static fromJS(data: any): GetAssetConfrontationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetConfrontationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["north"] = this.north;
        data["south"] = this.south;
        data["east"] = this.east;
        data["west"] = this.west;
        return data; 
    }

    clone(): GetAssetConfrontationDto {
        const json = this.toJSON();
        let result = new GetAssetConfrontationDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetConfrontationDto {
    id: number;
    north: string | undefined;
    south: string | undefined;
    east: string | undefined;
    west: string | undefined;
}

export class GetAssetDescriptionDto implements IGetAssetDescriptionDto {
    id: number;
    allocation: string | undefined;
    typology: string | undefined;
    perMilage: string | undefined;
    description: string | undefined;

    constructor(data?: IGetAssetDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allocation = _data["allocation"];
            this.typology = _data["typology"];
            this.perMilage = _data["perMilage"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetAssetDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocation"] = this.allocation;
        data["typology"] = this.typology;
        data["perMilage"] = this.perMilage;
        data["description"] = this.description;
        return data; 
    }

    clone(): GetAssetDescriptionDto {
        const json = this.toJSON();
        let result = new GetAssetDescriptionDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetDescriptionDto {
    id: number;
    allocation: string | undefined;
    typology: string | undefined;
    perMilage: string | undefined;
    description: string | undefined;
}

export class GetAssetDto implements IGetAssetDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    isPublished: boolean | undefined;
    isLocked: boolean | undefined;
    assetStatus: AssetStatus;
    correlationId: string | undefined;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    unpublishDate: moment.Moment | undefined;
    tenantId: number | undefined;
    steps: AssetFormSteps[] | undefined;
    assetAddress: GetAssetAddressInfoDto;
    assetSoldInfo: GetAssetSoldInfoDto;
    contractInfo: GetContractInfoDto;
    compensationInfo: GetCompensationInfoDto;
    assetFiles: GetAssetFilePathDto[] | undefined;
    assetArea: GetAssetAreaDto;
    assetConfrontation: GetAssetConfrontationDto;
    assetDescription: GetAssetDescriptionDto;
    assetEvaluation: GetAssetEvaluationDto;
    assetIdentification: GetAssetIdentificationDto;
    assetTitleHolder: GetAssetTitleHolderDto;
    assetSchoolInfo: GetAssetSchoolInfoDto;
    assetStructuralInfo: GetStructuralInfoDto;
    assetRoomFeatureSummary: GetAssetRoomInfoDto;
    assetFeature: GetAssetInteriorExteriorFeatureDto;
    assetAssociationInfo: GetAssetAssociationInfoDto;
    assetUnitSummary: GetAssetUnitInfoSummaryDto;
    assetCommercialInfo: GetAssetCommercialInfoDto;
    assetUtility: GetAssetUtilityDto;
    assetRemarks: GetAssetRemarksDto;
    assetOpenHouseSummary: GetAssetOpenHouseSummaryDto;
    assetAdditionalInfo: GetAssetAdditionalInfoDto;
    assetShowingFeedback: GetAssetShowingFeedbackDto;
    assetShowingAgentInstruction: GetAssetShowingAgentInstructionDto;
    assetShowingAccessInfo: GetAssetShowingAccessInfoDto;
    assetShowingSetting: GetAssetShowingSettingDto;
    assetLeaseInfo: GetAssetLeaseInfoDto;
    assetShowingContactSummary: GetAssetShowingContactSummaryDto;
    assetPhotoInfo: GetAssetPhotoDto;

    constructor(data?: IGetAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.systemId = _data["systemId"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.isPublished = _data["isPublished"];
            this.isLocked = _data["isLocked"];
            this.assetStatus = _data["assetStatus"];
            this.correlationId = _data["correlationId"];
            this.businessType = _data["businessType"];
            this.activationStartDate = _data["activationStartDate"] ? moment(_data["activationStartDate"].toString()) : <any>undefined;
            this.activationEndDate = _data["activationEndDate"] ? moment(_data["activationEndDate"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.unpublishDate = _data["unpublishDate"] ? moment(_data["unpublishDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps.push(item);
            }
            this.assetAddress = _data["assetAddress"] ? GetAssetAddressInfoDto.fromJS(_data["assetAddress"]) : <any>undefined;
            this.assetSoldInfo = _data["assetSoldInfo"] ? GetAssetSoldInfoDto.fromJS(_data["assetSoldInfo"]) : <any>undefined;
            this.contractInfo = _data["contractInfo"] ? GetContractInfoDto.fromJS(_data["contractInfo"]) : <any>undefined;
            this.compensationInfo = _data["compensationInfo"] ? GetCompensationInfoDto.fromJS(_data["compensationInfo"]) : <any>undefined;
            if (Array.isArray(_data["assetFiles"])) {
                this.assetFiles = [] as any;
                for (let item of _data["assetFiles"])
                    this.assetFiles.push(GetAssetFilePathDto.fromJS(item));
            }
            this.assetArea = _data["assetArea"] ? GetAssetAreaDto.fromJS(_data["assetArea"]) : <any>undefined;
            this.assetConfrontation = _data["assetConfrontation"] ? GetAssetConfrontationDto.fromJS(_data["assetConfrontation"]) : <any>undefined;
            this.assetDescription = _data["assetDescription"] ? GetAssetDescriptionDto.fromJS(_data["assetDescription"]) : <any>undefined;
            this.assetEvaluation = _data["assetEvaluation"] ? GetAssetEvaluationDto.fromJS(_data["assetEvaluation"]) : <any>undefined;
            this.assetIdentification = _data["assetIdentification"] ? GetAssetIdentificationDto.fromJS(_data["assetIdentification"]) : <any>undefined;
            this.assetTitleHolder = _data["assetTitleHolder"] ? GetAssetTitleHolderDto.fromJS(_data["assetTitleHolder"]) : <any>undefined;
            this.assetSchoolInfo = _data["assetSchoolInfo"] ? GetAssetSchoolInfoDto.fromJS(_data["assetSchoolInfo"]) : <any>undefined;
            this.assetStructuralInfo = _data["assetStructuralInfo"] ? GetStructuralInfoDto.fromJS(_data["assetStructuralInfo"]) : <any>undefined;
            this.assetRoomFeatureSummary = _data["assetRoomFeatureSummary"] ? GetAssetRoomInfoDto.fromJS(_data["assetRoomFeatureSummary"]) : <any>undefined;
            this.assetFeature = _data["assetFeature"] ? GetAssetInteriorExteriorFeatureDto.fromJS(_data["assetFeature"]) : <any>undefined;
            this.assetAssociationInfo = _data["assetAssociationInfo"] ? GetAssetAssociationInfoDto.fromJS(_data["assetAssociationInfo"]) : <any>undefined;
            this.assetUnitSummary = _data["assetUnitSummary"] ? GetAssetUnitInfoSummaryDto.fromJS(_data["assetUnitSummary"]) : <any>undefined;
            this.assetCommercialInfo = _data["assetCommercialInfo"] ? GetAssetCommercialInfoDto.fromJS(_data["assetCommercialInfo"]) : <any>undefined;
            this.assetUtility = _data["assetUtility"] ? GetAssetUtilityDto.fromJS(_data["assetUtility"]) : <any>undefined;
            this.assetRemarks = _data["assetRemarks"] ? GetAssetRemarksDto.fromJS(_data["assetRemarks"]) : <any>undefined;
            this.assetOpenHouseSummary = _data["assetOpenHouseSummary"] ? GetAssetOpenHouseSummaryDto.fromJS(_data["assetOpenHouseSummary"]) : <any>undefined;
            this.assetAdditionalInfo = _data["assetAdditionalInfo"] ? GetAssetAdditionalInfoDto.fromJS(_data["assetAdditionalInfo"]) : <any>undefined;
            this.assetShowingFeedback = _data["assetShowingFeedback"] ? GetAssetShowingFeedbackDto.fromJS(_data["assetShowingFeedback"]) : <any>undefined;
            this.assetShowingAgentInstruction = _data["assetShowingAgentInstruction"] ? GetAssetShowingAgentInstructionDto.fromJS(_data["assetShowingAgentInstruction"]) : <any>undefined;
            this.assetShowingAccessInfo = _data["assetShowingAccessInfo"] ? GetAssetShowingAccessInfoDto.fromJS(_data["assetShowingAccessInfo"]) : <any>undefined;
            this.assetShowingSetting = _data["assetShowingSetting"] ? GetAssetShowingSettingDto.fromJS(_data["assetShowingSetting"]) : <any>undefined;
            this.assetLeaseInfo = _data["assetLeaseInfo"] ? GetAssetLeaseInfoDto.fromJS(_data["assetLeaseInfo"]) : <any>undefined;
            this.assetShowingContactSummary = _data["assetShowingContactSummary"] ? GetAssetShowingContactSummaryDto.fromJS(_data["assetShowingContactSummary"]) : <any>undefined;
            this.assetPhotoInfo = _data["assetPhotoInfo"] ? GetAssetPhotoDto.fromJS(_data["assetPhotoInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["systemId"] = this.systemId;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["isPublished"] = this.isPublished;
        data["isLocked"] = this.isLocked;
        data["assetStatus"] = this.assetStatus;
        data["correlationId"] = this.correlationId;
        data["businessType"] = this.businessType;
        data["activationStartDate"] = this.activationStartDate ? this.activationStartDate.toISOString() : <any>undefined;
        data["activationEndDate"] = this.activationEndDate ? this.activationEndDate.toISOString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["unpublishDate"] = this.unpublishDate ? this.unpublishDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item);
        }
        data["assetAddress"] = this.assetAddress ? this.assetAddress.toJSON() : <any>undefined;
        data["assetSoldInfo"] = this.assetSoldInfo ? this.assetSoldInfo.toJSON() : <any>undefined;
        data["contractInfo"] = this.contractInfo ? this.contractInfo.toJSON() : <any>undefined;
        data["compensationInfo"] = this.compensationInfo ? this.compensationInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.assetFiles)) {
            data["assetFiles"] = [];
            for (let item of this.assetFiles)
                data["assetFiles"].push(item.toJSON());
        }
        data["assetArea"] = this.assetArea ? this.assetArea.toJSON() : <any>undefined;
        data["assetConfrontation"] = this.assetConfrontation ? this.assetConfrontation.toJSON() : <any>undefined;
        data["assetDescription"] = this.assetDescription ? this.assetDescription.toJSON() : <any>undefined;
        data["assetEvaluation"] = this.assetEvaluation ? this.assetEvaluation.toJSON() : <any>undefined;
        data["assetIdentification"] = this.assetIdentification ? this.assetIdentification.toJSON() : <any>undefined;
        data["assetTitleHolder"] = this.assetTitleHolder ? this.assetTitleHolder.toJSON() : <any>undefined;
        data["assetSchoolInfo"] = this.assetSchoolInfo ? this.assetSchoolInfo.toJSON() : <any>undefined;
        data["assetStructuralInfo"] = this.assetStructuralInfo ? this.assetStructuralInfo.toJSON() : <any>undefined;
        data["assetRoomFeatureSummary"] = this.assetRoomFeatureSummary ? this.assetRoomFeatureSummary.toJSON() : <any>undefined;
        data["assetFeature"] = this.assetFeature ? this.assetFeature.toJSON() : <any>undefined;
        data["assetAssociationInfo"] = this.assetAssociationInfo ? this.assetAssociationInfo.toJSON() : <any>undefined;
        data["assetUnitSummary"] = this.assetUnitSummary ? this.assetUnitSummary.toJSON() : <any>undefined;
        data["assetCommercialInfo"] = this.assetCommercialInfo ? this.assetCommercialInfo.toJSON() : <any>undefined;
        data["assetUtility"] = this.assetUtility ? this.assetUtility.toJSON() : <any>undefined;
        data["assetRemarks"] = this.assetRemarks ? this.assetRemarks.toJSON() : <any>undefined;
        data["assetOpenHouseSummary"] = this.assetOpenHouseSummary ? this.assetOpenHouseSummary.toJSON() : <any>undefined;
        data["assetAdditionalInfo"] = this.assetAdditionalInfo ? this.assetAdditionalInfo.toJSON() : <any>undefined;
        data["assetShowingFeedback"] = this.assetShowingFeedback ? this.assetShowingFeedback.toJSON() : <any>undefined;
        data["assetShowingAgentInstruction"] = this.assetShowingAgentInstruction ? this.assetShowingAgentInstruction.toJSON() : <any>undefined;
        data["assetShowingAccessInfo"] = this.assetShowingAccessInfo ? this.assetShowingAccessInfo.toJSON() : <any>undefined;
        data["assetShowingSetting"] = this.assetShowingSetting ? this.assetShowingSetting.toJSON() : <any>undefined;
        data["assetLeaseInfo"] = this.assetLeaseInfo ? this.assetLeaseInfo.toJSON() : <any>undefined;
        data["assetShowingContactSummary"] = this.assetShowingContactSummary ? this.assetShowingContactSummary.toJSON() : <any>undefined;
        data["assetPhotoInfo"] = this.assetPhotoInfo ? this.assetPhotoInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAssetDto {
        const json = this.toJSON();
        let result = new GetAssetDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    isPublished: boolean | undefined;
    isLocked: boolean | undefined;
    assetStatus: AssetStatus;
    correlationId: string | undefined;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    unpublishDate: moment.Moment | undefined;
    tenantId: number | undefined;
    steps: AssetFormSteps[] | undefined;
    assetAddress: GetAssetAddressInfoDto;
    assetSoldInfo: GetAssetSoldInfoDto;
    contractInfo: GetContractInfoDto;
    compensationInfo: GetCompensationInfoDto;
    assetFiles: GetAssetFilePathDto[] | undefined;
    assetArea: GetAssetAreaDto;
    assetConfrontation: GetAssetConfrontationDto;
    assetDescription: GetAssetDescriptionDto;
    assetEvaluation: GetAssetEvaluationDto;
    assetIdentification: GetAssetIdentificationDto;
    assetTitleHolder: GetAssetTitleHolderDto;
    assetSchoolInfo: GetAssetSchoolInfoDto;
    assetStructuralInfo: GetStructuralInfoDto;
    assetRoomFeatureSummary: GetAssetRoomInfoDto;
    assetFeature: GetAssetInteriorExteriorFeatureDto;
    assetAssociationInfo: GetAssetAssociationInfoDto;
    assetUnitSummary: GetAssetUnitInfoSummaryDto;
    assetCommercialInfo: GetAssetCommercialInfoDto;
    assetUtility: GetAssetUtilityDto;
    assetRemarks: GetAssetRemarksDto;
    assetOpenHouseSummary: GetAssetOpenHouseSummaryDto;
    assetAdditionalInfo: GetAssetAdditionalInfoDto;
    assetShowingFeedback: GetAssetShowingFeedbackDto;
    assetShowingAgentInstruction: GetAssetShowingAgentInstructionDto;
    assetShowingAccessInfo: GetAssetShowingAccessInfoDto;
    assetShowingSetting: GetAssetShowingSettingDto;
    assetLeaseInfo: GetAssetLeaseInfoDto;
    assetShowingContactSummary: GetAssetShowingContactSummaryDto;
    assetPhotoInfo: GetAssetPhotoDto;
}

export class GetAssetEvaluationDto implements IGetAssetEvaluationDto {
    id: number;
    matrixEnrollmentYear: string | undefined;
    currentEquityValue: string | undefined;
    yearDetermined: string | undefined;
    locationCoefficientType: string | undefined;
    xCoordinate: string | undefined;
    yCoordinate: string | undefined;
    modOfIMI: string | undefined;
    currentIMIYear: string | undefined;
    deliveryDate: string | undefined;
    evaluationForm: string | undefined;
    evaluationDate: string | undefined;
    otherTaxes: string | undefined;

    constructor(data?: IGetAssetEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matrixEnrollmentYear = _data["matrixEnrollmentYear"];
            this.currentEquityValue = _data["currentEquityValue"];
            this.yearDetermined = _data["yearDetermined"];
            this.locationCoefficientType = _data["locationCoefficientType"];
            this.xCoordinate = _data["xCoordinate"];
            this.yCoordinate = _data["yCoordinate"];
            this.modOfIMI = _data["modOfIMI"];
            this.currentIMIYear = _data["currentIMIYear"];
            this.deliveryDate = _data["deliveryDate"];
            this.evaluationForm = _data["evaluationForm"];
            this.evaluationDate = _data["evaluationDate"];
            this.otherTaxes = _data["otherTaxes"];
        }
    }

    static fromJS(data: any): GetAssetEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matrixEnrollmentYear"] = this.matrixEnrollmentYear;
        data["currentEquityValue"] = this.currentEquityValue;
        data["yearDetermined"] = this.yearDetermined;
        data["locationCoefficientType"] = this.locationCoefficientType;
        data["xCoordinate"] = this.xCoordinate;
        data["yCoordinate"] = this.yCoordinate;
        data["modOfIMI"] = this.modOfIMI;
        data["currentIMIYear"] = this.currentIMIYear;
        data["deliveryDate"] = this.deliveryDate;
        data["evaluationForm"] = this.evaluationForm;
        data["evaluationDate"] = this.evaluationDate;
        data["otherTaxes"] = this.otherTaxes;
        return data; 
    }

    clone(): GetAssetEvaluationDto {
        const json = this.toJSON();
        let result = new GetAssetEvaluationDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetEvaluationDto {
    id: number;
    matrixEnrollmentYear: string | undefined;
    currentEquityValue: string | undefined;
    yearDetermined: string | undefined;
    locationCoefficientType: string | undefined;
    xCoordinate: string | undefined;
    yCoordinate: string | undefined;
    modOfIMI: string | undefined;
    currentIMIYear: string | undefined;
    deliveryDate: string | undefined;
    evaluationForm: string | undefined;
    evaluationDate: string | undefined;
    otherTaxes: string | undefined;
}

export class GetAssetFilePathDto implements IGetAssetFilePathDto {
    name: string | undefined;
    description: string | undefined;
    physicalPath: string | undefined;
    relativePath: string | undefined;
    uniqueId: string | undefined;
    format: string | undefined;

    constructor(data?: IGetAssetFilePathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.physicalPath = _data["physicalPath"];
            this.relativePath = _data["relativePath"];
            this.uniqueId = _data["uniqueId"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): GetAssetFilePathDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetFilePathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["physicalPath"] = this.physicalPath;
        data["relativePath"] = this.relativePath;
        data["uniqueId"] = this.uniqueId;
        data["format"] = this.format;
        return data; 
    }

    clone(): GetAssetFilePathDto {
        const json = this.toJSON();
        let result = new GetAssetFilePathDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetFilePathDto {
    name: string | undefined;
    description: string | undefined;
    physicalPath: string | undefined;
    relativePath: string | undefined;
    uniqueId: string | undefined;
    format: string | undefined;
}

export class GetAssetIdentificationDto implements IGetAssetIdentificationDto {
    id: number;
    matrixArticle: string | undefined;
    nip: string | undefined;
    describedCRP: string | undefined;
    underRegistrationNo: string | undefined;

    constructor(data?: IGetAssetIdentificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matrixArticle = _data["matrixArticle"];
            this.nip = _data["nip"];
            this.describedCRP = _data["describedCRP"];
            this.underRegistrationNo = _data["underRegistrationNo"];
        }
    }

    static fromJS(data: any): GetAssetIdentificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetIdentificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matrixArticle"] = this.matrixArticle;
        data["nip"] = this.nip;
        data["describedCRP"] = this.describedCRP;
        data["underRegistrationNo"] = this.underRegistrationNo;
        return data; 
    }

    clone(): GetAssetIdentificationDto {
        const json = this.toJSON();
        let result = new GetAssetIdentificationDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetIdentificationDto {
    id: number;
    matrixArticle: string | undefined;
    nip: string | undefined;
    describedCRP: string | undefined;
    underRegistrationNo: string | undefined;
}

export class GetAssetInteriorExteriorFeatureDto implements IGetAssetInteriorExteriorFeatureDto {
    id: number;
    interior: string[] | undefined;
    homeAutomation: string[] | undefined;
    appliances: string[] | undefined;
    handicap: string[] | undefined;
    exterior: string[] | undefined;
    nearbyAmenities: string[] | undefined;
    waterFront: string[] | undefined;
    pool: string[] | undefined;

    constructor(data?: IGetAssetInteriorExteriorFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["interior"])) {
                this.interior = [] as any;
                for (let item of _data["interior"])
                    this.interior.push(item);
            }
            if (Array.isArray(_data["homeAutomation"])) {
                this.homeAutomation = [] as any;
                for (let item of _data["homeAutomation"])
                    this.homeAutomation.push(item);
            }
            if (Array.isArray(_data["appliances"])) {
                this.appliances = [] as any;
                for (let item of _data["appliances"])
                    this.appliances.push(item);
            }
            if (Array.isArray(_data["handicap"])) {
                this.handicap = [] as any;
                for (let item of _data["handicap"])
                    this.handicap.push(item);
            }
            if (Array.isArray(_data["exterior"])) {
                this.exterior = [] as any;
                for (let item of _data["exterior"])
                    this.exterior.push(item);
            }
            if (Array.isArray(_data["nearbyAmenities"])) {
                this.nearbyAmenities = [] as any;
                for (let item of _data["nearbyAmenities"])
                    this.nearbyAmenities.push(item);
            }
            if (Array.isArray(_data["waterFront"])) {
                this.waterFront = [] as any;
                for (let item of _data["waterFront"])
                    this.waterFront.push(item);
            }
            if (Array.isArray(_data["pool"])) {
                this.pool = [] as any;
                for (let item of _data["pool"])
                    this.pool.push(item);
            }
        }
    }

    static fromJS(data: any): GetAssetInteriorExteriorFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetInteriorExteriorFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.interior)) {
            data["interior"] = [];
            for (let item of this.interior)
                data["interior"].push(item);
        }
        if (Array.isArray(this.homeAutomation)) {
            data["homeAutomation"] = [];
            for (let item of this.homeAutomation)
                data["homeAutomation"].push(item);
        }
        if (Array.isArray(this.appliances)) {
            data["appliances"] = [];
            for (let item of this.appliances)
                data["appliances"].push(item);
        }
        if (Array.isArray(this.handicap)) {
            data["handicap"] = [];
            for (let item of this.handicap)
                data["handicap"].push(item);
        }
        if (Array.isArray(this.exterior)) {
            data["exterior"] = [];
            for (let item of this.exterior)
                data["exterior"].push(item);
        }
        if (Array.isArray(this.nearbyAmenities)) {
            data["nearbyAmenities"] = [];
            for (let item of this.nearbyAmenities)
                data["nearbyAmenities"].push(item);
        }
        if (Array.isArray(this.waterFront)) {
            data["waterFront"] = [];
            for (let item of this.waterFront)
                data["waterFront"].push(item);
        }
        if (Array.isArray(this.pool)) {
            data["pool"] = [];
            for (let item of this.pool)
                data["pool"].push(item);
        }
        return data; 
    }

    clone(): GetAssetInteriorExteriorFeatureDto {
        const json = this.toJSON();
        let result = new GetAssetInteriorExteriorFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetInteriorExteriorFeatureDto {
    id: number;
    interior: string[] | undefined;
    homeAutomation: string[] | undefined;
    appliances: string[] | undefined;
    handicap: string[] | undefined;
    exterior: string[] | undefined;
    nearbyAmenities: string[] | undefined;
    waterFront: string[] | undefined;
    pool: string[] | undefined;
}

export class GetAssetLeaseInfoDto implements IGetAssetLeaseInfoDto {
    id: number;
    spaceIsLeased: boolean | undefined;
    rentalDuration: RentalDurationType;
    monthsRemainingOnLease: number | undefined;
    landlordRequirements: string[] | undefined;
    dateOfPossessionAvailability: moment.Moment | undefined;
    landlordResponsibality: string[] | undefined;
    monthlyLeaseAmount: number | undefined;
    tenantResponsibality: string[] | undefined;
    securityDepositInfo: string | undefined;
    smokingAllowed: SmokingAllowedType;
    buildoutAllowanceAvailble: BuildoutAllowanceAvailbleType;
    petsAllowed: PetsAllowedType;
    landlordOptions: string | undefined;
    additionalPetInfo: string | undefined;
    listingMlsNumber: string | undefined;
    additionalConditions: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetLeaseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.spaceIsLeased = _data["spaceIsLeased"];
            this.rentalDuration = _data["rentalDuration"];
            this.monthsRemainingOnLease = _data["monthsRemainingOnLease"];
            if (Array.isArray(_data["landlordRequirements"])) {
                this.landlordRequirements = [] as any;
                for (let item of _data["landlordRequirements"])
                    this.landlordRequirements.push(item);
            }
            this.dateOfPossessionAvailability = _data["dateOfPossessionAvailability"] ? moment(_data["dateOfPossessionAvailability"].toString()) : <any>undefined;
            if (Array.isArray(_data["landlordResponsibality"])) {
                this.landlordResponsibality = [] as any;
                for (let item of _data["landlordResponsibality"])
                    this.landlordResponsibality.push(item);
            }
            this.monthlyLeaseAmount = _data["monthlyLeaseAmount"];
            if (Array.isArray(_data["tenantResponsibality"])) {
                this.tenantResponsibality = [] as any;
                for (let item of _data["tenantResponsibality"])
                    this.tenantResponsibality.push(item);
            }
            this.securityDepositInfo = _data["securityDepositInfo"];
            this.smokingAllowed = _data["smokingAllowed"];
            this.buildoutAllowanceAvailble = _data["buildoutAllowanceAvailble"];
            this.petsAllowed = _data["petsAllowed"];
            this.landlordOptions = _data["landlordOptions"];
            this.additionalPetInfo = _data["additionalPetInfo"];
            this.listingMlsNumber = _data["listingMlsNumber"];
            this.additionalConditions = _data["additionalConditions"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetLeaseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetLeaseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["spaceIsLeased"] = this.spaceIsLeased;
        data["rentalDuration"] = this.rentalDuration;
        data["monthsRemainingOnLease"] = this.monthsRemainingOnLease;
        if (Array.isArray(this.landlordRequirements)) {
            data["landlordRequirements"] = [];
            for (let item of this.landlordRequirements)
                data["landlordRequirements"].push(item);
        }
        data["dateOfPossessionAvailability"] = this.dateOfPossessionAvailability ? this.dateOfPossessionAvailability.toISOString() : <any>undefined;
        if (Array.isArray(this.landlordResponsibality)) {
            data["landlordResponsibality"] = [];
            for (let item of this.landlordResponsibality)
                data["landlordResponsibality"].push(item);
        }
        data["monthlyLeaseAmount"] = this.monthlyLeaseAmount;
        if (Array.isArray(this.tenantResponsibality)) {
            data["tenantResponsibality"] = [];
            for (let item of this.tenantResponsibality)
                data["tenantResponsibality"].push(item);
        }
        data["securityDepositInfo"] = this.securityDepositInfo;
        data["smokingAllowed"] = this.smokingAllowed;
        data["buildoutAllowanceAvailble"] = this.buildoutAllowanceAvailble;
        data["petsAllowed"] = this.petsAllowed;
        data["landlordOptions"] = this.landlordOptions;
        data["additionalPetInfo"] = this.additionalPetInfo;
        data["listingMlsNumber"] = this.listingMlsNumber;
        data["additionalConditions"] = this.additionalConditions;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetLeaseInfoDto {
        const json = this.toJSON();
        let result = new GetAssetLeaseInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetLeaseInfoDto {
    id: number;
    spaceIsLeased: boolean | undefined;
    rentalDuration: RentalDurationType;
    monthsRemainingOnLease: number | undefined;
    landlordRequirements: string[] | undefined;
    dateOfPossessionAvailability: moment.Moment | undefined;
    landlordResponsibality: string[] | undefined;
    monthlyLeaseAmount: number | undefined;
    tenantResponsibality: string[] | undefined;
    securityDepositInfo: string | undefined;
    smokingAllowed: SmokingAllowedType;
    buildoutAllowanceAvailble: BuildoutAllowanceAvailbleType;
    petsAllowed: PetsAllowedType;
    landlordOptions: string | undefined;
    additionalPetInfo: string | undefined;
    listingMlsNumber: string | undefined;
    additionalConditions: string | undefined;
    assetId: number;
}

export class GetAssetOpenHouseInfoDto implements IGetAssetOpenHouseInfoDto {
    id: number;
    link: string | undefined;
    description: string | undefined;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    date: moment.Moment | undefined;
    refreshmentType: RefreshmentType;
    openHouseType: OpenHouseType;

    constructor(data?: IGetAssetOpenHouseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.link = _data["link"];
            this.description = _data["description"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.refreshmentType = _data["refreshmentType"];
            this.openHouseType = _data["openHouseType"];
        }
    }

    static fromJS(data: any): GetAssetOpenHouseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetOpenHouseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        data["description"] = this.description;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["refreshmentType"] = this.refreshmentType;
        data["openHouseType"] = this.openHouseType;
        return data; 
    }

    clone(): GetAssetOpenHouseInfoDto {
        const json = this.toJSON();
        let result = new GetAssetOpenHouseInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetOpenHouseInfoDto {
    id: number;
    link: string | undefined;
    description: string | undefined;
    endTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    date: moment.Moment | undefined;
    refreshmentType: RefreshmentType;
    openHouseType: OpenHouseType;
}

export class GetAssetOpenHouseSummaryDto implements IGetAssetOpenHouseSummaryDto {
    id: number;
    isScheduleTour: boolean | undefined;
    assetId: number;
    assetOpenHouseInfos: GetAssetOpenHouseInfoDto[] | undefined;

    constructor(data?: IGetAssetOpenHouseSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isScheduleTour = _data["isScheduleTour"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["assetOpenHouseInfos"])) {
                this.assetOpenHouseInfos = [] as any;
                for (let item of _data["assetOpenHouseInfos"])
                    this.assetOpenHouseInfos.push(GetAssetOpenHouseInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetOpenHouseSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetOpenHouseSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isScheduleTour"] = this.isScheduleTour;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.assetOpenHouseInfos)) {
            data["assetOpenHouseInfos"] = [];
            for (let item of this.assetOpenHouseInfos)
                data["assetOpenHouseInfos"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAssetOpenHouseSummaryDto {
        const json = this.toJSON();
        let result = new GetAssetOpenHouseSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetOpenHouseSummaryDto {
    id: number;
    isScheduleTour: boolean | undefined;
    assetId: number;
    assetOpenHouseInfos: GetAssetOpenHouseInfoDto[] | undefined;
}

export class GetAssetPagedResponseDto implements IGetAssetPagedResponseDto {
    items: GetAssetResponseDto[] | undefined;
    totalCount: number;

    constructor(data?: IGetAssetPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetAssetResponseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetAssetPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): GetAssetPagedResponseDto {
        const json = this.toJSON();
        let result = new GetAssetPagedResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetPagedResponseDto {
    items: GetAssetResponseDto[] | undefined;
    totalCount: number;
}

export class GetAssetPhotoDto implements IGetAssetPhotoDto {
    id: number;
    photographsTakenBy: PhotographsTakenByType;
    photographerMlsId: string | undefined;
    photographerName: string | undefined;
    studioName: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.photographsTakenBy = _data["photographsTakenBy"];
            this.photographerMlsId = _data["photographerMlsId"];
            this.photographerName = _data["photographerName"];
            this.studioName = _data["studioName"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetPhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetPhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["photographsTakenBy"] = this.photographsTakenBy;
        data["photographerMlsId"] = this.photographerMlsId;
        data["photographerName"] = this.photographerName;
        data["studioName"] = this.studioName;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetPhotoDto {
        const json = this.toJSON();
        let result = new GetAssetPhotoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetPhotoDto {
    id: number;
    photographsTakenBy: PhotographsTakenByType;
    photographerMlsId: string | undefined;
    photographerName: string | undefined;
    studioName: string | undefined;
    assetId: number;
}

export class GetAssetRemarksDto implements IGetAssetRemarksDto {
    id: number;
    publicRemarks: string | undefined;
    publicRemarksAddendum: string | undefined;
    confidentialAgentRemarks: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetRemarksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicRemarks = _data["publicRemarks"];
            this.publicRemarksAddendum = _data["publicRemarksAddendum"];
            this.confidentialAgentRemarks = _data["confidentialAgentRemarks"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetRemarksDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetRemarksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicRemarks"] = this.publicRemarks;
        data["publicRemarksAddendum"] = this.publicRemarksAddendum;
        data["confidentialAgentRemarks"] = this.confidentialAgentRemarks;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetRemarksDto {
        const json = this.toJSON();
        let result = new GetAssetRemarksDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetRemarksDto {
    id: number;
    publicRemarks: string | undefined;
    publicRemarksAddendum: string | undefined;
    confidentialAgentRemarks: string | undefined;
    assetId: number;
}

export class GetAssetResponseDto implements IGetAssetResponseDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    unpublishDate: moment.Moment | undefined;
    assetAddress: GetAssetAddressInfoDto;
    contractInfos: GetContractInfoDto;
    assetFiles: GetAssetFilePathDto;

    constructor(data?: IGetAssetResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.systemId = _data["systemId"];
            this.type = _data["type"];
            this.assetStatus = _data["assetStatus"];
            this.businessType = _data["businessType"];
            this.activationStartDate = _data["activationStartDate"] ? moment(_data["activationStartDate"].toString()) : <any>undefined;
            this.activationEndDate = _data["activationEndDate"] ? moment(_data["activationEndDate"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.unpublishDate = _data["unpublishDate"] ? moment(_data["unpublishDate"].toString()) : <any>undefined;
            this.assetAddress = _data["assetAddress"] ? GetAssetAddressInfoDto.fromJS(_data["assetAddress"]) : <any>undefined;
            this.contractInfos = _data["contractInfos"] ? GetContractInfoDto.fromJS(_data["contractInfos"]) : <any>undefined;
            this.assetFiles = _data["assetFiles"] ? GetAssetFilePathDto.fromJS(_data["assetFiles"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["systemId"] = this.systemId;
        data["type"] = this.type;
        data["assetStatus"] = this.assetStatus;
        data["businessType"] = this.businessType;
        data["activationStartDate"] = this.activationStartDate ? this.activationStartDate.toISOString() : <any>undefined;
        data["activationEndDate"] = this.activationEndDate ? this.activationEndDate.toISOString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["unpublishDate"] = this.unpublishDate ? this.unpublishDate.toISOString() : <any>undefined;
        data["assetAddress"] = this.assetAddress ? this.assetAddress.toJSON() : <any>undefined;
        data["contractInfos"] = this.contractInfos ? this.contractInfos.toJSON() : <any>undefined;
        data["assetFiles"] = this.assetFiles ? this.assetFiles.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAssetResponseDto {
        const json = this.toJSON();
        let result = new GetAssetResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetResponseDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    unpublishDate: moment.Moment | undefined;
    assetAddress: GetAssetAddressInfoDto;
    contractInfos: GetContractInfoDto;
    assetFiles: GetAssetFilePathDto;
}

export class GetAssetRoomDto implements IGetAssetRoomDto {
    id: number;
    type: string | undefined;
    roomLevel: string | undefined;
    roomLength: number;
    roomWidth: number;
    features: string[] | undefined;

    constructor(data?: IGetAssetRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.roomLevel = _data["roomLevel"];
            this.roomLength = _data["roomLength"];
            this.roomWidth = _data["roomWidth"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(item);
            }
        }
    }

    static fromJS(data: any): GetAssetRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["roomLevel"] = this.roomLevel;
        data["roomLength"] = this.roomLength;
        data["roomWidth"] = this.roomWidth;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        return data; 
    }

    clone(): GetAssetRoomDto {
        const json = this.toJSON();
        let result = new GetAssetRoomDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetRoomDto {
    id: number;
    type: string | undefined;
    roomLevel: string | undefined;
    roomLength: number;
    roomWidth: number;
    features: string[] | undefined;
}

export class GetAssetRoomInfoDto implements IGetAssetRoomInfoDto {
    id: number;
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBaths: number | undefined;
    numberOfHalfBaths: number | undefined;
    laundaryRoomInfo: string | undefined;
    laundaryLcoation: string | undefined;
    inLawApartmentAccess: string | undefined;
    hasInLawApartment: boolean | undefined;
    assetId: number;
    rooms: GetAssetRoomDto[] | undefined;

    constructor(data?: IGetAssetRoomInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBedRooms = _data["numberOfBedRooms"];
            this.numberOfFullBaths = _data["numberOfFullBaths"];
            this.numberOfHalfBaths = _data["numberOfHalfBaths"];
            this.laundaryRoomInfo = _data["laundaryRoomInfo"];
            this.laundaryLcoation = _data["laundaryLcoation"];
            this.inLawApartmentAccess = _data["inLawApartmentAccess"];
            this.hasInLawApartment = _data["hasInLawApartment"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(GetAssetRoomDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetRoomInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetRoomInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBedRooms"] = this.numberOfBedRooms;
        data["numberOfFullBaths"] = this.numberOfFullBaths;
        data["numberOfHalfBaths"] = this.numberOfHalfBaths;
        data["laundaryRoomInfo"] = this.laundaryRoomInfo;
        data["laundaryLcoation"] = this.laundaryLcoation;
        data["inLawApartmentAccess"] = this.inLawApartmentAccess;
        data["hasInLawApartment"] = this.hasInLawApartment;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAssetRoomInfoDto {
        const json = this.toJSON();
        let result = new GetAssetRoomInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetRoomInfoDto {
    id: number;
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBaths: number | undefined;
    numberOfHalfBaths: number | undefined;
    laundaryRoomInfo: string | undefined;
    laundaryLcoation: string | undefined;
    inLawApartmentAccess: string | undefined;
    hasInLawApartment: boolean | undefined;
    assetId: number;
    rooms: GetAssetRoomDto[] | undefined;
}

export class GetAssetSchoolInfoDto implements IGetAssetSchoolInfoDto {
    id: number;
    elementarySchool: string | undefined;
    middleSchool: string | undefined;
    intermediateSchool: string | undefined;
    highSchool: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetSchoolInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elementarySchool = _data["elementarySchool"];
            this.middleSchool = _data["middleSchool"];
            this.intermediateSchool = _data["intermediateSchool"];
            this.highSchool = _data["highSchool"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetSchoolInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetSchoolInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elementarySchool"] = this.elementarySchool;
        data["middleSchool"] = this.middleSchool;
        data["intermediateSchool"] = this.intermediateSchool;
        data["highSchool"] = this.highSchool;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetSchoolInfoDto {
        const json = this.toJSON();
        let result = new GetAssetSchoolInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetSchoolInfoDto {
    id: number;
    elementarySchool: string | undefined;
    middleSchool: string | undefined;
    intermediateSchool: string | undefined;
    highSchool: string | undefined;
    assetId: number;
}

export class GetAssetShowingAccessInfoDto implements IGetAssetShowingAccessInfoDto {
    id: number;
    isSecureAccessEnabled: boolean | undefined;
    isListingAgentIsRequiedInShowing: boolean | undefined;
    hasAlarm: boolean | undefined;
    accessType: string | undefined;
    accessCode: string | undefined;
    keyLocation: string | undefined;
    showingInstructions: string | undefined;
    alarmCode: string | undefined;
    alarmInstructions: string | undefined;

    constructor(data?: IGetAssetShowingAccessInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSecureAccessEnabled = _data["isSecureAccessEnabled"];
            this.isListingAgentIsRequiedInShowing = _data["isListingAgentIsRequiedInShowing"];
            this.hasAlarm = _data["hasAlarm"];
            this.accessType = _data["accessType"];
            this.accessCode = _data["accessCode"];
            this.keyLocation = _data["keyLocation"];
            this.showingInstructions = _data["showingInstructions"];
            this.alarmCode = _data["alarmCode"];
            this.alarmInstructions = _data["alarmInstructions"];
        }
    }

    static fromJS(data: any): GetAssetShowingAccessInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingAccessInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSecureAccessEnabled"] = this.isSecureAccessEnabled;
        data["isListingAgentIsRequiedInShowing"] = this.isListingAgentIsRequiedInShowing;
        data["hasAlarm"] = this.hasAlarm;
        data["accessType"] = this.accessType;
        data["accessCode"] = this.accessCode;
        data["keyLocation"] = this.keyLocation;
        data["showingInstructions"] = this.showingInstructions;
        data["alarmCode"] = this.alarmCode;
        data["alarmInstructions"] = this.alarmInstructions;
        return data; 
    }

    clone(): GetAssetShowingAccessInfoDto {
        const json = this.toJSON();
        let result = new GetAssetShowingAccessInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingAccessInfoDto {
    id: number;
    isSecureAccessEnabled: boolean | undefined;
    isListingAgentIsRequiedInShowing: boolean | undefined;
    hasAlarm: boolean | undefined;
    accessType: string | undefined;
    accessCode: string | undefined;
    keyLocation: string | undefined;
    showingInstructions: string | undefined;
    alarmCode: string | undefined;
    alarmInstructions: string | undefined;
}

export class GetAssetShowingAgentInstructionDto implements IGetAssetShowingAgentInstructionDto {
    id: number;
    shouldTurnOffLights: boolean | undefined;
    shouldBringAgentLicense: boolean | undefined;
    shouldLeaveBusinessCards: boolean | undefined;
    shouldRemoveShoes: boolean | undefined;
    shouldLockAllDoors: boolean | undefined;
    shouldKnockFirst: boolean | undefined;
    otherInstructions: string | undefined;
    noteForAgent: string | undefined;
    noteForStaff: string | undefined;

    constructor(data?: IGetAssetShowingAgentInstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shouldTurnOffLights = _data["shouldTurnOffLights"];
            this.shouldBringAgentLicense = _data["shouldBringAgentLicense"];
            this.shouldLeaveBusinessCards = _data["shouldLeaveBusinessCards"];
            this.shouldRemoveShoes = _data["shouldRemoveShoes"];
            this.shouldLockAllDoors = _data["shouldLockAllDoors"];
            this.shouldKnockFirst = _data["shouldKnockFirst"];
            this.otherInstructions = _data["otherInstructions"];
            this.noteForAgent = _data["noteForAgent"];
            this.noteForStaff = _data["noteForStaff"];
        }
    }

    static fromJS(data: any): GetAssetShowingAgentInstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingAgentInstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shouldTurnOffLights"] = this.shouldTurnOffLights;
        data["shouldBringAgentLicense"] = this.shouldBringAgentLicense;
        data["shouldLeaveBusinessCards"] = this.shouldLeaveBusinessCards;
        data["shouldRemoveShoes"] = this.shouldRemoveShoes;
        data["shouldLockAllDoors"] = this.shouldLockAllDoors;
        data["shouldKnockFirst"] = this.shouldKnockFirst;
        data["otherInstructions"] = this.otherInstructions;
        data["noteForAgent"] = this.noteForAgent;
        data["noteForStaff"] = this.noteForStaff;
        return data; 
    }

    clone(): GetAssetShowingAgentInstructionDto {
        const json = this.toJSON();
        let result = new GetAssetShowingAgentInstructionDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingAgentInstructionDto {
    id: number;
    shouldTurnOffLights: boolean | undefined;
    shouldBringAgentLicense: boolean | undefined;
    shouldLeaveBusinessCards: boolean | undefined;
    shouldRemoveShoes: boolean | undefined;
    shouldLockAllDoors: boolean | undefined;
    shouldKnockFirst: boolean | undefined;
    otherInstructions: string | undefined;
    noteForAgent: string | undefined;
    noteForStaff: string | undefined;
}

export class GetAssetShowingAvailabilityScheduleDto implements IGetAssetShowingAvailabilityScheduleDto {
    id: number;
    mode: AssetShowingAvailabilityModeType;
    dayOfWeek: DayOfWeek;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: moment.Moment | undefined;
    timeTo: moment.Moment | undefined;
    autoConfirm: boolean | undefined;
    assetId: number;
    assetUnitId: number | undefined;

    constructor(data?: IGetAssetShowingAvailabilityScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mode = _data["mode"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = _data["timeFrom"] ? moment(_data["timeFrom"].toString()) : <any>undefined;
            this.timeTo = _data["timeTo"] ? moment(_data["timeTo"].toString()) : <any>undefined;
            this.autoConfirm = _data["autoConfirm"];
            this.assetId = _data["assetId"];
            this.assetUnitId = _data["assetUnitId"];
        }
    }

    static fromJS(data: any): GetAssetShowingAvailabilityScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingAvailabilityScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mode"] = this.mode;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toISOString() : <any>undefined;
        data["timeTo"] = this.timeTo ? this.timeTo.toISOString() : <any>undefined;
        data["autoConfirm"] = this.autoConfirm;
        data["assetId"] = this.assetId;
        data["assetUnitId"] = this.assetUnitId;
        return data; 
    }

    clone(): GetAssetShowingAvailabilityScheduleDto {
        const json = this.toJSON();
        let result = new GetAssetShowingAvailabilityScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingAvailabilityScheduleDto {
    id: number;
    mode: AssetShowingAvailabilityModeType;
    dayOfWeek: DayOfWeek;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: moment.Moment | undefined;
    timeTo: moment.Moment | undefined;
    autoConfirm: boolean | undefined;
    assetId: number;
    assetUnitId: number | undefined;
}

export class GetAssetShowingContactDto implements IGetAssetShowingContactDto {
    id: number;
    occupantType: OccupantType[] | undefined;
    notificationType: NotificationType[] | undefined;
    requirementType: ContactRequirementType[] | undefined;
    isReceivedFeedbackToBeSent: boolean | undefined;
    isShowingAgentInfoToBeSent: boolean | undefined;
    userContactId: number | undefined;
    userContact: GetUserContactDto;

    constructor(data?: IGetAssetShowingContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["occupantType"])) {
                this.occupantType = [] as any;
                for (let item of _data["occupantType"])
                    this.occupantType.push(item);
            }
            if (Array.isArray(_data["notificationType"])) {
                this.notificationType = [] as any;
                for (let item of _data["notificationType"])
                    this.notificationType.push(item);
            }
            if (Array.isArray(_data["requirementType"])) {
                this.requirementType = [] as any;
                for (let item of _data["requirementType"])
                    this.requirementType.push(item);
            }
            this.isReceivedFeedbackToBeSent = _data["isReceivedFeedbackToBeSent"];
            this.isShowingAgentInfoToBeSent = _data["isShowingAgentInfoToBeSent"];
            this.userContactId = _data["userContactId"];
            this.userContact = _data["userContact"] ? GetUserContactDto.fromJS(_data["userContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetShowingContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.occupantType)) {
            data["occupantType"] = [];
            for (let item of this.occupantType)
                data["occupantType"].push(item);
        }
        if (Array.isArray(this.notificationType)) {
            data["notificationType"] = [];
            for (let item of this.notificationType)
                data["notificationType"].push(item);
        }
        if (Array.isArray(this.requirementType)) {
            data["requirementType"] = [];
            for (let item of this.requirementType)
                data["requirementType"].push(item);
        }
        data["isReceivedFeedbackToBeSent"] = this.isReceivedFeedbackToBeSent;
        data["isShowingAgentInfoToBeSent"] = this.isShowingAgentInfoToBeSent;
        data["userContactId"] = this.userContactId;
        data["userContact"] = this.userContact ? this.userContact.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAssetShowingContactDto {
        const json = this.toJSON();
        let result = new GetAssetShowingContactDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingContactDto {
    id: number;
    occupantType: OccupantType[] | undefined;
    notificationType: NotificationType[] | undefined;
    requirementType: ContactRequirementType[] | undefined;
    isReceivedFeedbackToBeSent: boolean | undefined;
    isShowingAgentInfoToBeSent: boolean | undefined;
    userContactId: number | undefined;
    userContact: GetUserContactDto;
}

export class GetAssetShowingContactSummaryDto implements IGetAssetShowingContactSummaryDto {
    id: number;
    showingType: ShowingType;
    assetId: number;
    assetShowingContacts: GetAssetShowingContactDto[] | undefined;

    constructor(data?: IGetAssetShowingContactSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showingType = _data["showingType"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["assetShowingContacts"])) {
                this.assetShowingContacts = [] as any;
                for (let item of _data["assetShowingContacts"])
                    this.assetShowingContacts.push(GetAssetShowingContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetShowingContactSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingContactSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showingType"] = this.showingType;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.assetShowingContacts)) {
            data["assetShowingContacts"] = [];
            for (let item of this.assetShowingContacts)
                data["assetShowingContacts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAssetShowingContactSummaryDto {
        const json = this.toJSON();
        let result = new GetAssetShowingContactSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingContactSummaryDto {
    id: number;
    showingType: ShowingType;
    assetId: number;
    assetShowingContacts: GetAssetShowingContactDto[] | undefined;
}

export class GetAssetShowingFeedbackDto implements IGetAssetShowingFeedbackDto {
    id: number;
    isShowingFeedbackAllowed: boolean | undefined;
    feedbackTemplate: string | undefined;

    constructor(data?: IGetAssetShowingFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isShowingFeedbackAllowed = _data["isShowingFeedbackAllowed"];
            this.feedbackTemplate = _data["feedbackTemplate"];
        }
    }

    static fromJS(data: any): GetAssetShowingFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isShowingFeedbackAllowed"] = this.isShowingFeedbackAllowed;
        data["feedbackTemplate"] = this.feedbackTemplate;
        return data; 
    }

    clone(): GetAssetShowingFeedbackDto {
        const json = this.toJSON();
        let result = new GetAssetShowingFeedbackDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingFeedbackDto {
    id: number;
    isShowingFeedbackAllowed: boolean | undefined;
    feedbackTemplate: string | undefined;
}

export class GetAssetShowingSettingDto implements IGetAssetShowingSettingDto {
    id: number;
    isShowingOff: boolean | undefined;
    isRealTimeAvaliabilityAllowed: boolean | undefined;
    isSmartShowingConciergeActivated: boolean | undefined;
    isOverlappingShowingAllowed: boolean | undefined;
    isAgentAllowToScheduleShowingOnline: boolean | undefined;
    isOverlappingShowingNotificationToAgentOn: boolean | undefined;
    maxShowingDuration: number | undefined;
    maxOverlapShowing: MaxOverlapShowing;
    minShowingNotice: number | undefined;

    constructor(data?: IGetAssetShowingSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isShowingOff = _data["isShowingOff"];
            this.isRealTimeAvaliabilityAllowed = _data["isRealTimeAvaliabilityAllowed"];
            this.isSmartShowingConciergeActivated = _data["isSmartShowingConciergeActivated"];
            this.isOverlappingShowingAllowed = _data["isOverlappingShowingAllowed"];
            this.isAgentAllowToScheduleShowingOnline = _data["isAgentAllowToScheduleShowingOnline"];
            this.isOverlappingShowingNotificationToAgentOn = _data["isOverlappingShowingNotificationToAgentOn"];
            this.maxShowingDuration = _data["maxShowingDuration"];
            this.maxOverlapShowing = _data["maxOverlapShowing"];
            this.minShowingNotice = _data["minShowingNotice"];
        }
    }

    static fromJS(data: any): GetAssetShowingSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isShowingOff"] = this.isShowingOff;
        data["isRealTimeAvaliabilityAllowed"] = this.isRealTimeAvaliabilityAllowed;
        data["isSmartShowingConciergeActivated"] = this.isSmartShowingConciergeActivated;
        data["isOverlappingShowingAllowed"] = this.isOverlappingShowingAllowed;
        data["isAgentAllowToScheduleShowingOnline"] = this.isAgentAllowToScheduleShowingOnline;
        data["isOverlappingShowingNotificationToAgentOn"] = this.isOverlappingShowingNotificationToAgentOn;
        data["maxShowingDuration"] = this.maxShowingDuration;
        data["maxOverlapShowing"] = this.maxOverlapShowing;
        data["minShowingNotice"] = this.minShowingNotice;
        return data; 
    }

    clone(): GetAssetShowingSettingDto {
        const json = this.toJSON();
        let result = new GetAssetShowingSettingDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingSettingDto {
    id: number;
    isShowingOff: boolean | undefined;
    isRealTimeAvaliabilityAllowed: boolean | undefined;
    isSmartShowingConciergeActivated: boolean | undefined;
    isOverlappingShowingAllowed: boolean | undefined;
    isAgentAllowToScheduleShowingOnline: boolean | undefined;
    isOverlappingShowingNotificationToAgentOn: boolean | undefined;
    maxShowingDuration: number | undefined;
    maxOverlapShowing: MaxOverlapShowing;
    minShowingNotice: number | undefined;
}

export class GetAssetShowingSettingSummaryDto implements IGetAssetShowingSettingSummaryDto {
    assetId: number;
    assetShowingSetting: AssetShowingSettingResponseDto;
    assetShowingAccessInfo: AssetShowingAccessInfoResponseDto;
    assetShowingAgentInstruction: AssetShowingAgentInstructionResponseDto;
    assetShowingFeedback: AssetShowingFeedbackResponseDto;

    constructor(data?: IGetAssetShowingSettingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetShowingSetting = _data["assetShowingSetting"] ? AssetShowingSettingResponseDto.fromJS(_data["assetShowingSetting"]) : <any>undefined;
            this.assetShowingAccessInfo = _data["assetShowingAccessInfo"] ? AssetShowingAccessInfoResponseDto.fromJS(_data["assetShowingAccessInfo"]) : <any>undefined;
            this.assetShowingAgentInstruction = _data["assetShowingAgentInstruction"] ? AssetShowingAgentInstructionResponseDto.fromJS(_data["assetShowingAgentInstruction"]) : <any>undefined;
            this.assetShowingFeedback = _data["assetShowingFeedback"] ? AssetShowingFeedbackResponseDto.fromJS(_data["assetShowingFeedback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetShowingSettingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetShowingSettingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetShowingSetting"] = this.assetShowingSetting ? this.assetShowingSetting.toJSON() : <any>undefined;
        data["assetShowingAccessInfo"] = this.assetShowingAccessInfo ? this.assetShowingAccessInfo.toJSON() : <any>undefined;
        data["assetShowingAgentInstruction"] = this.assetShowingAgentInstruction ? this.assetShowingAgentInstruction.toJSON() : <any>undefined;
        data["assetShowingFeedback"] = this.assetShowingFeedback ? this.assetShowingFeedback.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAssetShowingSettingSummaryDto {
        const json = this.toJSON();
        let result = new GetAssetShowingSettingSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetShowingSettingSummaryDto {
    assetId: number;
    assetShowingSetting: AssetShowingSettingResponseDto;
    assetShowingAccessInfo: AssetShowingAccessInfoResponseDto;
    assetShowingAgentInstruction: AssetShowingAgentInstructionResponseDto;
    assetShowingFeedback: AssetShowingFeedbackResponseDto;
}

export class GetAssetSoldInfoDto implements IGetAssetSoldInfoDto {
    id: number;
    buyerName: string[] | undefined;
    lenderName: string | undefined;
    financeType: FinanceType;
    sellerCredits: number | undefined;
    price: number | undefined;
    downPayment: number | undefined;
    relocatingFrom: AssetSoldIntoAddressDto;
    relocatingTo: AssetSoldIntoAddressDto;
    assetId: number;

    constructor(data?: IGetAssetSoldInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["buyerName"])) {
                this.buyerName = [] as any;
                for (let item of _data["buyerName"])
                    this.buyerName.push(item);
            }
            this.lenderName = _data["lenderName"];
            this.financeType = _data["financeType"];
            this.sellerCredits = _data["sellerCredits"];
            this.price = _data["price"];
            this.downPayment = _data["downPayment"];
            this.relocatingFrom = _data["relocatingFrom"] ? AssetSoldIntoAddressDto.fromJS(_data["relocatingFrom"]) : <any>undefined;
            this.relocatingTo = _data["relocatingTo"] ? AssetSoldIntoAddressDto.fromJS(_data["relocatingTo"]) : <any>undefined;
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetSoldInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetSoldInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.buyerName)) {
            data["buyerName"] = [];
            for (let item of this.buyerName)
                data["buyerName"].push(item);
        }
        data["lenderName"] = this.lenderName;
        data["financeType"] = this.financeType;
        data["sellerCredits"] = this.sellerCredits;
        data["price"] = this.price;
        data["downPayment"] = this.downPayment;
        data["relocatingFrom"] = this.relocatingFrom ? this.relocatingFrom.toJSON() : <any>undefined;
        data["relocatingTo"] = this.relocatingTo ? this.relocatingTo.toJSON() : <any>undefined;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetSoldInfoDto {
        const json = this.toJSON();
        let result = new GetAssetSoldInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetSoldInfoDto {
    id: number;
    buyerName: string[] | undefined;
    lenderName: string | undefined;
    financeType: FinanceType;
    sellerCredits: number | undefined;
    price: number | undefined;
    downPayment: number | undefined;
    relocatingFrom: AssetSoldIntoAddressDto;
    relocatingTo: AssetSoldIntoAddressDto;
    assetId: number;
}

export class GetAssetTitleHolderDto implements IGetAssetTitleHolderDto {
    id: number;
    ownershipType: string | undefined;
    part: string | undefined;
    document: string | undefined;
    entity: string | undefined;
    taxIdentification: string | undefined;
    ownerName: string | undefined;
    ownerAddress: string | undefined;

    constructor(data?: IGetAssetTitleHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownershipType = _data["ownershipType"];
            this.part = _data["part"];
            this.document = _data["document"];
            this.entity = _data["entity"];
            this.taxIdentification = _data["taxIdentification"];
            this.ownerName = _data["ownerName"];
            this.ownerAddress = _data["ownerAddress"];
        }
    }

    static fromJS(data: any): GetAssetTitleHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetTitleHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownershipType"] = this.ownershipType;
        data["part"] = this.part;
        data["document"] = this.document;
        data["entity"] = this.entity;
        data["taxIdentification"] = this.taxIdentification;
        data["ownerName"] = this.ownerName;
        data["ownerAddress"] = this.ownerAddress;
        return data; 
    }

    clone(): GetAssetTitleHolderDto {
        const json = this.toJSON();
        let result = new GetAssetTitleHolderDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetTitleHolderDto {
    id: number;
    ownershipType: string | undefined;
    part: string | undefined;
    document: string | undefined;
    entity: string | undefined;
    taxIdentification: string | undefined;
    ownerName: string | undefined;
    ownerAddress: string | undefined;
}

export class GetAssetUnitInfoForDropDownDto implements IGetAssetUnitInfoForDropDownDto {
    id: number;
    value: string | undefined;

    constructor(data?: IGetAssetUnitInfoForDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetAssetUnitInfoForDropDownDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetUnitInfoForDropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }

    clone(): GetAssetUnitInfoForDropDownDto {
        const json = this.toJSON();
        let result = new GetAssetUnitInfoForDropDownDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetUnitInfoForDropDownDto {
    id: number;
    value: string | undefined;
}

export class GetAssetUnitInfoSummaryDto implements IGetAssetUnitInfoSummaryDto {
    id: number;
    numberOfUnits: number | undefined;
    laundaryLocation: string | undefined;
    assetId: number;
    units: AssetUnitResponseDto[] | undefined;

    constructor(data?: IGetAssetUnitInfoSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberOfUnits = _data["numberOfUnits"];
            this.laundaryLocation = _data["laundaryLocation"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units.push(AssetUnitResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetUnitInfoSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetUnitInfoSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfUnits"] = this.numberOfUnits;
        data["laundaryLocation"] = this.laundaryLocation;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAssetUnitInfoSummaryDto {
        const json = this.toJSON();
        let result = new GetAssetUnitInfoSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetUnitInfoSummaryDto {
    id: number;
    numberOfUnits: number | undefined;
    laundaryLocation: string | undefined;
    assetId: number;
    units: AssetUnitResponseDto[] | undefined;
}

export class GetAssetUtilityDto implements IGetAssetUtilityDto {
    id: number;
    coolingType: string | undefined;
    heatingType: string | undefined;
    heatingFuel: string | undefined;
    hotWaterSystem: string | undefined;
    waterSource: string | undefined;
    estimatedAnnualWaterCost: number | undefined;
    sewerSource: string | undefined;
    estimatedAnnualSewerCost: number | undefined;
    hasAirRadonMitigationSystem: string | undefined;
    hasWaterRadonMitigationSystem: string | undefined;
    energyCertificate: string | undefined;
    solarSystem: string | undefined;
    energyFeatures: string[] | undefined;
    solarContractDetails: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetUtilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coolingType = _data["coolingType"];
            this.heatingType = _data["heatingType"];
            this.heatingFuel = _data["heatingFuel"];
            this.hotWaterSystem = _data["hotWaterSystem"];
            this.waterSource = _data["waterSource"];
            this.estimatedAnnualWaterCost = _data["estimatedAnnualWaterCost"];
            this.sewerSource = _data["sewerSource"];
            this.estimatedAnnualSewerCost = _data["estimatedAnnualSewerCost"];
            this.hasAirRadonMitigationSystem = _data["hasAirRadonMitigationSystem"];
            this.hasWaterRadonMitigationSystem = _data["hasWaterRadonMitigationSystem"];
            this.energyCertificate = _data["energyCertificate"];
            this.solarSystem = _data["solarSystem"];
            if (Array.isArray(_data["energyFeatures"])) {
                this.energyFeatures = [] as any;
                for (let item of _data["energyFeatures"])
                    this.energyFeatures.push(item);
            }
            this.solarContractDetails = _data["solarContractDetails"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetUtilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetUtilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coolingType"] = this.coolingType;
        data["heatingType"] = this.heatingType;
        data["heatingFuel"] = this.heatingFuel;
        data["hotWaterSystem"] = this.hotWaterSystem;
        data["waterSource"] = this.waterSource;
        data["estimatedAnnualWaterCost"] = this.estimatedAnnualWaterCost;
        data["sewerSource"] = this.sewerSource;
        data["estimatedAnnualSewerCost"] = this.estimatedAnnualSewerCost;
        data["hasAirRadonMitigationSystem"] = this.hasAirRadonMitigationSystem;
        data["hasWaterRadonMitigationSystem"] = this.hasWaterRadonMitigationSystem;
        data["energyCertificate"] = this.energyCertificate;
        data["solarSystem"] = this.solarSystem;
        if (Array.isArray(this.energyFeatures)) {
            data["energyFeatures"] = [];
            for (let item of this.energyFeatures)
                data["energyFeatures"].push(item);
        }
        data["solarContractDetails"] = this.solarContractDetails;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetUtilityDto {
        const json = this.toJSON();
        let result = new GetAssetUtilityDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetUtilityDto {
    id: number;
    coolingType: string | undefined;
    heatingType: string | undefined;
    heatingFuel: string | undefined;
    hotWaterSystem: string | undefined;
    waterSource: string | undefined;
    estimatedAnnualWaterCost: number | undefined;
    sewerSource: string | undefined;
    estimatedAnnualSewerCost: number | undefined;
    hasAirRadonMitigationSystem: string | undefined;
    hasWaterRadonMitigationSystem: string | undefined;
    energyCertificate: string | undefined;
    solarSystem: string | undefined;
    energyFeatures: string[] | undefined;
    solarContractDetails: string | undefined;
    assetId: number;
}

export class GetAssetVirtualTourDto implements IGetAssetVirtualTourDto {
    id: number;
    isFreeVirtualTour: boolean | undefined;
    brandedVirtualTourURL: string | undefined;
    unbrandedVirtualTourURL: string | undefined;
    additionalVirtualTourURL: string | undefined;
    videoURL: string | undefined;
    assetId: number;

    constructor(data?: IGetAssetVirtualTourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isFreeVirtualTour = _data["isFreeVirtualTour"];
            this.brandedVirtualTourURL = _data["brandedVirtualTourURL"];
            this.unbrandedVirtualTourURL = _data["unbrandedVirtualTourURL"];
            this.additionalVirtualTourURL = _data["additionalVirtualTourURL"];
            this.videoURL = _data["videoURL"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetAssetVirtualTourDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetVirtualTourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isFreeVirtualTour"] = this.isFreeVirtualTour;
        data["brandedVirtualTourURL"] = this.brandedVirtualTourURL;
        data["unbrandedVirtualTourURL"] = this.unbrandedVirtualTourURL;
        data["additionalVirtualTourURL"] = this.additionalVirtualTourURL;
        data["videoURL"] = this.videoURL;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetAssetVirtualTourDto {
        const json = this.toJSON();
        let result = new GetAssetVirtualTourDto();
        result.init(json);
        return result;
    }
}

export interface IGetAssetVirtualTourDto {
    id: number;
    isFreeVirtualTour: boolean | undefined;
    brandedVirtualTourURL: string | undefined;
    unbrandedVirtualTourURL: string | undefined;
    additionalVirtualTourURL: string | undefined;
    videoURL: string | undefined;
    assetId: number;
}

export class GetCompensationInfoDto implements IGetCompensationInfoDto {
    id: number;
    commissionType: CommissionType;
    note: string | undefined;
    compensation: number | undefined;
    assetId: number;

    constructor(data?: IGetCompensationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commissionType = _data["commissionType"];
            this.note = _data["note"];
            this.compensation = _data["compensation"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetCompensationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompensationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commissionType"] = this.commissionType;
        data["note"] = this.note;
        data["compensation"] = this.compensation;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetCompensationInfoDto {
        const json = this.toJSON();
        let result = new GetCompensationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetCompensationInfoDto {
    id: number;
    commissionType: CommissionType;
    note: string | undefined;
    compensation: number | undefined;
    assetId: number;
}

export class GetContractInfoDto implements IGetContractInfoDto {
    id: number;
    price: number | undefined;
    priceCycle: PriceCycle;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    contractType: ContractType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    signedDate: moment.Moment | undefined;
    expectedCloseDate: moment.Moment | undefined;
    title: string | undefined;
    assetId: number;

    constructor(data?: IGetContractInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.priceCycle = _data["priceCycle"];
            this.assetStatus = _data["assetStatus"];
            this.businessType = _data["businessType"];
            this.contractType = _data["contractType"];
            this.activationStartDate = _data["activationStartDate"] ? moment(_data["activationStartDate"].toString()) : <any>undefined;
            this.activationEndDate = _data["activationEndDate"] ? moment(_data["activationEndDate"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.signedDate = _data["signedDate"] ? moment(_data["signedDate"].toString()) : <any>undefined;
            this.expectedCloseDate = _data["expectedCloseDate"] ? moment(_data["expectedCloseDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetContractInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["priceCycle"] = this.priceCycle;
        data["assetStatus"] = this.assetStatus;
        data["businessType"] = this.businessType;
        data["contractType"] = this.contractType;
        data["activationStartDate"] = this.activationStartDate ? this.activationStartDate.toISOString() : <any>undefined;
        data["activationEndDate"] = this.activationEndDate ? this.activationEndDate.toISOString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["signedDate"] = this.signedDate ? this.signedDate.toISOString() : <any>undefined;
        data["expectedCloseDate"] = this.expectedCloseDate ? this.expectedCloseDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetContractInfoDto {
        const json = this.toJSON();
        let result = new GetContractInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetContractInfoDto {
    id: number;
    price: number | undefined;
    priceCycle: PriceCycle;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    contractType: ContractType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    signedDate: moment.Moment | undefined;
    expectedCloseDate: moment.Moment | undefined;
    title: string | undefined;
    assetId: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetLandRecordInfoDto implements IGetLandRecordInfoDto {
    assetId: number;
    assetArea: GetAssetAreaDto;
    assetConfrontation: GetAssetConfrontationDto;
    assetDescription: GetAssetDescriptionDto;
    assetEvaluation: GetAssetEvaluationDto;
    assetIdentification: GetAssetIdentificationDto;
    assetTitleHolder: GetAssetTitleHolderDto;

    constructor(data?: IGetLandRecordInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetArea = _data["assetArea"] ? GetAssetAreaDto.fromJS(_data["assetArea"]) : <any>undefined;
            this.assetConfrontation = _data["assetConfrontation"] ? GetAssetConfrontationDto.fromJS(_data["assetConfrontation"]) : <any>undefined;
            this.assetDescription = _data["assetDescription"] ? GetAssetDescriptionDto.fromJS(_data["assetDescription"]) : <any>undefined;
            this.assetEvaluation = _data["assetEvaluation"] ? GetAssetEvaluationDto.fromJS(_data["assetEvaluation"]) : <any>undefined;
            this.assetIdentification = _data["assetIdentification"] ? GetAssetIdentificationDto.fromJS(_data["assetIdentification"]) : <any>undefined;
            this.assetTitleHolder = _data["assetTitleHolder"] ? GetAssetTitleHolderDto.fromJS(_data["assetTitleHolder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLandRecordInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLandRecordInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetArea"] = this.assetArea ? this.assetArea.toJSON() : <any>undefined;
        data["assetConfrontation"] = this.assetConfrontation ? this.assetConfrontation.toJSON() : <any>undefined;
        data["assetDescription"] = this.assetDescription ? this.assetDescription.toJSON() : <any>undefined;
        data["assetEvaluation"] = this.assetEvaluation ? this.assetEvaluation.toJSON() : <any>undefined;
        data["assetIdentification"] = this.assetIdentification ? this.assetIdentification.toJSON() : <any>undefined;
        data["assetTitleHolder"] = this.assetTitleHolder ? this.assetTitleHolder.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetLandRecordInfoDto {
        const json = this.toJSON();
        let result = new GetLandRecordInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetLandRecordInfoDto {
    assetId: number;
    assetArea: GetAssetAreaDto;
    assetConfrontation: GetAssetConfrontationDto;
    assetDescription: GetAssetDescriptionDto;
    assetEvaluation: GetAssetEvaluationDto;
    assetIdentification: GetAssetIdentificationDto;
    assetTitleHolder: GetAssetTitleHolderDto;
}

export class GetMarketPulseHistoryResponseDto implements IGetMarketPulseHistoryResponseDto {
    id: number;
    area: AreaType;
    propertyType: PropertyType;
    backDays: MarketPulseDaysCount;

    constructor(data?: IGetMarketPulseHistoryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.area = _data["area"];
            this.propertyType = _data["propertyType"];
            this.backDays = _data["backDays"];
        }
    }

    static fromJS(data: any): GetMarketPulseHistoryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketPulseHistoryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["area"] = this.area;
        data["propertyType"] = this.propertyType;
        data["backDays"] = this.backDays;
        return data; 
    }

    clone(): GetMarketPulseHistoryResponseDto {
        const json = this.toJSON();
        let result = new GetMarketPulseHistoryResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetMarketPulseHistoryResponseDto {
    id: number;
    area: AreaType;
    propertyType: PropertyType;
    backDays: MarketPulseDaysCount;
}

export class GetMyBusinessResponseDto implements IGetMyBusinessResponseDto {
    myBusiness: { [key: string]: number; } | undefined;

    constructor(data?: IGetMyBusinessResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["myBusiness"]) {
                this.myBusiness = {} as any;
                for (let key in _data["myBusiness"]) {
                    if (_data["myBusiness"].hasOwnProperty(key))
                        (<any>this.myBusiness)[key] = _data["myBusiness"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetMyBusinessResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyBusinessResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.myBusiness) {
            data["myBusiness"] = {};
            for (let key in this.myBusiness) {
                if (this.myBusiness.hasOwnProperty(key))
                    (<any>data["myBusiness"])[key] = this.myBusiness[key];
            }
        }
        return data; 
    }

    clone(): GetMyBusinessResponseDto {
        const json = this.toJSON();
        let result = new GetMyBusinessResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetMyBusinessResponseDto {
    myBusiness: { [key: string]: number; } | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetSearchHistoryResponseDto implements IGetSearchHistoryResponseDto {
    id: number;
    searchText: string | undefined;
    listingStatus: AssetStatus;
    businessType: BusinessType;
    propertyType: PropertyType;
    businessSubPropertyType: BusinessSubPropertyType;
    landSubPropertyType: LandSubPropertyType;
    residentialSubPropertyType: ResidentialSubPropertyType;
    price: number | undefined;
    isSaved: boolean | undefined;
    userId: number;

    constructor(data?: IGetSearchHistoryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchText = _data["searchText"];
            this.listingStatus = _data["listingStatus"];
            this.businessType = _data["businessType"];
            this.propertyType = _data["propertyType"];
            this.businessSubPropertyType = _data["businessSubPropertyType"];
            this.landSubPropertyType = _data["landSubPropertyType"];
            this.residentialSubPropertyType = _data["residentialSubPropertyType"];
            this.price = _data["price"];
            this.isSaved = _data["isSaved"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetSearchHistoryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchHistoryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchText"] = this.searchText;
        data["listingStatus"] = this.listingStatus;
        data["businessType"] = this.businessType;
        data["propertyType"] = this.propertyType;
        data["businessSubPropertyType"] = this.businessSubPropertyType;
        data["landSubPropertyType"] = this.landSubPropertyType;
        data["residentialSubPropertyType"] = this.residentialSubPropertyType;
        data["price"] = this.price;
        data["isSaved"] = this.isSaved;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): GetSearchHistoryResponseDto {
        const json = this.toJSON();
        let result = new GetSearchHistoryResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetSearchHistoryResponseDto {
    id: number;
    searchText: string | undefined;
    listingStatus: AssetStatus;
    businessType: BusinessType;
    propertyType: PropertyType;
    businessSubPropertyType: BusinessSubPropertyType;
    landSubPropertyType: LandSubPropertyType;
    residentialSubPropertyType: ResidentialSubPropertyType;
    price: number | undefined;
    isSaved: boolean | undefined;
    userId: number;
}

export class GetStructuralInfoDto implements IGetStructuralInfoDto {
    id: number;
    levelsInBuilding: number | undefined;
    unitLevel: number | undefined;
    unitsInBuilding: number | undefined;
    unitsInComplex: number | undefined;
    yearBuilt: number | undefined;
    numberOfCarsInGarages: number | undefined;
    numberOfCarsInUncoveredParking: number | undefined;
    type: string | undefined;
    subType: string | undefined;
    interior: string | undefined;
    condition: string | undefined;
    construction: string | undefined;
    roof: string | undefined;
    foundation: string | undefined;
    storage: string | undefined;
    exterior: string | undefined;
    driveway: string | undefined;
    attic: string | undefined;
    basement: string | undefined;
    garages: string | undefined;
    assetId: number;

    constructor(data?: IGetStructuralInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelsInBuilding = _data["levelsInBuilding"];
            this.unitLevel = _data["unitLevel"];
            this.unitsInBuilding = _data["unitsInBuilding"];
            this.unitsInComplex = _data["unitsInComplex"];
            this.yearBuilt = _data["yearBuilt"];
            this.numberOfCarsInGarages = _data["numberOfCarsInGarages"];
            this.numberOfCarsInUncoveredParking = _data["numberOfCarsInUncoveredParking"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.interior = _data["interior"];
            this.condition = _data["condition"];
            this.construction = _data["construction"];
            this.roof = _data["roof"];
            this.foundation = _data["foundation"];
            this.storage = _data["storage"];
            this.exterior = _data["exterior"];
            this.driveway = _data["driveway"];
            this.attic = _data["attic"];
            this.basement = _data["basement"];
            this.garages = _data["garages"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GetStructuralInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStructuralInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelsInBuilding"] = this.levelsInBuilding;
        data["unitLevel"] = this.unitLevel;
        data["unitsInBuilding"] = this.unitsInBuilding;
        data["unitsInComplex"] = this.unitsInComplex;
        data["yearBuilt"] = this.yearBuilt;
        data["numberOfCarsInGarages"] = this.numberOfCarsInGarages;
        data["numberOfCarsInUncoveredParking"] = this.numberOfCarsInUncoveredParking;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["interior"] = this.interior;
        data["condition"] = this.condition;
        data["construction"] = this.construction;
        data["roof"] = this.roof;
        data["foundation"] = this.foundation;
        data["storage"] = this.storage;
        data["exterior"] = this.exterior;
        data["driveway"] = this.driveway;
        data["attic"] = this.attic;
        data["basement"] = this.basement;
        data["garages"] = this.garages;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): GetStructuralInfoDto {
        const json = this.toJSON();
        let result = new GetStructuralInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGetStructuralInfoDto {
    id: number;
    levelsInBuilding: number | undefined;
    unitLevel: number | undefined;
    unitsInBuilding: number | undefined;
    unitsInComplex: number | undefined;
    yearBuilt: number | undefined;
    numberOfCarsInGarages: number | undefined;
    numberOfCarsInUncoveredParking: number | undefined;
    type: string | undefined;
    subType: string | undefined;
    interior: string | undefined;
    condition: string | undefined;
    construction: string | undefined;
    roof: string | undefined;
    foundation: string | undefined;
    storage: string | undefined;
    exterior: string | undefined;
    driveway: string | undefined;
    attic: string | undefined;
    basement: string | undefined;
    garages: string | undefined;
    assetId: number;
}

export class GetUserContactDto implements IGetUserContactDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    spouse: string | undefined;
    note: string | undefined;
    isEmailNotificationRequired: boolean | undefined;
    isCallNotificationRequired: boolean | undefined;
    isTextNotificationRequired: boolean | undefined;
    isWhatsappNotificationRequired: boolean | undefined;
    contactType: ContactType;
    contactStatus: ContactStatus;
    leadSource: LeadSource;
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IGetUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.spouse = _data["spouse"];
            this.note = _data["note"];
            this.isEmailNotificationRequired = _data["isEmailNotificationRequired"];
            this.isCallNotificationRequired = _data["isCallNotificationRequired"];
            this.isTextNotificationRequired = _data["isTextNotificationRequired"];
            this.isWhatsappNotificationRequired = _data["isWhatsappNotificationRequired"];
            this.contactType = _data["contactType"];
            this.contactStatus = _data["contactStatus"];
            this.leadSource = _data["leadSource"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetUserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["spouse"] = this.spouse;
        data["note"] = this.note;
        data["isEmailNotificationRequired"] = this.isEmailNotificationRequired;
        data["isCallNotificationRequired"] = this.isCallNotificationRequired;
        data["isTextNotificationRequired"] = this.isTextNotificationRequired;
        data["isWhatsappNotificationRequired"] = this.isWhatsappNotificationRequired;
        data["contactType"] = this.contactType;
        data["contactStatus"] = this.contactStatus;
        data["leadSource"] = this.leadSource;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): GetUserContactDto {
        const json = this.toJSON();
        let result = new GetUserContactDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserContactDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    spouse: string | undefined;
    note: string | undefined;
    isEmailNotificationRequired: boolean | undefined;
    isCallNotificationRequired: boolean | undefined;
    isTextNotificationRequired: boolean | undefined;
    isWhatsappNotificationRequired: boolean | undefined;
    contactType: ContactType;
    contactStatus: ContactStatus;
    leadSource: LeadSource;
    tenantId: number | undefined;
    userId: number;
}

export class HOAAmenitiesTypesDto implements IHOAAmenitiesTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IHOAAmenitiesTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HOAAmenitiesTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new HOAAmenitiesTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): HOAAmenitiesTypesDto {
        const json = this.toJSON();
        let result = new HOAAmenitiesTypesDto();
        result.init(json);
        return result;
    }
}

export interface IHOAAmenitiesTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class HOARestrictionTypesDto implements IHOARestrictionTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IHOARestrictionTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HOARestrictionTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new HOARestrictionTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): HOARestrictionTypesDto {
        const json = this.toJSON();
        let result = new HOARestrictionTypesDto();
        result.init(json);
        return result;
    }
}

export interface IHOARestrictionTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class InsertAssetFileDto implements IInsertAssetFileDto {
    name: string | undefined;
    description: string | undefined;
    physicalPath: string | undefined;
    relativePath: string | undefined;
    uniqueId: string | undefined;
    format: string | undefined;
    type: FileType;
    assetId: number;

    constructor(data?: IInsertAssetFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.physicalPath = _data["physicalPath"];
            this.relativePath = _data["relativePath"];
            this.uniqueId = _data["uniqueId"];
            this.format = _data["format"];
            this.type = _data["type"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): InsertAssetFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsertAssetFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["physicalPath"] = this.physicalPath;
        data["relativePath"] = this.relativePath;
        data["uniqueId"] = this.uniqueId;
        data["format"] = this.format;
        data["type"] = this.type;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): InsertAssetFileDto {
        const json = this.toJSON();
        let result = new InsertAssetFileDto();
        result.init(json);
        return result;
    }
}

export interface IInsertAssetFileDto {
    name: string | undefined;
    description: string | undefined;
    physicalPath: string | undefined;
    relativePath: string | undefined;
    uniqueId: string | undefined;
    format: string | undefined;
    type: FileType;
    assetId: number;
}

export class InsertAssetFileResponseDto implements IInsertAssetFileResponseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    uniqueId: string | undefined;
    format: string | undefined;
    physicalPath: string | undefined;
    relativePath: string | undefined;
    type: FileType;
    assetId: number;

    constructor(data?: IInsertAssetFileResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.uniqueId = _data["uniqueId"];
            this.format = _data["format"];
            this.physicalPath = _data["physicalPath"];
            this.relativePath = _data["relativePath"];
            this.type = _data["type"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): InsertAssetFileResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsertAssetFileResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["uniqueId"] = this.uniqueId;
        data["format"] = this.format;
        data["physicalPath"] = this.physicalPath;
        data["relativePath"] = this.relativePath;
        data["type"] = this.type;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): InsertAssetFileResponseDto {
        const json = this.toJSON();
        let result = new InsertAssetFileResponseDto();
        result.init(json);
        return result;
    }
}

export interface IInsertAssetFileResponseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    uniqueId: string | undefined;
    format: string | undefined;
    physicalPath: string | undefined;
    relativePath: string | undefined;
    type: FileType;
    assetId: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class InteriorExteriorFeatureLookupDto implements IInteriorExteriorFeatureLookupDto {
    id: number;
    name: string | undefined;
    type: InteriorExteriorFeatureLookupType;

    constructor(data?: IInteriorExteriorFeatureLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InteriorExteriorFeatureLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorExteriorFeatureLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }

    clone(): InteriorExteriorFeatureLookupDto {
        const json = this.toJSON();
        let result = new InteriorExteriorFeatureLookupDto();
        result.init(json);
        return result;
    }
}

export interface IInteriorExteriorFeatureLookupDto {
    id: number;
    name: string | undefined;
    type: InteriorExteriorFeatureLookupType;
}

export enum InteriorExteriorFeatureLookupType {
    None = <any>"None",
    Interior = <any>"Interior",
    Handicap = <any>"Handicap",
    HomeAutomation = <any>"HomeAutomation",
    WaterFront = <any>"WaterFront",
    NearAmenities = <any>"NearAmenities",
    LotDescription = <any>"LotDescription",
    Pool = <any>"Pool",
    Exterior = <any>"Exterior",
    Appliance = <any>"Appliance"
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export enum LandSubPropertyType {
    None = <any>"None",
    LandRustic = <any>"LandRustic",
    LandUrban = <any>"LandUrban",
    LandIndustrial = <any>"LandIndustrial",
    LandCommercial = <any>"LandCommercial",
    Farm = <any>"Farm",
    VineYard = <any>"VineYard",
}

export class LandlordRequirementsTypeLookupDto implements ILandlordRequirementsTypeLookupDto {
    id: number;
    name: string | undefined;

    constructor(data?: ILandlordRequirementsTypeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LandlordRequirementsTypeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LandlordRequirementsTypeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): LandlordRequirementsTypeLookupDto {
        const json = this.toJSON();
        let result = new LandlordRequirementsTypeLookupDto();
        result.init(json);
        return result;
    }
}

export interface ILandlordRequirementsTypeLookupDto {
    id: number;
    name: string | undefined;
}

export class LaundryRoomTypesDto implements ILaundryRoomTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: ILaundryRoomTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LaundryRoomTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaundryRoomTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): LaundryRoomTypesDto {
        const json = this.toJSON();
        let result = new LaundryRoomTypesDto();
        result.init(json);
        return result;
    }
}

export interface ILaundryRoomTypesDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export enum LeadSource {
    None = <any>"None",
}

export enum LeaseType {
    None = <any>"None",
    Monthly = <any>"Monthly",
    Lease = <any>"Lease",
}

export enum MarketPulseDaysCount {
    AllTime = <any>"AllTime",
    OneDay = <any>"OneDay",
    SevenDays = <any>"SevenDays",
    FifteenDays = <any>"FifteenDays",
    ThirtyDays = <any>"ThirtyDays",
}

export class MarketPulseDto implements IMarketPulseDto {
    area: AreaType;
    propertyType: PropertyType;
    backDays: MarketPulseDaysCount;

    constructor(data?: IMarketPulseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.area = _data["area"];
            this.propertyType = _data["propertyType"];
            this.backDays = _data["backDays"];
        }
    }

    static fromJS(data: any): MarketPulseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketPulseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["propertyType"] = this.propertyType;
        data["backDays"] = this.backDays;
        return data; 
    }

    clone(): MarketPulseDto {
        const json = this.toJSON();
        let result = new MarketPulseDto();
        result.init(json);
        return result;
    }
}

export interface IMarketPulseDto {
    area: AreaType;
    propertyType: PropertyType;
    backDays: MarketPulseDaysCount;
}

export class MarketPulseResponceDto implements IMarketPulseResponceDto {
    commingSoon: number;
    commingSoonAvgPrice: number;
    new: number;
    newAvgPrice: number;
    active: number;
    activeAvgPrice: number;
    temporary: number;
    temporaryAvgPrice: number;
    underContract: number;
    underContractAvgPrice: number;
    closed: number;
    closedAvgPrice: number;
    withDrawn: number;
    withDrawnAvgPrice: number;
    cancelled: number;
    cancelledAvgPrice: number;
    expired: number;
    expiredAvgPrice: number;
    avgValuationEstimate: number;
    absorptionRate: number;

    constructor(data?: IMarketPulseResponceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commingSoon = _data["commingSoon"];
            this.commingSoonAvgPrice = _data["commingSoonAvgPrice"];
            this.new = _data["new"];
            this.newAvgPrice = _data["newAvgPrice"];
            this.active = _data["active"];
            this.activeAvgPrice = _data["activeAvgPrice"];
            this.temporary = _data["temporary"];
            this.temporaryAvgPrice = _data["temporaryAvgPrice"];
            this.underContract = _data["underContract"];
            this.underContractAvgPrice = _data["underContractAvgPrice"];
            this.closed = _data["closed"];
            this.closedAvgPrice = _data["closedAvgPrice"];
            this.withDrawn = _data["withDrawn"];
            this.withDrawnAvgPrice = _data["withDrawnAvgPrice"];
            this.cancelled = _data["cancelled"];
            this.cancelledAvgPrice = _data["cancelledAvgPrice"];
            this.expired = _data["expired"];
            this.expiredAvgPrice = _data["expiredAvgPrice"];
            this.avgValuationEstimate = _data["avgValuationEstimate"];
            this.absorptionRate = _data["absorptionRate"];
        }
    }

    static fromJS(data: any): MarketPulseResponceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketPulseResponceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commingSoon"] = this.commingSoon;
        data["commingSoonAvgPrice"] = this.commingSoonAvgPrice;
        data["new"] = this.new;
        data["newAvgPrice"] = this.newAvgPrice;
        data["active"] = this.active;
        data["activeAvgPrice"] = this.activeAvgPrice;
        data["temporary"] = this.temporary;
        data["temporaryAvgPrice"] = this.temporaryAvgPrice;
        data["underContract"] = this.underContract;
        data["underContractAvgPrice"] = this.underContractAvgPrice;
        data["closed"] = this.closed;
        data["closedAvgPrice"] = this.closedAvgPrice;
        data["withDrawn"] = this.withDrawn;
        data["withDrawnAvgPrice"] = this.withDrawnAvgPrice;
        data["cancelled"] = this.cancelled;
        data["cancelledAvgPrice"] = this.cancelledAvgPrice;
        data["expired"] = this.expired;
        data["expiredAvgPrice"] = this.expiredAvgPrice;
        data["avgValuationEstimate"] = this.avgValuationEstimate;
        data["absorptionRate"] = this.absorptionRate;
        return data; 
    }

    clone(): MarketPulseResponceDto {
        const json = this.toJSON();
        let result = new MarketPulseResponceDto();
        result.init(json);
        return result;
    }
}

export interface IMarketPulseResponceDto {
    commingSoon: number;
    commingSoonAvgPrice: number;
    new: number;
    newAvgPrice: number;
    active: number;
    activeAvgPrice: number;
    temporary: number;
    temporaryAvgPrice: number;
    underContract: number;
    underContractAvgPrice: number;
    closed: number;
    closedAvgPrice: number;
    withDrawn: number;
    withDrawnAvgPrice: number;
    cancelled: number;
    cancelledAvgPrice: number;
    expired: number;
    expiredAvgPrice: number;
    avgValuationEstimate: number;
    absorptionRate: number;
}

export enum MaxOverlapShowing {
    None = <any>"None",
    Two = <any>"Two",
    Three = <any>"Three",
    Four = <any>"Four",
    Five = <any>"Five",
    Unlimited = <any>"Unlimited",
}

export class MunicipalityLookupDto implements IMunicipalityLookupDto {
    id: number;
    name: string | undefined;

    constructor(data?: IMunicipalityLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MunicipalityLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MunicipalityLookupDto {
        const json = this.toJSON();
        let result = new MunicipalityLookupDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityLookupDto {
    id: number;
    name: string | undefined;
}

export enum NotificationType {
    None = <any>"None",
    ConfirmOrCancelAppointment = <any>"ConfirmOrCancelAppointment",
    SendFYI = <any>"SendFYI",
    NoNotifications = <any>"NoNotifications",
}

export enum OccupantType {
    None = <any>"None",
    Owner = <any>"Owner",
    Tenant = <any>"Tenant",
    Vacant = <any>"Vacant",
}

export enum OccupiedByType {
    None = <any>"None",
    Owner = <any>"Owner",
    Tenant = <any>"Tenant",
    Vacant = <any>"Vacant",
    Other = <any>"Other",
}

export enum OpenHouseType {
    None = <any>"None",
    PublicOpenHouse = <any>"PublicOpenHouse",
    LiveStreamOpenHouse = <any>"LiveStreamOpenHouse",
    BrokerTour = <any>"BrokerTour",
    LiveStreamBrokerTour = <any>"LiveStreamBrokerTour",
}

export enum OwnershipType {
    None = <any>"None",
    FullOwnership = <any>"FullOwnership",
    Freehold = <any>"Freehold",
    Leasehold = <any>"Leasehold",
    FractionalOwnership = <any>"FractionalOwnership",
    Comdominium = <any>"Comdominium",
    Cooperative = <any>"Cooperative",
    Timeshare = <any>"Timeshare",
    LandLease = <any>"LandLease",
}

export class ParishLookupDto implements IParishLookupDto {
    id: number;
    name: string | undefined;

    constructor(data?: IParishLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ParishLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParishLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): ParishLookupDto {
        const json = this.toJSON();
        let result = new ParishLookupDto();
        result.init(json);
        return result;
    }
}

export interface IParishLookupDto {
    id: number;
    name: string | undefined;
}

export enum PaymentFrequency {
    None = <any>"None",
    OneTime = <any>"OneTime",
    Monthly = <any>"Monthly",
    Quarterly = <any>"Quarterly",
    Annually = <any>"Annually",
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export enum PetsAllowedType {
    None = <any>"None",
    Yes = <any>"Yes",
    No = <any>"No",
    Negotiable = <any>"Negotiable",
}

export enum PhotographsTakenByType {
    None = <any>"None",
    Unknown = <any>"Unknown",
    MLSVerifiedPhotographer = <any>"MLSVerifiedPhotographer",
    Seller = <any>"Seller",
    Self = <any>"Self",
    Other = <any>"Other",
    BrokerAuthorizedPhotographer = <any>"BrokerAuthorizedPhotographer",
}

export enum PriceCycle {
    None = <any>"None",
    Week = <any>"Week",
    Month = <any>"Month",
    Year = <any>"Year",
}

export enum PropertyAccessType {
    None = <any>"None",
    CombinationLockBox = <any>"CombinationLockBox",
    Keypad = <any>"Keypad",
    ListingAgentWillMeet = <any>"ListingAgentWillMeet",
    ListingAgentWillProvideInstructions = <any>"ListingAgentWillProvideInstructions",
    OccupantWillMeet = <any>"OccupantWillMeet",
    OtherWillProvideAccess = <any>"OtherWillProvideAccess",
    OwnerWillMeet = <any>"OwnerWillMeet",
    Other = <any>"Other",
}

export enum PropertyManagementType {
    None = <any>"None",
    ProfessionalOnSite = <any>"ProfessionalOnSite",
    ProfessionalOffSite = <any>"ProfessionalOffSite",
    UnitOwnersAsociation = <any>"UnitOwnersAsociation",
}

export enum PropertyType {
    None = <any>"None",
    Building = <any>"Building",
    Business = <any>"Business",
    Commercial = <any>"Commercial",
    Garages = <any>"Garages",
    Industrial = <any>"Industrial",
    Land = <any>"Land",
    Office = <any>"Office",
    Residential = <any>"Residential",
    Rooms = <any>"Rooms",
    Stores = <any>"Stores",
    Storage = <any>"Storage",
    Warehouses = <any>"Warehouses",
    Venture = <any>"Venture",
}

export class QuestionDto implements IQuestionDto {
    id: number;
    questionText: string | undefined;
    type: QuestionType;
    threshold: number | undefined;
    choices: ChoiceDto[] | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionText = _data["questionText"];
            this.type = _data["type"];
            this.threshold = _data["threshold"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices.push(ChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionText"] = this.questionText;
        data["type"] = this.type;
        data["threshold"] = this.threshold;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data; 
    }

    clone(): QuestionDto {
        const json = this.toJSON();
        let result = new QuestionDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionDto {
    id: number;
    questionText: string | undefined;
    type: QuestionType;
    threshold: number | undefined;
    choices: ChoiceDto[] | undefined;
}

export enum QuestionType {
    None = <any>"None",
    MultipleChoice = <any>"MultipleChoice",
    SimpleText = <any>"SimpleText",
    Rating = <any>"Rating",
}

export enum RefreshmentType {
    None = <any>"None",
    LunchProvided = <any>"LunchProvided",
    RefreshmentProvided = <any>"RefreshmentProvided",
}

export class RegionLookupDto implements IRegionLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    isIsland: boolean;

    constructor(data?: IRegionLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isIsland = _data["isIsland"];
        }
    }

    static fromJS(data: any): RegionLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isIsland"] = this.isIsland;
        return data; 
    }

    clone(): RegionLookupDto {
        const json = this.toJSON();
        let result = new RegionLookupDto();
        result.init(json);
        return result;
    }
}

export interface IRegionLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    isIsland: boolean;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export enum RentalDurationType {
    None = <any>"None",
    OneYear = <any>"OneYear",
    TwoYears = <any>"TwoYears",
    ThreeYears = <any>"ThreeYears",
    FourYears = <any>"FourYears",
    FiveYears = <any>"FiveYears",
    TenYears = <any>"TenYears",
    FlexibleLeaseTerms = <any>"FlexibleLeaseTerms",
    MonthtoMonth = <any>"MonthtoMonth",
    Negotiable = <any>"Negotiable",
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export enum ResidentialSubPropertyType {
    None = <any>"None",
    Apartment = <any>"Apartment",
    Castle = <any>"Castle",
    Duplex = <any>"Duplex",
    Estate = <any>"Estate",
    ResidentialWithBusiness = <any>"ResidentialWithBusiness",
    IsolatedVila = <any>"IsolatedVila",
    TownHouseVila = <any>"TownHouseVila",
    SemiDetachedVila = <any>"SemiDetachedVila",
    PrivateIceland = <any>"PrivateIceland",
}

export class ResponsibilityLookupDto implements IResponsibilityLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IResponsibilityLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ResponsibilityLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsibilityLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): ResponsibilityLookupDto {
        const json = this.toJSON();
        let result = new ResponsibilityLookupDto();
        result.init(json);
        return result;
    }
}

export interface IResponsibilityLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class RoadFrontageLookupDto implements IRoadFrontageLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IRoadFrontageLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoadFrontageLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadFrontageLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): RoadFrontageLookupDto {
        const json = this.toJSON();
        let result = new RoadFrontageLookupDto();
        result.init(json);
        return result;
    }
}

export interface IRoadFrontageLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RoomFeatureLookupDto implements IRoomFeatureLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IRoomFeatureLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoomFeatureLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomFeatureLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): RoomFeatureLookupDto {
        const json = this.toJSON();
        let result = new RoomFeatureLookupDto();
        result.init(json);
        return result;
    }
}

export interface IRoomFeatureLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class RoomTypeLookupDto implements IRoomTypeLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IRoomTypeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoomTypeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomTypeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): RoomTypeLookupDto {
        const json = this.toJSON();
        let result = new RoomTypeLookupDto();
        result.init(json);
        return result;
    }
}

export interface IRoomTypeLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class SearchDto implements ISearchDto {
    id: number;
    searchText: string | undefined;
    listingStatus: AssetStatus;
    businessType: BusinessType;
    propertyType: PropertyType;
    businessSubPropertyType: BusinessSubPropertyType;
    landSubPropertyType: LandSubPropertyType;
    residentialSubPropertyType: ResidentialSubPropertyType;
    price: number | undefined;

    constructor(data?: ISearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchText = _data["searchText"];
            this.listingStatus = _data["listingStatus"];
            this.businessType = _data["businessType"];
            this.propertyType = _data["propertyType"];
            this.businessSubPropertyType = _data["businessSubPropertyType"];
            this.landSubPropertyType = _data["landSubPropertyType"];
            this.residentialSubPropertyType = _data["residentialSubPropertyType"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): SearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchText"] = this.searchText;
        data["listingStatus"] = this.listingStatus;
        data["businessType"] = this.businessType;
        data["propertyType"] = this.propertyType;
        data["businessSubPropertyType"] = this.businessSubPropertyType;
        data["landSubPropertyType"] = this.landSubPropertyType;
        data["residentialSubPropertyType"] = this.residentialSubPropertyType;
        data["price"] = this.price;
        return data; 
    }

    clone(): SearchDto {
        const json = this.toJSON();
        let result = new SearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchDto {
    id: number;
    searchText: string | undefined;
    listingStatus: AssetStatus;
    businessType: BusinessType;
    propertyType: PropertyType;
    businessSubPropertyType: BusinessSubPropertyType;
    landSubPropertyType: LandSubPropertyType;
    residentialSubPropertyType: ResidentialSubPropertyType;
    price: number | undefined;
}

export class SearchResponseDto implements ISearchResponseDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    soldDate: moment.Moment | undefined;
    assetAddress: GetAddressInfoProjection;

    constructor(data?: ISearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.systemId = _data["systemId"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.assetStatus = _data["assetStatus"];
            this.businessType = _data["businessType"];
            this.activationStartDate = _data["activationStartDate"] ? moment(_data["activationStartDate"].toString()) : <any>undefined;
            this.activationEndDate = _data["activationEndDate"] ? moment(_data["activationEndDate"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.soldDate = _data["soldDate"] ? moment(_data["soldDate"].toString()) : <any>undefined;
            this.assetAddress = _data["assetAddress"] ? GetAddressInfoProjection.fromJS(_data["assetAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["systemId"] = this.systemId;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["assetStatus"] = this.assetStatus;
        data["businessType"] = this.businessType;
        data["activationStartDate"] = this.activationStartDate ? this.activationStartDate.toISOString() : <any>undefined;
        data["activationEndDate"] = this.activationEndDate ? this.activationEndDate.toISOString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["soldDate"] = this.soldDate ? this.soldDate.toISOString() : <any>undefined;
        data["assetAddress"] = this.assetAddress ? this.assetAddress.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SearchResponseDto {
        const json = this.toJSON();
        let result = new SearchResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISearchResponseDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    soldDate: moment.Moment | undefined;
    assetAddress: GetAddressInfoProjection;
}

export enum ShowingType {
    None = <any>"None",
    AppointmentRequiredConfirmWithAny = <any>"AppointmentRequiredConfirmWithAny",
    AppointmentRequiredConfirmWithAll = <any>"AppointmentRequiredConfirmWithAll",
    CourtesyCall = <any>"CourtesyCall",
    GoAndShow = <any>"GoAndShow",
    ReferToListingAgent = <any>"ReferToListingAgent",
}

export class SignupDto implements ISignupDto {
    firstName: string | undefined;
    lastName: string | undefined;
    licenseNumber: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    markets: string | undefined;
    availabilitySlots: AvailabilitySlotDto[] | undefined;
    companies: CompanyDto[] | undefined;

    constructor(data?: ISignupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.licenseNumber = _data["licenseNumber"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.markets = _data["markets"];
            if (Array.isArray(_data["availabilitySlots"])) {
                this.availabilitySlots = [] as any;
                for (let item of _data["availabilitySlots"])
                    this.availabilitySlots.push(AvailabilitySlotDto.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies.push(CompanyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["licenseNumber"] = this.licenseNumber;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["markets"] = this.markets;
        if (Array.isArray(this.availabilitySlots)) {
            data["availabilitySlots"] = [];
            for (let item of this.availabilitySlots)
                data["availabilitySlots"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SignupDto {
        const json = this.toJSON();
        let result = new SignupDto();
        result.init(json);
        return result;
    }
}

export interface ISignupDto {
    firstName: string | undefined;
    lastName: string | undefined;
    licenseNumber: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    markets: string | undefined;
    availabilitySlots: AvailabilitySlotDto[] | undefined;
    companies: CompanyDto[] | undefined;
}

export enum SmokingAllowedType {
    None = <any>"None",
    Yes = <any>"Yes",
    No = <any>"No",
    Negotiable = <any>"Negotiable",
}

export enum SoldInfoAddressType {
    None = <any>"None",
    RelocatingFrom = <any>"RelocatingFrom",
    RelocatingTo = <any>"RelocatingTo",
}

export class StructuralLookupDto implements IStructuralLookupDto {
    id: number;
    name: string | undefined;
    type: StructureLookupType;

    constructor(data?: IStructuralLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): StructuralLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }

    clone(): StructuralLookupDto {
        const json = this.toJSON();
        let result = new StructuralLookupDto();
        result.init(json);
        return result;
    }
}

export interface IStructuralLookupDto {
    id: number;
    name: string | undefined;
    type: StructureLookupType;
}

export enum StructureLookupType {
    None = <any>"None",
    Interior = <any>"Interior",
    Construction = <any>"Construction",
    Foundation = <any>"Foundation",
    Roof = <any>"Roof",
    Attic = <any>"Attic",
    Basement = <any>"Basement",
    Garages = <any>"Garages",
    Exterior = <any>"Exterior",
    Driveway = <any>"Driveway",
    Condition = <any>"Condition",
    Storage = <any>"Storage",
}

export enum SunExposeSides {
    None = <any>"None",
    North = <any>"North",
    South = <any>"South",
    East = <any>"East",
    West = <any>"West",
    NorthEast = <any>"NorthEast",
    SouthEast = <any>"SouthEast",
    SouthWest = <any>"SouthWest",
    NorthWest = <any>"NorthWest",
}

export enum TenantAvailabilityState {
    Available = <any>"Available",
    InActive = <any>"InActive",
    NotFound = <any>"NotFound",
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class UnitFeatureLookupDto implements IUnitFeatureLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IUnitFeatureLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UnitFeatureLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitFeatureLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): UnitFeatureLookupDto {
        const json = this.toJSON();
        let result = new UnitFeatureLookupDto();
        result.init(json);
        return result;
    }
}

export interface IUnitFeatureLookupDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class UpdateAssetBusinessTypeDto implements IUpdateAssetBusinessTypeDto {
    id: number;
    businessType: BusinessType;

    constructor(data?: IUpdateAssetBusinessTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessType = _data["businessType"];
        }
    }

    static fromJS(data: any): UpdateAssetBusinessTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetBusinessTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessType"] = this.businessType;
        return data; 
    }

    clone(): UpdateAssetBusinessTypeDto {
        const json = this.toJSON();
        let result = new UpdateAssetBusinessTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetBusinessTypeDto {
    id: number;
    businessType: BusinessType;
}

export class UpdateAssetFileDescriptionDto implements IUpdateAssetFileDescriptionDto {
    description: string | undefined;
    uniqueId: string | undefined;

    constructor(data?: IUpdateAssetFileDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): UpdateAssetFileDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetFileDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["uniqueId"] = this.uniqueId;
        return data; 
    }

    clone(): UpdateAssetFileDescriptionDto {
        const json = this.toJSON();
        let result = new UpdateAssetFileDescriptionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetFileDescriptionDto {
    description: string | undefined;
    uniqueId: string | undefined;
}

export class UpdateAssetPublishStatusDto implements IUpdateAssetPublishStatusDto {
    assetId: number;
    isPublished: boolean;

    constructor(data?: IUpdateAssetPublishStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): UpdateAssetPublishStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetPublishStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["isPublished"] = this.isPublished;
        return data; 
    }

    clone(): UpdateAssetPublishStatusDto {
        const json = this.toJSON();
        let result = new UpdateAssetPublishStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetPublishStatusDto {
    assetId: number;
    isPublished: boolean;
}

export class UpdateAssetStatusDto implements IUpdateAssetStatusDto {
    id: number;
    assetStatus: AssetStatus;

    constructor(data?: IUpdateAssetStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetStatus = _data["assetStatus"];
        }
    }

    static fromJS(data: any): UpdateAssetStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetStatus"] = this.assetStatus;
        return data; 
    }

    clone(): UpdateAssetStatusDto {
        const json = this.toJSON();
        let result = new UpdateAssetStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetStatusDto {
    id: number;
    assetStatus: AssetStatus;
}

export class UpdateAssetTitleDto implements IUpdateAssetTitleDto {
    id: number;
    title: string | undefined;

    constructor(data?: IUpdateAssetTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateAssetTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data; 
    }

    clone(): UpdateAssetTitleDto {
        const json = this.toJSON();
        let result = new UpdateAssetTitleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetTitleDto {
    id: number;
    title: string | undefined;
}

export class UpdateAssetTypeDto implements IUpdateAssetTypeDto {
    id: number;
    type: string | undefined;
    subtype: string | undefined;

    constructor(data?: IUpdateAssetTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.subtype = _data["subtype"];
        }
    }

    static fromJS(data: any): UpdateAssetTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["subtype"] = this.subtype;
        return data; 
    }

    clone(): UpdateAssetTypeDto {
        const json = this.toJSON();
        let result = new UpdateAssetTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetTypeDto {
    id: number;
    type: string | undefined;
    subtype: string | undefined;
}

export class UpsertAddressInfoDto implements IUpsertAddressInfoDto {
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    departmentName: string | undefined;
    sunExposure: SunExposeSides;
    assetId: number;

    constructor(data?: IUpsertAddressInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.intermunicipalCommunities = _data["intermunicipalCommunities"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.zone = _data["zone"];
            this.streetType = _data["streetType"];
            this.streetName = _data["streetName"];
            this.doorNumber = _data["doorNumber"];
            this.floorNumber = _data["floorNumber"];
            this.doorIdentifier = _data["doorIdentifier"];
            this.unitNumber = _data["unitNumber"];
            this.floorLevel = _data["floorLevel"];
            this.zipcode = _data["zipcode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.departmentName = _data["departmentName"];
            this.sunExposure = _data["sunExposure"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAddressInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAddressInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["intermunicipalCommunities"] = this.intermunicipalCommunities;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["zone"] = this.zone;
        data["streetType"] = this.streetType;
        data["streetName"] = this.streetName;
        data["doorNumber"] = this.doorNumber;
        data["floorNumber"] = this.floorNumber;
        data["doorIdentifier"] = this.doorIdentifier;
        data["unitNumber"] = this.unitNumber;
        data["floorLevel"] = this.floorLevel;
        data["zipcode"] = this.zipcode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["departmentName"] = this.departmentName;
        data["sunExposure"] = this.sunExposure;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAddressInfoDto {
        const json = this.toJSON();
        let result = new UpsertAddressInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAddressInfoDto {
    region: string | undefined;
    intermunicipalCommunities: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    departmentName: string | undefined;
    sunExposure: SunExposeSides;
    assetId: number;
}

export class UpsertAssetAdditionalInfoDto implements IUpsertAssetAdditionalInfoDto {
    displayAddressOnInternet: boolean | undefined;
    acceptableFinancing: AcceptableFinancingType;
    displayListingOnIdxWebsite: boolean | undefined;
    occupiedBy: OccupiedByType;
    propertyHasForSaleSign: boolean | undefined;
    anyPropertyOwnerIsARealEstateLicensee: boolean | undefined;
    possession: moment.Moment | undefined;
    relatedMlsNumbers: string[] | undefined;
    bankOwnedOrControlledProperty: boolean | undefined;
    propertyTitle: string | undefined;
    directions: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetAdditionalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayAddressOnInternet = _data["displayAddressOnInternet"];
            this.acceptableFinancing = _data["acceptableFinancing"];
            this.displayListingOnIdxWebsite = _data["displayListingOnIdxWebsite"];
            this.occupiedBy = _data["occupiedBy"];
            this.propertyHasForSaleSign = _data["propertyHasForSaleSign"];
            this.anyPropertyOwnerIsARealEstateLicensee = _data["anyPropertyOwnerIsARealEstateLicensee"];
            this.possession = _data["possession"] ? moment(_data["possession"].toString()) : <any>undefined;
            if (Array.isArray(_data["relatedMlsNumbers"])) {
                this.relatedMlsNumbers = [] as any;
                for (let item of _data["relatedMlsNumbers"])
                    this.relatedMlsNumbers.push(item);
            }
            this.bankOwnedOrControlledProperty = _data["bankOwnedOrControlledProperty"];
            this.propertyTitle = _data["propertyTitle"];
            this.directions = _data["directions"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetAdditionalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetAdditionalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayAddressOnInternet"] = this.displayAddressOnInternet;
        data["acceptableFinancing"] = this.acceptableFinancing;
        data["displayListingOnIdxWebsite"] = this.displayListingOnIdxWebsite;
        data["occupiedBy"] = this.occupiedBy;
        data["propertyHasForSaleSign"] = this.propertyHasForSaleSign;
        data["anyPropertyOwnerIsARealEstateLicensee"] = this.anyPropertyOwnerIsARealEstateLicensee;
        data["possession"] = this.possession ? this.possession.toISOString() : <any>undefined;
        if (Array.isArray(this.relatedMlsNumbers)) {
            data["relatedMlsNumbers"] = [];
            for (let item of this.relatedMlsNumbers)
                data["relatedMlsNumbers"].push(item);
        }
        data["bankOwnedOrControlledProperty"] = this.bankOwnedOrControlledProperty;
        data["propertyTitle"] = this.propertyTitle;
        data["directions"] = this.directions;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetAdditionalInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetAdditionalInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetAdditionalInfoDto {
    displayAddressOnInternet: boolean | undefined;
    acceptableFinancing: AcceptableFinancingType;
    displayListingOnIdxWebsite: boolean | undefined;
    occupiedBy: OccupiedByType;
    propertyHasForSaleSign: boolean | undefined;
    anyPropertyOwnerIsARealEstateLicensee: boolean | undefined;
    possession: moment.Moment | undefined;
    relatedMlsNumbers: string[] | undefined;
    bankOwnedOrControlledProperty: boolean | undefined;
    propertyTitle: string | undefined;
    directions: string | undefined;
    assetId: number;
}

export class UpsertAssetAssociationInfoDto implements IUpsertAssetAssociationInfoDto {
    fees: number | undefined;
    paymentFrequency: PaymentFrequency;
    restrictions: string[] | undefined;
    amenities: string[] | undefined;
    feeProvides: string[] | undefined;
    propertyManagementType: PropertyManagementType;
    managementCompanyName: string | undefined;
    propertyManagerName: string | undefined;
    managerPhone: string | undefined;
    managementCompanyPhone: string | undefined;
    managementEmail: string | undefined;
    specialAssociationDetails: string | undefined;
    isHOA: boolean | undefined;
    isSpecialAssociationAssessments: boolean | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetAssociationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fees = _data["fees"];
            this.paymentFrequency = _data["paymentFrequency"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions.push(item);
            }
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities.push(item);
            }
            if (Array.isArray(_data["feeProvides"])) {
                this.feeProvides = [] as any;
                for (let item of _data["feeProvides"])
                    this.feeProvides.push(item);
            }
            this.propertyManagementType = _data["propertyManagementType"];
            this.managementCompanyName = _data["managementCompanyName"];
            this.propertyManagerName = _data["propertyManagerName"];
            this.managerPhone = _data["managerPhone"];
            this.managementCompanyPhone = _data["managementCompanyPhone"];
            this.managementEmail = _data["managementEmail"];
            this.specialAssociationDetails = _data["specialAssociationDetails"];
            this.isHOA = _data["isHOA"];
            this.isSpecialAssociationAssessments = _data["isSpecialAssociationAssessments"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetAssociationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetAssociationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fees"] = this.fees;
        data["paymentFrequency"] = this.paymentFrequency;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item);
        }
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item);
        }
        if (Array.isArray(this.feeProvides)) {
            data["feeProvides"] = [];
            for (let item of this.feeProvides)
                data["feeProvides"].push(item);
        }
        data["propertyManagementType"] = this.propertyManagementType;
        data["managementCompanyName"] = this.managementCompanyName;
        data["propertyManagerName"] = this.propertyManagerName;
        data["managerPhone"] = this.managerPhone;
        data["managementCompanyPhone"] = this.managementCompanyPhone;
        data["managementEmail"] = this.managementEmail;
        data["specialAssociationDetails"] = this.specialAssociationDetails;
        data["isHOA"] = this.isHOA;
        data["isSpecialAssociationAssessments"] = this.isSpecialAssociationAssessments;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetAssociationInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetAssociationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetAssociationInfoDto {
    fees: number | undefined;
    paymentFrequency: PaymentFrequency;
    restrictions: string[] | undefined;
    amenities: string[] | undefined;
    feeProvides: string[] | undefined;
    propertyManagementType: PropertyManagementType;
    managementCompanyName: string | undefined;
    propertyManagerName: string | undefined;
    managerPhone: string | undefined;
    managementCompanyPhone: string | undefined;
    managementEmail: string | undefined;
    specialAssociationDetails: string | undefined;
    isHOA: boolean | undefined;
    isSpecialAssociationAssessments: boolean | undefined;
    assetId: number;
}

export class UpsertAssetCommercialInfoDto implements IUpsertAssetCommercialInfoDto {
    potentialUse: string | undefined;
    presentUser: string | undefined;
    location: string | undefined;
    availableDocuments: string | undefined;
    disabilityCompliant: DisabilityCompliantState;
    trafficCount: number | undefined;
    industrialArea: number | undefined;
    rentalArea: number | undefined;
    officeArea: number | undefined;
    warehouseArea: number | undefined;
    ceilingArea: number | undefined;
    roadFrontageArea: number | undefined;
    roadFrontageDescription: string | undefined;
    garageParkingType: string | undefined;
    numberOfRestRooms: number | undefined;
    numberOfStories: number | undefined;
    numberOfLoadingDocks: number | undefined;
    numberOfOverheadDoors: number | undefined;
    coveredParkingSpaces: number | undefined;
    uncoveredParkingSpaces: number | undefined;
    additionalSpaceAvailable: boolean | undefined;
    spaceIsDividlable: boolean | undefined;
    businessIncluded: BusinessIncludedState;
    numberOfTenants: number | undefined;
    businessIncludedItems: string | undefined;
    commercialFeatures: string[] | undefined;
    grossAnnaulIncome: number | undefined;
    grossAnnaulExpenses: number | undefined;
    netOperationIncome: number | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetCommercialInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.potentialUse = _data["potentialUse"];
            this.presentUser = _data["presentUser"];
            this.location = _data["location"];
            this.availableDocuments = _data["availableDocuments"];
            this.disabilityCompliant = _data["disabilityCompliant"];
            this.trafficCount = _data["trafficCount"];
            this.industrialArea = _data["industrialArea"];
            this.rentalArea = _data["rentalArea"];
            this.officeArea = _data["officeArea"];
            this.warehouseArea = _data["warehouseArea"];
            this.ceilingArea = _data["ceilingArea"];
            this.roadFrontageArea = _data["roadFrontageArea"];
            this.roadFrontageDescription = _data["roadFrontageDescription"];
            this.garageParkingType = _data["garageParkingType"];
            this.numberOfRestRooms = _data["numberOfRestRooms"];
            this.numberOfStories = _data["numberOfStories"];
            this.numberOfLoadingDocks = _data["numberOfLoadingDocks"];
            this.numberOfOverheadDoors = _data["numberOfOverheadDoors"];
            this.coveredParkingSpaces = _data["coveredParkingSpaces"];
            this.uncoveredParkingSpaces = _data["uncoveredParkingSpaces"];
            this.additionalSpaceAvailable = _data["additionalSpaceAvailable"];
            this.spaceIsDividlable = _data["spaceIsDividlable"];
            this.businessIncluded = _data["businessIncluded"];
            this.numberOfTenants = _data["numberOfTenants"];
            this.businessIncludedItems = _data["businessIncludedItems"];
            if (Array.isArray(_data["commercialFeatures"])) {
                this.commercialFeatures = [] as any;
                for (let item of _data["commercialFeatures"])
                    this.commercialFeatures.push(item);
            }
            this.grossAnnaulIncome = _data["grossAnnaulIncome"];
            this.grossAnnaulExpenses = _data["grossAnnaulExpenses"];
            this.netOperationIncome = _data["netOperationIncome"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetCommercialInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetCommercialInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialUse"] = this.potentialUse;
        data["presentUser"] = this.presentUser;
        data["location"] = this.location;
        data["availableDocuments"] = this.availableDocuments;
        data["disabilityCompliant"] = this.disabilityCompliant;
        data["trafficCount"] = this.trafficCount;
        data["industrialArea"] = this.industrialArea;
        data["rentalArea"] = this.rentalArea;
        data["officeArea"] = this.officeArea;
        data["warehouseArea"] = this.warehouseArea;
        data["ceilingArea"] = this.ceilingArea;
        data["roadFrontageArea"] = this.roadFrontageArea;
        data["roadFrontageDescription"] = this.roadFrontageDescription;
        data["garageParkingType"] = this.garageParkingType;
        data["numberOfRestRooms"] = this.numberOfRestRooms;
        data["numberOfStories"] = this.numberOfStories;
        data["numberOfLoadingDocks"] = this.numberOfLoadingDocks;
        data["numberOfOverheadDoors"] = this.numberOfOverheadDoors;
        data["coveredParkingSpaces"] = this.coveredParkingSpaces;
        data["uncoveredParkingSpaces"] = this.uncoveredParkingSpaces;
        data["additionalSpaceAvailable"] = this.additionalSpaceAvailable;
        data["spaceIsDividlable"] = this.spaceIsDividlable;
        data["businessIncluded"] = this.businessIncluded;
        data["numberOfTenants"] = this.numberOfTenants;
        data["businessIncludedItems"] = this.businessIncludedItems;
        if (Array.isArray(this.commercialFeatures)) {
            data["commercialFeatures"] = [];
            for (let item of this.commercialFeatures)
                data["commercialFeatures"].push(item);
        }
        data["grossAnnaulIncome"] = this.grossAnnaulIncome;
        data["grossAnnaulExpenses"] = this.grossAnnaulExpenses;
        data["netOperationIncome"] = this.netOperationIncome;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetCommercialInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetCommercialInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetCommercialInfoDto {
    potentialUse: string | undefined;
    presentUser: string | undefined;
    location: string | undefined;
    availableDocuments: string | undefined;
    disabilityCompliant: DisabilityCompliantState;
    trafficCount: number | undefined;
    industrialArea: number | undefined;
    rentalArea: number | undefined;
    officeArea: number | undefined;
    warehouseArea: number | undefined;
    ceilingArea: number | undefined;
    roadFrontageArea: number | undefined;
    roadFrontageDescription: string | undefined;
    garageParkingType: string | undefined;
    numberOfRestRooms: number | undefined;
    numberOfStories: number | undefined;
    numberOfLoadingDocks: number | undefined;
    numberOfOverheadDoors: number | undefined;
    coveredParkingSpaces: number | undefined;
    uncoveredParkingSpaces: number | undefined;
    additionalSpaceAvailable: boolean | undefined;
    spaceIsDividlable: boolean | undefined;
    businessIncluded: BusinessIncludedState;
    numberOfTenants: number | undefined;
    businessIncludedItems: string | undefined;
    commercialFeatures: string[] | undefined;
    grossAnnaulIncome: number | undefined;
    grossAnnaulExpenses: number | undefined;
    netOperationIncome: number | undefined;
    assetId: number;
}

export class UpsertAssetDto implements IUpsertAssetDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    correlationId: string | undefined;
    tenantId: number | undefined;
    isPublished: boolean | undefined;
    savedEntity: any | undefined;
    steps: AssetFormSteps[] | undefined;

    constructor(data?: IUpsertAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.systemId = _data["systemId"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.assetStatus = _data["assetStatus"];
            this.businessType = _data["businessType"];
            this.correlationId = _data["correlationId"];
            this.tenantId = _data["tenantId"];
            this.isPublished = _data["isPublished"];
            this.savedEntity = _data["savedEntity"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["systemId"] = this.systemId;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["assetStatus"] = this.assetStatus;
        data["businessType"] = this.businessType;
        data["correlationId"] = this.correlationId;
        data["tenantId"] = this.tenantId;
        data["isPublished"] = this.isPublished;
        data["savedEntity"] = this.savedEntity;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item);
        }
        return data; 
    }

    clone(): UpsertAssetDto {
        const json = this.toJSON();
        let result = new UpsertAssetDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetDto {
    id: number;
    title: string | undefined;
    systemId: string | undefined;
    type: string | undefined;
    subType: string | undefined;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    correlationId: string | undefined;
    tenantId: number | undefined;
    isPublished: boolean | undefined;
    savedEntity: any | undefined;
    steps: AssetFormSteps[] | undefined;
}

export class UpsertAssetInteriorExteriorFeatureDto implements IUpsertAssetInteriorExteriorFeatureDto {
    interior: string[] | undefined;
    homeAutomation: string[] | undefined;
    appliances: string[] | undefined;
    handicap: string[] | undefined;
    exterior: string[] | undefined;
    nearbyAmenities: string[] | undefined;
    waterFront: string[] | undefined;
    pool: string[] | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetInteriorExteriorFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interior"])) {
                this.interior = [] as any;
                for (let item of _data["interior"])
                    this.interior.push(item);
            }
            if (Array.isArray(_data["homeAutomation"])) {
                this.homeAutomation = [] as any;
                for (let item of _data["homeAutomation"])
                    this.homeAutomation.push(item);
            }
            if (Array.isArray(_data["appliances"])) {
                this.appliances = [] as any;
                for (let item of _data["appliances"])
                    this.appliances.push(item);
            }
            if (Array.isArray(_data["handicap"])) {
                this.handicap = [] as any;
                for (let item of _data["handicap"])
                    this.handicap.push(item);
            }
            if (Array.isArray(_data["exterior"])) {
                this.exterior = [] as any;
                for (let item of _data["exterior"])
                    this.exterior.push(item);
            }
            if (Array.isArray(_data["nearbyAmenities"])) {
                this.nearbyAmenities = [] as any;
                for (let item of _data["nearbyAmenities"])
                    this.nearbyAmenities.push(item);
            }
            if (Array.isArray(_data["waterFront"])) {
                this.waterFront = [] as any;
                for (let item of _data["waterFront"])
                    this.waterFront.push(item);
            }
            if (Array.isArray(_data["pool"])) {
                this.pool = [] as any;
                for (let item of _data["pool"])
                    this.pool.push(item);
            }
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetInteriorExteriorFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetInteriorExteriorFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interior)) {
            data["interior"] = [];
            for (let item of this.interior)
                data["interior"].push(item);
        }
        if (Array.isArray(this.homeAutomation)) {
            data["homeAutomation"] = [];
            for (let item of this.homeAutomation)
                data["homeAutomation"].push(item);
        }
        if (Array.isArray(this.appliances)) {
            data["appliances"] = [];
            for (let item of this.appliances)
                data["appliances"].push(item);
        }
        if (Array.isArray(this.handicap)) {
            data["handicap"] = [];
            for (let item of this.handicap)
                data["handicap"].push(item);
        }
        if (Array.isArray(this.exterior)) {
            data["exterior"] = [];
            for (let item of this.exterior)
                data["exterior"].push(item);
        }
        if (Array.isArray(this.nearbyAmenities)) {
            data["nearbyAmenities"] = [];
            for (let item of this.nearbyAmenities)
                data["nearbyAmenities"].push(item);
        }
        if (Array.isArray(this.waterFront)) {
            data["waterFront"] = [];
            for (let item of this.waterFront)
                data["waterFront"].push(item);
        }
        if (Array.isArray(this.pool)) {
            data["pool"] = [];
            for (let item of this.pool)
                data["pool"].push(item);
        }
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetInteriorExteriorFeatureDto {
        const json = this.toJSON();
        let result = new UpsertAssetInteriorExteriorFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetInteriorExteriorFeatureDto {
    interior: string[] | undefined;
    homeAutomation: string[] | undefined;
    appliances: string[] | undefined;
    handicap: string[] | undefined;
    exterior: string[] | undefined;
    nearbyAmenities: string[] | undefined;
    waterFront: string[] | undefined;
    pool: string[] | undefined;
    assetId: number;
}

export class UpsertAssetLeaseInfoDto implements IUpsertAssetLeaseInfoDto {
    spaceIsLeased: boolean | undefined;
    rentalDuration: RentalDurationType;
    monthsRemainingOnLease: number | undefined;
    landlordRequirements: string[] | undefined;
    dateOfPossessionAvailability: moment.Moment | undefined;
    landlordResponsibality: string[] | undefined;
    monthlyLeaseAmount: number | undefined;
    tenantResponsibality: string[] | undefined;
    securityDepositInfo: string | undefined;
    smokingAllowed: SmokingAllowedType;
    buildoutAllowanceAvailble: BuildoutAllowanceAvailbleType;
    petsAllowed: PetsAllowedType;
    landlordOptions: string | undefined;
    additionalPetInfo: string | undefined;
    listingMlsNumber: string | undefined;
    additionalConditions: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetLeaseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceIsLeased = _data["spaceIsLeased"];
            this.rentalDuration = _data["rentalDuration"];
            this.monthsRemainingOnLease = _data["monthsRemainingOnLease"];
            if (Array.isArray(_data["landlordRequirements"])) {
                this.landlordRequirements = [] as any;
                for (let item of _data["landlordRequirements"])
                    this.landlordRequirements.push(item);
            }
            this.dateOfPossessionAvailability = _data["dateOfPossessionAvailability"] ? moment(_data["dateOfPossessionAvailability"].toString()) : <any>undefined;
            if (Array.isArray(_data["landlordResponsibality"])) {
                this.landlordResponsibality = [] as any;
                for (let item of _data["landlordResponsibality"])
                    this.landlordResponsibality.push(item);
            }
            this.monthlyLeaseAmount = _data["monthlyLeaseAmount"];
            if (Array.isArray(_data["tenantResponsibality"])) {
                this.tenantResponsibality = [] as any;
                for (let item of _data["tenantResponsibality"])
                    this.tenantResponsibality.push(item);
            }
            this.securityDepositInfo = _data["securityDepositInfo"];
            this.smokingAllowed = _data["smokingAllowed"];
            this.buildoutAllowanceAvailble = _data["buildoutAllowanceAvailble"];
            this.petsAllowed = _data["petsAllowed"];
            this.landlordOptions = _data["landlordOptions"];
            this.additionalPetInfo = _data["additionalPetInfo"];
            this.listingMlsNumber = _data["listingMlsNumber"];
            this.additionalConditions = _data["additionalConditions"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetLeaseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetLeaseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceIsLeased"] = this.spaceIsLeased;
        data["rentalDuration"] = this.rentalDuration;
        data["monthsRemainingOnLease"] = this.monthsRemainingOnLease;
        if (Array.isArray(this.landlordRequirements)) {
            data["landlordRequirements"] = [];
            for (let item of this.landlordRequirements)
                data["landlordRequirements"].push(item);
        }
        data["dateOfPossessionAvailability"] = this.dateOfPossessionAvailability ? this.dateOfPossessionAvailability.toISOString() : <any>undefined;
        if (Array.isArray(this.landlordResponsibality)) {
            data["landlordResponsibality"] = [];
            for (let item of this.landlordResponsibality)
                data["landlordResponsibality"].push(item);
        }
        data["monthlyLeaseAmount"] = this.monthlyLeaseAmount;
        if (Array.isArray(this.tenantResponsibality)) {
            data["tenantResponsibality"] = [];
            for (let item of this.tenantResponsibality)
                data["tenantResponsibality"].push(item);
        }
        data["securityDepositInfo"] = this.securityDepositInfo;
        data["smokingAllowed"] = this.smokingAllowed;
        data["buildoutAllowanceAvailble"] = this.buildoutAllowanceAvailble;
        data["petsAllowed"] = this.petsAllowed;
        data["landlordOptions"] = this.landlordOptions;
        data["additionalPetInfo"] = this.additionalPetInfo;
        data["listingMlsNumber"] = this.listingMlsNumber;
        data["additionalConditions"] = this.additionalConditions;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetLeaseInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetLeaseInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetLeaseInfoDto {
    spaceIsLeased: boolean | undefined;
    rentalDuration: RentalDurationType;
    monthsRemainingOnLease: number | undefined;
    landlordRequirements: string[] | undefined;
    dateOfPossessionAvailability: moment.Moment | undefined;
    landlordResponsibality: string[] | undefined;
    monthlyLeaseAmount: number | undefined;
    tenantResponsibality: string[] | undefined;
    securityDepositInfo: string | undefined;
    smokingAllowed: SmokingAllowedType;
    buildoutAllowanceAvailble: BuildoutAllowanceAvailbleType;
    petsAllowed: PetsAllowedType;
    landlordOptions: string | undefined;
    additionalPetInfo: string | undefined;
    listingMlsNumber: string | undefined;
    additionalConditions: string | undefined;
    assetId: number;
}

export class UpsertAssetOpenHouseSummaryDto implements IUpsertAssetOpenHouseSummaryDto {
    isScheduleTour: boolean | undefined;
    assetId: number;
    assetOpenHouseInfos: AssetOpenHouseInfoDto[] | undefined;

    constructor(data?: IUpsertAssetOpenHouseSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isScheduleTour = _data["isScheduleTour"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["assetOpenHouseInfos"])) {
                this.assetOpenHouseInfos = [] as any;
                for (let item of _data["assetOpenHouseInfos"])
                    this.assetOpenHouseInfos.push(AssetOpenHouseInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertAssetOpenHouseSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetOpenHouseSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isScheduleTour"] = this.isScheduleTour;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.assetOpenHouseInfos)) {
            data["assetOpenHouseInfos"] = [];
            for (let item of this.assetOpenHouseInfos)
                data["assetOpenHouseInfos"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpsertAssetOpenHouseSummaryDto {
        const json = this.toJSON();
        let result = new UpsertAssetOpenHouseSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetOpenHouseSummaryDto {
    isScheduleTour: boolean | undefined;
    assetId: number;
    assetOpenHouseInfos: AssetOpenHouseInfoDto[] | undefined;
}

export class UpsertAssetPhotoDto implements IUpsertAssetPhotoDto {
    photographsTakenBy: PhotographsTakenByType;
    photographerMlsId: string | undefined;
    photographerName: string | undefined;
    studioName: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.photographsTakenBy = _data["photographsTakenBy"];
            this.photographerMlsId = _data["photographerMlsId"];
            this.photographerName = _data["photographerName"];
            this.studioName = _data["studioName"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetPhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetPhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photographsTakenBy"] = this.photographsTakenBy;
        data["photographerMlsId"] = this.photographerMlsId;
        data["photographerName"] = this.photographerName;
        data["studioName"] = this.studioName;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetPhotoDto {
        const json = this.toJSON();
        let result = new UpsertAssetPhotoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetPhotoDto {
    photographsTakenBy: PhotographsTakenByType;
    photographerMlsId: string | undefined;
    photographerName: string | undefined;
    studioName: string | undefined;
    assetId: number;
}

export class UpsertAssetRemarksDto implements IUpsertAssetRemarksDto {
    publicRemarks: string | undefined;
    publicRemarksAddendum: string | undefined;
    confidentialAgentRemarks: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetRemarksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicRemarks = _data["publicRemarks"];
            this.publicRemarksAddendum = _data["publicRemarksAddendum"];
            this.confidentialAgentRemarks = _data["confidentialAgentRemarks"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetRemarksDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetRemarksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicRemarks"] = this.publicRemarks;
        data["publicRemarksAddendum"] = this.publicRemarksAddendum;
        data["confidentialAgentRemarks"] = this.confidentialAgentRemarks;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetRemarksDto {
        const json = this.toJSON();
        let result = new UpsertAssetRemarksDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetRemarksDto {
    publicRemarks: string | undefined;
    publicRemarksAddendum: string | undefined;
    confidentialAgentRemarks: string | undefined;
    assetId: number;
}

export class UpsertAssetRoomInfoDto implements IUpsertAssetRoomInfoDto {
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBaths: number | undefined;
    numberOfHalfBaths: number | undefined;
    laundaryRoomInfo: string | undefined;
    laundaryLcoation: string | undefined;
    inLawApartmentAccess: string | undefined;
    hasInLawApartment: boolean | undefined;
    assetId: number;
    rooms: AssetRoomDto[] | undefined;

    constructor(data?: IUpsertAssetRoomInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfRooms = _data["numberOfRooms"];
            this.numberOfBedRooms = _data["numberOfBedRooms"];
            this.numberOfFullBaths = _data["numberOfFullBaths"];
            this.numberOfHalfBaths = _data["numberOfHalfBaths"];
            this.laundaryRoomInfo = _data["laundaryRoomInfo"];
            this.laundaryLcoation = _data["laundaryLcoation"];
            this.inLawApartmentAccess = _data["inLawApartmentAccess"];
            this.hasInLawApartment = _data["hasInLawApartment"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(AssetRoomDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertAssetRoomInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetRoomInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfRooms"] = this.numberOfRooms;
        data["numberOfBedRooms"] = this.numberOfBedRooms;
        data["numberOfFullBaths"] = this.numberOfFullBaths;
        data["numberOfHalfBaths"] = this.numberOfHalfBaths;
        data["laundaryRoomInfo"] = this.laundaryRoomInfo;
        data["laundaryLcoation"] = this.laundaryLcoation;
        data["inLawApartmentAccess"] = this.inLawApartmentAccess;
        data["hasInLawApartment"] = this.hasInLawApartment;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpsertAssetRoomInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetRoomInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetRoomInfoDto {
    numberOfRooms: number | undefined;
    numberOfBedRooms: number | undefined;
    numberOfFullBaths: number | undefined;
    numberOfHalfBaths: number | undefined;
    laundaryRoomInfo: string | undefined;
    laundaryLcoation: string | undefined;
    inLawApartmentAccess: string | undefined;
    hasInLawApartment: boolean | undefined;
    assetId: number;
    rooms: AssetRoomDto[] | undefined;
}

export class UpsertAssetSchoolInfoDto implements IUpsertAssetSchoolInfoDto {
    elementarySchool: string | undefined;
    middleSchool: string | undefined;
    intermediateSchool: string | undefined;
    highSchool: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetSchoolInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementarySchool = _data["elementarySchool"];
            this.middleSchool = _data["middleSchool"];
            this.intermediateSchool = _data["intermediateSchool"];
            this.highSchool = _data["highSchool"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetSchoolInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetSchoolInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementarySchool"] = this.elementarySchool;
        data["middleSchool"] = this.middleSchool;
        data["intermediateSchool"] = this.intermediateSchool;
        data["highSchool"] = this.highSchool;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetSchoolInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetSchoolInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetSchoolInfoDto {
    elementarySchool: string | undefined;
    middleSchool: string | undefined;
    intermediateSchool: string | undefined;
    highSchool: string | undefined;
    assetId: number;
}

export class UpsertAssetShowingAvailabilityScheduleDto implements IUpsertAssetShowingAvailabilityScheduleDto {
    id: number;
    mode: AssetShowingAvailabilityModeType;
    dayOfWeek: DayOfWeek;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: moment.Moment | undefined;
    timeTo: moment.Moment | undefined;
    autoConfirm: boolean | undefined;
    assetId: number;
    assetUnitId: number | undefined;

    constructor(data?: IUpsertAssetShowingAvailabilityScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mode = _data["mode"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = _data["timeFrom"] ? moment(_data["timeFrom"].toString()) : <any>undefined;
            this.timeTo = _data["timeTo"] ? moment(_data["timeTo"].toString()) : <any>undefined;
            this.autoConfirm = _data["autoConfirm"];
            this.assetId = _data["assetId"];
            this.assetUnitId = _data["assetUnitId"];
        }
    }

    static fromJS(data: any): UpsertAssetShowingAvailabilityScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetShowingAvailabilityScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mode"] = this.mode;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toISOString() : <any>undefined;
        data["timeTo"] = this.timeTo ? this.timeTo.toISOString() : <any>undefined;
        data["autoConfirm"] = this.autoConfirm;
        data["assetId"] = this.assetId;
        data["assetUnitId"] = this.assetUnitId;
        return data; 
    }

    clone(): UpsertAssetShowingAvailabilityScheduleDto {
        const json = this.toJSON();
        let result = new UpsertAssetShowingAvailabilityScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetShowingAvailabilityScheduleDto {
    id: number;
    mode: AssetShowingAvailabilityModeType;
    dayOfWeek: DayOfWeek;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: moment.Moment | undefined;
    timeTo: moment.Moment | undefined;
    autoConfirm: boolean | undefined;
    assetId: number;
    assetUnitId: number | undefined;
}

export class UpsertAssetShowingContactDto implements IUpsertAssetShowingContactDto {
    showingType: ShowingType;
    assetId: number;
    assetShowingContacts: AssetShowingContactDto[] | undefined;

    constructor(data?: IUpsertAssetShowingContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showingType = _data["showingType"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["assetShowingContacts"])) {
                this.assetShowingContacts = [] as any;
                for (let item of _data["assetShowingContacts"])
                    this.assetShowingContacts.push(AssetShowingContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertAssetShowingContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetShowingContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showingType"] = this.showingType;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.assetShowingContacts)) {
            data["assetShowingContacts"] = [];
            for (let item of this.assetShowingContacts)
                data["assetShowingContacts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpsertAssetShowingContactDto {
        const json = this.toJSON();
        let result = new UpsertAssetShowingContactDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetShowingContactDto {
    showingType: ShowingType;
    assetId: number;
    assetShowingContacts: AssetShowingContactDto[] | undefined;
}

export class UpsertAssetShowingSettingDto implements IUpsertAssetShowingSettingDto {
    assetId: number;
    assetShowingSetting: AssetShowingSettingDto;
    assetShowingAccessInfo: AssetShowingAccessInfoDto;
    assetShowingAgentInstruction: AssetShowingAgentInstructionDto;
    assetShowingFeedback: AssetShowingFeedbackDto;

    constructor(data?: IUpsertAssetShowingSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetShowingSetting = _data["assetShowingSetting"] ? AssetShowingSettingDto.fromJS(_data["assetShowingSetting"]) : <any>undefined;
            this.assetShowingAccessInfo = _data["assetShowingAccessInfo"] ? AssetShowingAccessInfoDto.fromJS(_data["assetShowingAccessInfo"]) : <any>undefined;
            this.assetShowingAgentInstruction = _data["assetShowingAgentInstruction"] ? AssetShowingAgentInstructionDto.fromJS(_data["assetShowingAgentInstruction"]) : <any>undefined;
            this.assetShowingFeedback = _data["assetShowingFeedback"] ? AssetShowingFeedbackDto.fromJS(_data["assetShowingFeedback"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertAssetShowingSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetShowingSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetShowingSetting"] = this.assetShowingSetting ? this.assetShowingSetting.toJSON() : <any>undefined;
        data["assetShowingAccessInfo"] = this.assetShowingAccessInfo ? this.assetShowingAccessInfo.toJSON() : <any>undefined;
        data["assetShowingAgentInstruction"] = this.assetShowingAgentInstruction ? this.assetShowingAgentInstruction.toJSON() : <any>undefined;
        data["assetShowingFeedback"] = this.assetShowingFeedback ? this.assetShowingFeedback.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpsertAssetShowingSettingDto {
        const json = this.toJSON();
        let result = new UpsertAssetShowingSettingDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetShowingSettingDto {
    assetId: number;
    assetShowingSetting: AssetShowingSettingDto;
    assetShowingAccessInfo: AssetShowingAccessInfoDto;
    assetShowingAgentInstruction: AssetShowingAgentInstructionDto;
    assetShowingFeedback: AssetShowingFeedbackDto;
}

export class UpsertAssetSoldInfoDto implements IUpsertAssetSoldInfoDto {
    buyerName: string[] | undefined;
    lenderName: string | undefined;
    financeType: FinanceType;
    sellerCredits: number | undefined;
    price: number | undefined;
    downPayment: number | undefined;
    relocatingFrom: AssetSoldIntoAddressDto;
    relocatingTo: AssetSoldIntoAddressDto;
    assetId: number;

    constructor(data?: IUpsertAssetSoldInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buyerName"])) {
                this.buyerName = [] as any;
                for (let item of _data["buyerName"])
                    this.buyerName.push(item);
            }
            this.lenderName = _data["lenderName"];
            this.financeType = _data["financeType"];
            this.sellerCredits = _data["sellerCredits"];
            this.price = _data["price"];
            this.downPayment = _data["downPayment"];
            this.relocatingFrom = _data["relocatingFrom"] ? AssetSoldIntoAddressDto.fromJS(_data["relocatingFrom"]) : <any>undefined;
            this.relocatingTo = _data["relocatingTo"] ? AssetSoldIntoAddressDto.fromJS(_data["relocatingTo"]) : <any>undefined;
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetSoldInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetSoldInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buyerName)) {
            data["buyerName"] = [];
            for (let item of this.buyerName)
                data["buyerName"].push(item);
        }
        data["lenderName"] = this.lenderName;
        data["financeType"] = this.financeType;
        data["sellerCredits"] = this.sellerCredits;
        data["price"] = this.price;
        data["downPayment"] = this.downPayment;
        data["relocatingFrom"] = this.relocatingFrom ? this.relocatingFrom.toJSON() : <any>undefined;
        data["relocatingTo"] = this.relocatingTo ? this.relocatingTo.toJSON() : <any>undefined;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetSoldInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetSoldInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetSoldInfoDto {
    buyerName: string[] | undefined;
    lenderName: string | undefined;
    financeType: FinanceType;
    sellerCredits: number | undefined;
    price: number | undefined;
    downPayment: number | undefined;
    relocatingFrom: AssetSoldIntoAddressDto;
    relocatingTo: AssetSoldIntoAddressDto;
    assetId: number;
}

export class UpsertAssetUnitInfoDto implements IUpsertAssetUnitInfoDto {
    numberOfUnits: number | undefined;
    laundaryLocation: string | undefined;
    assetId: number;
    units: AssetUnitDto[] | undefined;

    constructor(data?: IUpsertAssetUnitInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfUnits = _data["numberOfUnits"];
            this.laundaryLocation = _data["laundaryLocation"];
            this.assetId = _data["assetId"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units.push(AssetUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertAssetUnitInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetUnitInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfUnits"] = this.numberOfUnits;
        data["laundaryLocation"] = this.laundaryLocation;
        data["assetId"] = this.assetId;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpsertAssetUnitInfoDto {
        const json = this.toJSON();
        let result = new UpsertAssetUnitInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetUnitInfoDto {
    numberOfUnits: number | undefined;
    laundaryLocation: string | undefined;
    assetId: number;
    units: AssetUnitDto[] | undefined;
}

export class UpsertAssetUtilityDto implements IUpsertAssetUtilityDto {
    coolingType: string | undefined;
    heatingType: string | undefined;
    heatingFuel: string | undefined;
    hotWaterSystem: string | undefined;
    waterSource: string | undefined;
    estimatedAnnualWaterCost: number | undefined;
    sewerSource: string | undefined;
    estimatedAnnualSewerCost: number | undefined;
    hasAirRadonMitigationSystem: string | undefined;
    hasWaterRadonMitigationSystem: string | undefined;
    energyCertificate: string | undefined;
    solarSystem: string | undefined;
    energyFeatures: string[] | undefined;
    solarContractDetails: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetUtilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coolingType = _data["coolingType"];
            this.heatingType = _data["heatingType"];
            this.heatingFuel = _data["heatingFuel"];
            this.hotWaterSystem = _data["hotWaterSystem"];
            this.waterSource = _data["waterSource"];
            this.estimatedAnnualWaterCost = _data["estimatedAnnualWaterCost"];
            this.sewerSource = _data["sewerSource"];
            this.estimatedAnnualSewerCost = _data["estimatedAnnualSewerCost"];
            this.hasAirRadonMitigationSystem = _data["hasAirRadonMitigationSystem"];
            this.hasWaterRadonMitigationSystem = _data["hasWaterRadonMitigationSystem"];
            this.energyCertificate = _data["energyCertificate"];
            this.solarSystem = _data["solarSystem"];
            if (Array.isArray(_data["energyFeatures"])) {
                this.energyFeatures = [] as any;
                for (let item of _data["energyFeatures"])
                    this.energyFeatures.push(item);
            }
            this.solarContractDetails = _data["solarContractDetails"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetUtilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetUtilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coolingType"] = this.coolingType;
        data["heatingType"] = this.heatingType;
        data["heatingFuel"] = this.heatingFuel;
        data["hotWaterSystem"] = this.hotWaterSystem;
        data["waterSource"] = this.waterSource;
        data["estimatedAnnualWaterCost"] = this.estimatedAnnualWaterCost;
        data["sewerSource"] = this.sewerSource;
        data["estimatedAnnualSewerCost"] = this.estimatedAnnualSewerCost;
        data["hasAirRadonMitigationSystem"] = this.hasAirRadonMitigationSystem;
        data["hasWaterRadonMitigationSystem"] = this.hasWaterRadonMitigationSystem;
        data["energyCertificate"] = this.energyCertificate;
        data["solarSystem"] = this.solarSystem;
        if (Array.isArray(this.energyFeatures)) {
            data["energyFeatures"] = [];
            for (let item of this.energyFeatures)
                data["energyFeatures"].push(item);
        }
        data["solarContractDetails"] = this.solarContractDetails;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetUtilityDto {
        const json = this.toJSON();
        let result = new UpsertAssetUtilityDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetUtilityDto {
    coolingType: string | undefined;
    heatingType: string | undefined;
    heatingFuel: string | undefined;
    hotWaterSystem: string | undefined;
    waterSource: string | undefined;
    estimatedAnnualWaterCost: number | undefined;
    sewerSource: string | undefined;
    estimatedAnnualSewerCost: number | undefined;
    hasAirRadonMitigationSystem: string | undefined;
    hasWaterRadonMitigationSystem: string | undefined;
    energyCertificate: string | undefined;
    solarSystem: string | undefined;
    energyFeatures: string[] | undefined;
    solarContractDetails: string | undefined;
    assetId: number;
}

export class UpsertAssetVirtualTourDto implements IUpsertAssetVirtualTourDto {
    isFreeVirtualTour: boolean | undefined;
    brandedVirtualTourURL: string | undefined;
    unbrandedVirtualTourURL: string | undefined;
    additionalVirtualTourURL: string | undefined;
    videoURL: string | undefined;
    assetId: number;

    constructor(data?: IUpsertAssetVirtualTourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFreeVirtualTour = _data["isFreeVirtualTour"];
            this.brandedVirtualTourURL = _data["brandedVirtualTourURL"];
            this.unbrandedVirtualTourURL = _data["unbrandedVirtualTourURL"];
            this.additionalVirtualTourURL = _data["additionalVirtualTourURL"];
            this.videoURL = _data["videoURL"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertAssetVirtualTourDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssetVirtualTourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFreeVirtualTour"] = this.isFreeVirtualTour;
        data["brandedVirtualTourURL"] = this.brandedVirtualTourURL;
        data["unbrandedVirtualTourURL"] = this.unbrandedVirtualTourURL;
        data["additionalVirtualTourURL"] = this.additionalVirtualTourURL;
        data["videoURL"] = this.videoURL;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertAssetVirtualTourDto {
        const json = this.toJSON();
        let result = new UpsertAssetVirtualTourDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertAssetVirtualTourDto {
    isFreeVirtualTour: boolean | undefined;
    brandedVirtualTourURL: string | undefined;
    unbrandedVirtualTourURL: string | undefined;
    additionalVirtualTourURL: string | undefined;
    videoURL: string | undefined;
    assetId: number;
}

export class UpsertCompensationInfoDto implements IUpsertCompensationInfoDto {
    commissionType: CommissionType;
    note: string | undefined;
    compensation: number | undefined;
    assetId: number;

    constructor(data?: IUpsertCompensationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionType = _data["commissionType"];
            this.note = _data["note"];
            this.compensation = _data["compensation"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertCompensationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCompensationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commissionType"] = this.commissionType;
        data["note"] = this.note;
        data["compensation"] = this.compensation;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertCompensationInfoDto {
        const json = this.toJSON();
        let result = new UpsertCompensationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertCompensationInfoDto {
    commissionType: CommissionType;
    note: string | undefined;
    compensation: number | undefined;
    assetId: number;
}

export class UpsertContractInfoDto implements IUpsertContractInfoDto {
    price: number | undefined;
    priceCycle: PriceCycle;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    contractType: ContractType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    signedDate: moment.Moment | undefined;
    expectedCloseDate: moment.Moment | undefined;
    assetId: number;

    constructor(data?: IUpsertContractInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.priceCycle = _data["priceCycle"];
            this.assetStatus = _data["assetStatus"];
            this.businessType = _data["businessType"];
            this.contractType = _data["contractType"];
            this.activationStartDate = _data["activationStartDate"] ? moment(_data["activationStartDate"].toString()) : <any>undefined;
            this.activationEndDate = _data["activationEndDate"] ? moment(_data["activationEndDate"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.signedDate = _data["signedDate"] ? moment(_data["signedDate"].toString()) : <any>undefined;
            this.expectedCloseDate = _data["expectedCloseDate"] ? moment(_data["expectedCloseDate"].toString()) : <any>undefined;
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertContractInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertContractInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["priceCycle"] = this.priceCycle;
        data["assetStatus"] = this.assetStatus;
        data["businessType"] = this.businessType;
        data["contractType"] = this.contractType;
        data["activationStartDate"] = this.activationStartDate ? this.activationStartDate.toISOString() : <any>undefined;
        data["activationEndDate"] = this.activationEndDate ? this.activationEndDate.toISOString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["signedDate"] = this.signedDate ? this.signedDate.toISOString() : <any>undefined;
        data["expectedCloseDate"] = this.expectedCloseDate ? this.expectedCloseDate.toISOString() : <any>undefined;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertContractInfoDto {
        const json = this.toJSON();
        let result = new UpsertContractInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertContractInfoDto {
    price: number | undefined;
    priceCycle: PriceCycle;
    assetStatus: AssetStatus;
    businessType: BusinessType;
    contractType: ContractType;
    activationStartDate: moment.Moment | undefined;
    activationEndDate: moment.Moment | undefined;
    publishDate: moment.Moment | undefined;
    signedDate: moment.Moment | undefined;
    expectedCloseDate: moment.Moment | undefined;
    assetId: number;
}

export class UpsertLandRecordInfoDto implements IUpsertLandRecordInfoDto {
    assetId: number;
    assetArea: AssetAreaDto;
    assetConfrontation: AssetConfrontationDto;
    assetDescription: AssetDescriptionDto;
    assetEvaluation: AssetEvaluationDto;
    assetIdentification: AssetIdentificationDto;
    assetTitleHolder: AssetTitleHolderDto;

    constructor(data?: IUpsertLandRecordInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetArea = _data["assetArea"] ? AssetAreaDto.fromJS(_data["assetArea"]) : <any>undefined;
            this.assetConfrontation = _data["assetConfrontation"] ? AssetConfrontationDto.fromJS(_data["assetConfrontation"]) : <any>undefined;
            this.assetDescription = _data["assetDescription"] ? AssetDescriptionDto.fromJS(_data["assetDescription"]) : <any>undefined;
            this.assetEvaluation = _data["assetEvaluation"] ? AssetEvaluationDto.fromJS(_data["assetEvaluation"]) : <any>undefined;
            this.assetIdentification = _data["assetIdentification"] ? AssetIdentificationDto.fromJS(_data["assetIdentification"]) : <any>undefined;
            this.assetTitleHolder = _data["assetTitleHolder"] ? AssetTitleHolderDto.fromJS(_data["assetTitleHolder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertLandRecordInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertLandRecordInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetArea"] = this.assetArea ? this.assetArea.toJSON() : <any>undefined;
        data["assetConfrontation"] = this.assetConfrontation ? this.assetConfrontation.toJSON() : <any>undefined;
        data["assetDescription"] = this.assetDescription ? this.assetDescription.toJSON() : <any>undefined;
        data["assetEvaluation"] = this.assetEvaluation ? this.assetEvaluation.toJSON() : <any>undefined;
        data["assetIdentification"] = this.assetIdentification ? this.assetIdentification.toJSON() : <any>undefined;
        data["assetTitleHolder"] = this.assetTitleHolder ? this.assetTitleHolder.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpsertLandRecordInfoDto {
        const json = this.toJSON();
        let result = new UpsertLandRecordInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertLandRecordInfoDto {
    assetId: number;
    assetArea: AssetAreaDto;
    assetConfrontation: AssetConfrontationDto;
    assetDescription: AssetDescriptionDto;
    assetEvaluation: AssetEvaluationDto;
    assetIdentification: AssetIdentificationDto;
    assetTitleHolder: AssetTitleHolderDto;
}

export class UpsertStructuralInfoDto implements IUpsertStructuralInfoDto {
    levelsInBuilding: number | undefined;
    unitLevel: number | undefined;
    unitsInBuilding: number | undefined;
    unitsInComplex: number | undefined;
    yearBuilt: number | undefined;
    numberOfCarsInGarages: number | undefined;
    numberOfCarsInUncoveredParking: number | undefined;
    type: string | undefined;
    subType: string | undefined;
    interior: string | undefined;
    condition: string | undefined;
    construction: string | undefined;
    roof: string | undefined;
    foundation: string | undefined;
    storage: string | undefined;
    exterior: string | undefined;
    driveway: string | undefined;
    attic: string | undefined;
    basement: string | undefined;
    garages: string | undefined;
    assetId: number;

    constructor(data?: IUpsertStructuralInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelsInBuilding = _data["levelsInBuilding"];
            this.unitLevel = _data["unitLevel"];
            this.unitsInBuilding = _data["unitsInBuilding"];
            this.unitsInComplex = _data["unitsInComplex"];
            this.yearBuilt = _data["yearBuilt"];
            this.numberOfCarsInGarages = _data["numberOfCarsInGarages"];
            this.numberOfCarsInUncoveredParking = _data["numberOfCarsInUncoveredParking"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.interior = _data["interior"];
            this.condition = _data["condition"];
            this.construction = _data["construction"];
            this.roof = _data["roof"];
            this.foundation = _data["foundation"];
            this.storage = _data["storage"];
            this.exterior = _data["exterior"];
            this.driveway = _data["driveway"];
            this.attic = _data["attic"];
            this.basement = _data["basement"];
            this.garages = _data["garages"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpsertStructuralInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertStructuralInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelsInBuilding"] = this.levelsInBuilding;
        data["unitLevel"] = this.unitLevel;
        data["unitsInBuilding"] = this.unitsInBuilding;
        data["unitsInComplex"] = this.unitsInComplex;
        data["yearBuilt"] = this.yearBuilt;
        data["numberOfCarsInGarages"] = this.numberOfCarsInGarages;
        data["numberOfCarsInUncoveredParking"] = this.numberOfCarsInUncoveredParking;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["interior"] = this.interior;
        data["condition"] = this.condition;
        data["construction"] = this.construction;
        data["roof"] = this.roof;
        data["foundation"] = this.foundation;
        data["storage"] = this.storage;
        data["exterior"] = this.exterior;
        data["driveway"] = this.driveway;
        data["attic"] = this.attic;
        data["basement"] = this.basement;
        data["garages"] = this.garages;
        data["assetId"] = this.assetId;
        return data; 
    }

    clone(): UpsertStructuralInfoDto {
        const json = this.toJSON();
        let result = new UpsertStructuralInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertStructuralInfoDto {
    levelsInBuilding: number | undefined;
    unitLevel: number | undefined;
    unitsInBuilding: number | undefined;
    unitsInComplex: number | undefined;
    yearBuilt: number | undefined;
    numberOfCarsInGarages: number | undefined;
    numberOfCarsInUncoveredParking: number | undefined;
    type: string | undefined;
    subType: string | undefined;
    interior: string | undefined;
    condition: string | undefined;
    construction: string | undefined;
    roof: string | undefined;
    foundation: string | undefined;
    storage: string | undefined;
    exterior: string | undefined;
    driveway: string | undefined;
    attic: string | undefined;
    basement: string | undefined;
    garages: string | undefined;
    assetId: number;
}

export class UserContactAddressDto implements IUserContactAddressDto {
    id: number;
    region: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;

    constructor(data?: IUserContactAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.region = _data["region"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.parish = _data["parish"];
            this.zone = _data["zone"];
            this.streetType = _data["streetType"];
            this.streetName = _data["streetName"];
            this.doorNumber = _data["doorNumber"];
            this.floorNumber = _data["floorNumber"];
            this.doorIdentifier = _data["doorIdentifier"];
            this.unitNumber = _data["unitNumber"];
            this.floorLevel = _data["floorLevel"];
            this.zipcode = _data["zipcode"];
        }
    }

    static fromJS(data: any): UserContactAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["region"] = this.region;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["parish"] = this.parish;
        data["zone"] = this.zone;
        data["streetType"] = this.streetType;
        data["streetName"] = this.streetName;
        data["doorNumber"] = this.doorNumber;
        data["floorNumber"] = this.floorNumber;
        data["doorIdentifier"] = this.doorIdentifier;
        data["unitNumber"] = this.unitNumber;
        data["floorLevel"] = this.floorLevel;
        data["zipcode"] = this.zipcode;
        return data; 
    }

    clone(): UserContactAddressDto {
        const json = this.toJSON();
        let result = new UserContactAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserContactAddressDto {
    id: number;
    region: string | undefined;
    district: string | undefined;
    municipality: string | undefined;
    parish: string | undefined;
    zone: string | undefined;
    streetType: string | undefined;
    streetName: string | undefined;
    doorNumber: string | undefined;
    floorNumber: string | undefined;
    doorIdentifier: string | undefined;
    unitNumber: string | undefined;
    floorLevel: string | undefined;
    zipcode: string | undefined;
}

export class UserContactDto implements IUserContactDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    spouseName: string | undefined;
    spouseCellNumber: string | undefined;
    note: string | undefined;
    isEmailNotificationRequired: boolean | undefined;
    isCallNotificationRequired: boolean | undefined;
    isTextNotificationRequired: boolean | undefined;
    isWhatsappNotificationRequired: boolean | undefined;
    contactType: ContactType;
    contactStatus: ContactStatus;
    leadSource: LeadSource;
    userId: number;
    tenantId: number | undefined;
    userContactAddresses: UserContactAddressDto[] | undefined;

    constructor(data?: IUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.spouseName = _data["spouseName"];
            this.spouseCellNumber = _data["spouseCellNumber"];
            this.note = _data["note"];
            this.isEmailNotificationRequired = _data["isEmailNotificationRequired"];
            this.isCallNotificationRequired = _data["isCallNotificationRequired"];
            this.isTextNotificationRequired = _data["isTextNotificationRequired"];
            this.isWhatsappNotificationRequired = _data["isWhatsappNotificationRequired"];
            this.contactType = _data["contactType"];
            this.contactStatus = _data["contactStatus"];
            this.leadSource = _data["leadSource"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["userContactAddresses"])) {
                this.userContactAddresses = [] as any;
                for (let item of _data["userContactAddresses"])
                    this.userContactAddresses.push(UserContactAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["spouseName"] = this.spouseName;
        data["spouseCellNumber"] = this.spouseCellNumber;
        data["note"] = this.note;
        data["isEmailNotificationRequired"] = this.isEmailNotificationRequired;
        data["isCallNotificationRequired"] = this.isCallNotificationRequired;
        data["isTextNotificationRequired"] = this.isTextNotificationRequired;
        data["isWhatsappNotificationRequired"] = this.isWhatsappNotificationRequired;
        data["contactType"] = this.contactType;
        data["contactStatus"] = this.contactStatus;
        data["leadSource"] = this.leadSource;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.userContactAddresses)) {
            data["userContactAddresses"] = [];
            for (let item of this.userContactAddresses)
                data["userContactAddresses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserContactDto {
        const json = this.toJSON();
        let result = new UserContactDto();
        result.init(json);
        return result;
    }
}

export interface IUserContactDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    spouseName: string | undefined;
    spouseCellNumber: string | undefined;
    note: string | undefined;
    isEmailNotificationRequired: boolean | undefined;
    isCallNotificationRequired: boolean | undefined;
    isTextNotificationRequired: boolean | undefined;
    isWhatsappNotificationRequired: boolean | undefined;
    contactType: ContactType;
    contactStatus: ContactStatus;
    leadSource: LeadSource;
    userId: number;
    tenantId: number | undefined;
    userContactAddresses: UserContactAddressDto[] | undefined;
}

export class UserContactDtoPagedResultDto implements IUserContactDtoPagedResultDto {
    items: UserContactDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserContactDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserContactDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserContactDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): UserContactDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserContactDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserContactDtoPagedResultDto {
    items: UserContactDto[] | undefined;
    totalCount: number;
}

export class UserContactRequestDto implements IUserContactRequestDto {

    constructor(data?: IUserContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UserContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): UserContactRequestDto {
        const json = this.toJSON();
        let result = new UserContactRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUserContactRequestDto {
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class UtilitiesFeatureLookupDto implements IUtilitiesFeatureLookupDto {
    id: number;
    name: string | undefined;
    type: UtilityLookupType;

    constructor(data?: IUtilitiesFeatureLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UtilitiesFeatureLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtilitiesFeatureLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }

    clone(): UtilitiesFeatureLookupDto {
        const json = this.toJSON();
        let result = new UtilitiesFeatureLookupDto();
        result.init(json);
        return result;
    }
}

export interface IUtilitiesFeatureLookupDto {
    id: number;
    name: string | undefined;
    type: UtilityLookupType;
}

export enum UtilityLookupType {
    None = <any>"None",
    Cooling = <any>"Cooling",
    Heating = <any>"Heating",
    Water = <any>"Water",
    HotWater = <any>"HotWater",
    HeatingFuel = <any>"HeatingFuel",
    WaterSource = <any>"WaterSource",
    SewerSource = <any>"SewerSource",
    SolarSystem = <any>"SolarSystem",
    EnergyFeature = <any>"EnergyFeature",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}